import { createAnchor, getPositionFromIndex } from "../components/AutoSuggestion";
import { findTabularEnvs, parseColumnSpec, findCommandorNot, capitalizeInsideBraces, isCommented, getallData, getInsideTextofBraces, createGranularAnchors, isLineCommented, LineCommented, numberToWords, getMathRanges, parseTabularBody, makeAnchorEmitter, isInsideMath, buildStyleContext, extractBracedContent } from "../components/ReusableFunctions";
import { getOverlappingAnchors, isAlreadyAnchored, isRejectedByLivePosition } from "../components/AutoSuggestion";
import { commonStyles, eplStyles } from "./commonstyles";
import { HeadingSentenceCase, changeToKeywordCase, changeToLowerCase, changeToSentenceCase, changeToTitleCase, changeTocase } from "../components/TextCases";
import nlp from 'compromise';
import Typo from "typo-js";
import nspell from "nspell";
import { KNOWN_COUNTRIES } from "../Utils/countryUtils";
import { typography } from "@chakra-ui/react";
let spell = null;
let _spellWorker = null;
let _spellWorkerBusy = false;


function classifyRefTarget(texFile, refAbsIndex, key) {
    const windowStart = Math.max(0, refAbsIndex - 25);
    const before = texFile.slice(windowStart, refAbsIndex).replace(/[\s~]+$/, ' ');

    if (/\b(?:fig(?:ure)?s?\.?)\s*$/i.test(before)) return 'figure';
    if (/\b(?:tab(?:le)?s?\.?)\s*$/i.test(before)) return 'table';

    if (/^(?:fig|figure)[:_-]/i.test(key)) return 'figure';
    if (/^(?:tab|table)[:_-]/i.test(key)) return 'table';

    return null;
}


function getSpellWorker() {
    if (!_spellWorker) {
        _spellWorker = new Worker(
            new URL('./SpellWorker.js', import.meta.url),
            { type: 'module' }
        );
    }
    return _spellWorker;
}

function runSpellWorker(texFile, options = {}) {
    const { onBatch, batchSize = 50, isCancelled } = options;

    return new Promise((resolve, reject) => {
        if (_spellWorkerBusy) {
            _spellWorker.terminate();
            _spellWorker = null;
            _spellWorkerBusy = false;
        }

        const worker = getSpellWorker();
        _spellWorkerBusy = true;

        const cleanup = () => {
            worker.removeEventListener('message', onMsg);
            worker.removeEventListener('error', onErr);
            _spellWorkerBusy = false;
        };

        const onMsg = (e) => {
            if (e.data.type === 'batch') {
                if (onBatch) onBatch(e.data.typos);
            } else if (e.data.type === 'done') {
                cleanup();
                e.data.error ? reject(new Error(e.data.error)) : resolve([]);
            }
        };

        const onErr = (err) => { cleanup(); reject(err); };

        worker.addEventListener('message', onMsg);
        worker.addEventListener('error', onErr);


        const extraWords = ["overleaf", "inmath", "arxiv", "bibtex", "pdftex", "xelatex", "lualatex", "pdflatex", "texlive", "miktex", "texmaker", "texstudio", "sharelatex", "latexmk", "tug", "ctan", "texcount", "latexdiff", "beamer", "tikz", "pgfplots", "biblatex", "natbib", "biber", "pdflatex", "thebibliography"];

        worker.postMessage({
            texFile,
            batchSize,
            customWords: extraWords
        });
    });
}

function getdatainsidebrackets(file, i) {
    let content = "";
    let depth = 1;
    while (i < file.length && depth > 0) {
        if (file[i] === "{") depth++;
        else if (file[i] === "}") {
            depth--;
            if (depth === 0) break;
        }
        content = content + file[i];
        i++;
    }
    return content;
}

// ─── CHANGE HERE: Update sync helper dictionary to use nspell ───
const loadDictionary = async () => {
    try {
        const affData = await fetch("/dictionaries/en_US.aff").then(r => r.text());
        const dicData = await fetch("/dictionaries/en_US.dic").then(r => r.text());

        // Assign to our module variable using nspell
        spell = nspell(affData, dicData);
        console.log("Nspell checker module ready!");
    } catch (e) {
        console.error("Dictionary load failed", e);
    }
};

loadDictionary();
// ── Escape special regex characters in a label string ────────────────────────
function escapeRegex(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
function extractAuthorName(content) {
    const given = /\\givenname\s*\{([^}]*)\}/.exec(content);
    const sur = /\\surname\s*\{([^}]*)\}/.exec(content);
    return `${given?.[1] || ''} ${sur?.[1] || ''}`.trim() || content.trim().slice(0, 30);
}
function analyseCorresp(content, extractBraced) {
    const correspM = /\\corresp\s*\{/.exec(content);
    if (correspM) {
        const { content: cc } = extractBraced(content, correspM.index + correspM[0].length - 1);
        const hasHypertarget = /\\hypertarget\s*\{[^}]+\}/.test(cc);
        const hasEmail = /\\email\s*\{[^}]+\}/.test(cc) || /[\w.+-]+@[\w-]+\.[a-zA-Z]{2,}/.test(cc);
        return {
            hasCorresp: true, isComplete: hasHypertarget && hasEmail,
            missingHypertarget: !hasHypertarget, missingEmail: !hasEmail,
        };
    }
    const thanksM = /\\thanks\s*\{/.exec(content);
    if (thanksM) {
        const { content: tc } = extractBraced(content, thanksM.index + thanksM[0].length - 1);
        const hasEmail = /\\email\s*\{[^}]+\}/.test(tc) || /[\w.+-]+@[\w-]+\.[a-zA-Z]{2,}/.test(tc);
        return { hasThanks: true, isComplete: hasEmail, missingEmail: !hasEmail };
    }
    return { hasNothing: true, isComplete: false };
}
export const edp = {

    RemoveHiddenText: eplStyles.RemoveHiddenText,

    removeHonorifics: {
        name: "Remove Honorifics",
        description: "Remove honorifics from the author name, including those inside tags.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = [], rejectedSuggestions = []) {
            const staleIds = new Set();
            const emit = makeAnchorEmitter({
                texFile, session, Range, anchorlist, existingSuggestions, staleIds,
                styleName: this.name, markerClass: this.markerClass,
            });

            // The list of words to remove
            // const honorificsList = [
            //     "mr", "mister", "mrs", "miss", "ms", "dr", "doctor", "prof", "professor", "phd", "ph.d",
            //     "sir", "madam", "rev", "reverend", "hon", "honorable"
            // ];
            const honorificsList = new Set([
                "mr", "mister", "mrs", "miss", "ms", "mx",
                "dr", "doctor", "prof", "professor", "phd", "eng", "esq", "esquire", "ph.d",
                "sir", "madam", "dame", "lord", "lady", "baron", "baroness",
                "count", "countess", "duke", "duchess", "earl", "viscount",
                "princess", "prince", "king", "queen",
                "capt", "captain", "col", "colonel", "maj", "major",
                "lt", "lieutenant", "cmdr", "commander", "sgt", "sergeant",
                "cpl", "corporal", "gen", "general", "adm", "admiral",
                "rev", "reverend", "fr", "father", "sis", "sister",
                "pastor", "imam", "imām", "rabbi", "sheikh", "shaykh",
                "mufti", "bishop", "archbishop", "pope", "cardinal",
                "brother", "elder", "pandit", "guru", "swami",
                "sri", "shri", "smt", "ji", "babu", "rao", "devi",
                "kumari", "chan", "san", "kun", "sama", "sensei",
                "honorable", "rt", "rt.", "sen", "senator",
                "rep", "representative", "pres", "president",
                "gov", "governor", "amb", "ambassador",
                "tunku", "tuan", "puan", "dato", "datuk", "tan",
                "tengku", "nguyen", "madame", "monsieur", "herr",
                "frau", "signor", "signora", "don", "doña", "Ph.D."
            ]);


            const authorPattern = /\\author\s*(?:\[[^\]]*\])?\s*\{/gi;
            let match;

            while ((match = authorPattern.exec(texFile)) !== null) {
                if (isCommented(texFile, match.index)) continue;


                let depth = 1, i = match.index + match[0].length, content = '';
                while (i < texFile.length && depth > 0) {
                    if (texFile[i] === '{') depth++;
                    else if (texFile[i] === '}') { depth--; if (depth === 0) break; }
                    content += texFile[i]; i++;
                }

                const fullMatch = texFile.slice(match.index, i + 1);
                const optionalArg = match[0].match(/\[[^\]]*\]/)?.[0] || '';

                let processedContent = content.replace(/\\honor\s*\{[^}]*\}/gi, '');

                honorificsList.forEach(title => {
                    // const wordRegex = new RegExp(`\\b${title}\\s*\\.?\\b`, 'gi');
                    const wordRegex = new RegExp(`(?<![a-zA-Z])${title}\\s*\\.?`, 'gi');
                    processedContent = processedContent.replace(wordRegex, '');
                });

                processedContent = processedContent
                    .replace(/\s+/g, ' ')           // Collapse multiple spaces
                    .replace(/\{\s+\}/g, '{}')      // Fix empty braces
                    .trim();

                const suggestion = `\\author${optionalArg}{${processedContent}}`;

                if (fullMatch === suggestion) continue;

                emit(fullMatch, suggestion, match.index, this.description);
            }

            return staleIds;
        }
    },

    AffiliationEndAndOrder: {
        name: "Affiliation End With Period",
        description: "Replace the comma after the country name in \\address{} with a period.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles,
            existingSuggestions = [], rejectedSuggestions = []) {

            const staleIds = new Set();
            const self = this;

            const { segments } = buildStyleContext({
                texFile, session, Range, anchorlist,
                existingSuggestions, staleIds,
                styleName: self.name,
                markerClass: self.markerClass,
                scope: { wholeDocument: true },
                excludeMath: true,
                excludeAllCommands: false,
                overlapMode: 'simple',
            });

            // ── Large country list for reliable detection (nlp alone is unreliable on single words) ──
            const KNOWN_COUNTRIES = new Set([
                "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Argentina", "Armenia", "Australia",
                "Austria", "Azerbaijan", "Bahrain", "Bangladesh", "Belarus", "Belgium", "Belize", "Benin",
                "Bhutan", "Bolivia", "Bosnia", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina",
                "Burundi", "Cambodia", "Cameroon", "Canada", "Chad", "Chile", "China", "Colombia", "Comoros",
                "Congo", "Croatia", "Cuba", "Cyprus", "Czechia", "Denmark", "Djibouti", "Ecuador", "Egypt",
                "Estonia", "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Georgia", "Germany", "Ghana",
                "Greece", "Guatemala", "Guinea", "Haiti", "Honduras", "Hungary", "Iceland", "India",
                "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Jamaica", "Japan", "Jordan",
                "Kazakhstan", "Kenya", "Kosovo", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon",
                "Lesotho", "Liberia", "Libya", "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia",
                "Maldives", "Mali", "Malta", "Mauritania", "Mauritius", "Mexico", "Moldova", "Monaco",
                "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nepal",
                "Netherlands", "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Palestine",
                "Panama", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania",
                "Russia", "Rwanda", "Samoa", "Senegal", "Serbia", "Singapore", "Slovakia", "Slovenia",
                "Somalia", "Spain", "Sudan", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan",
                "Tanzania", "Thailand", "Togo", "Tunisia", "Turkey", "Turkmenistan", "Uganda", "Ukraine",
                "Emirates", "Uruguay", "USA", "Uzbekistan", "Venezuela", "Vietnam", "Yemen", "Zambia",
                "Zimbabwe", "Kingdom", "States", "Republic", "Korea", "Zealand", "Africa", "Arabia", "Deutschland"
            ]);



            // ── Large city list as fallback (only major/commonly cited cities) ──
            const KNOWN_CITIES = new Set([
                "Amsterdam", "Athens", "Auckland", "Bangkok", "Barcelona", "Beijing", "Berlin", "Boston",
                "Brussels", "Budapest", "Cairo", "Canberra", "Chicago", "Copenhagen", "Dallas", "Delhi",
                "Dubai", "Dublin", "Edinburgh", "Frankfurt", "Geneva", "Hamburg", "Helsinki", "Houston",
                "Istanbul", "Jakarta", "Jena", "Johannesburg", "Karachi", "Kiev", "Kyiv", "Lagos", "Lima",
                "Lisbon", "London", "Los", "Lyon", "Madrid", "Manchester", "Melbourne", "Mexico", "Miami",
                "Milan", "Montreal", "Moscow", "Mumbai", "Munich", "Nairobi", "Oslo", "Ottawa", "Paris",
                "Prague", "Riyadh", "Rome", "Santiago", "Seoul", "Shanghai", "Singapore", "Stockholm",
                "Sydney", "Taipei", "Tehran", "Tokyo", "Toronto", "Vienna", "Warsaw", "Washington", "Zurich",
            ]);

            function isCountry(word) {
                return (nlp && nlp(word).has('#Country')) || KNOWN_COUNTRIES.has(word);
            }

            function isCity(word) {
                return (nlp && nlp(word).has('#City')) || KNOWN_CITIES.has(word);
            }

            function getPlainWords(text) {
                return text
                    .replace(/\\[a-zA-Z]+(?:\{[^}]*\}|\[[^\]]*\])*/g, ' ')
                    .replace(/[{}]/g, ' ')
                    .replace(/[,.\d\-@]/g, ' ')
                    .replace(/\s+/g, ' ')
                    .trim()
                    .split(' ')
                    .filter(w => w.length >= 2);
            }

            function findEntities(words) {
                let city = null;
                let country = null;
                for (const word of words) {
                    if (isCountry(word)) country = word;
                    if (isCity(word)) city = word;
                }
                return { city, country };
            }

            function escapeRegExp(str) {
                return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            }

            function extractContent(text, afterOpenBrace) {
                let depth = 1;
                let i = afterOpenBrace;
                let content = '';
                while (i < text.length && depth > 0) {
                    const ch = text[i];
                    if (ch === '{') depth++;
                    else if (ch === '}') {
                        depth--;
                        if (depth === 0) break;
                    }
                    content += ch;
                    i++;
                }
                return { content, closeIdx: i };
            }

            function buildSuggestion(matchStr, content) {
                // 1. Strip email/texttt BEFORE doing any text analysis
                let modifiedContent = content.replace(/\\(?:email|texttt)\{[^}]+\}/gi, '');

                // Check if the email removal actually changed anything
                let isModified = (content !== modifiedContent);

                // 2. Get words from the CLEANED content
                const words = getPlainWords(modifiedContent);
                const { city, country } = findEntities(words);

                // Need at least a country to act
                if (!country) return null;

                // 3. City/Country Swap Logic
                if (city && country) {
                    const mCountry = new RegExp(escapeRegExp(country), 'i').exec(modifiedContent);
                    const mCity = new RegExp(escapeRegExp(city), 'i').exec(modifiedContent);

                    if (mCountry && mCity && mCountry.index < mCity.index) {
                        isModified = true;
                        const firstIdx = mCountry.index;
                        const firstLen = mCountry[0].length;
                        const secondIdx = mCity.index;
                        const secondLen = mCity[0].length;

                        modifiedContent =
                            modifiedContent.slice(0, firstIdx) +
                            mCity[0] +
                            modifiedContent.slice(firstIdx + firstLen, secondIdx) +
                            mCountry[0] +
                            modifiedContent.slice(secondIdx + secondLen);
                    }
                }

                // 4. End Period Logic (targets the LAST country found)
                const countryRegex = new RegExp(escapeRegExp(country), 'gi');
                let finalCountryMatch = null;
                let m;
                while ((m = countryRegex.exec(modifiedContent)) !== null) {
                    finalCountryMatch = m;
                }

                if (finalCountryMatch) {
                    const countryEndIdx = finalCountryMatch.index + finalCountryMatch[0].length;

                    let i = countryEndIdx;
                    while (i < modifiedContent.length && modifiedContent[i] === ' ') i++;

                    const charAfter = modifiedContent[i];

                    if (charAfter === '.') {
                        // Already has a period, do nothing
                    } else if (charAfter === ',') {
                        isModified = true;
                        modifiedContent = modifiedContent.slice(0, i) + '.' + modifiedContent.slice(i + 1);
                    } else {
                        // No punctuation — insert period right after the last country
                        isModified = true;
                        modifiedContent = modifiedContent.slice(0, countryEndIdx) + '.' + modifiedContent.slice(countryEndIdx);
                    }
                }

                if (!isModified) return null;

                return {
                    original: matchStr + content + '}',
                    suggestion: matchStr + modifiedContent + '}',
                };
            }

            const addressPat = /\\address\s*(?:\[[^\]]*\])?\s*\{/gi;

            for (const seg of segments) {
                addressPat.lastIndex = 0;
                let match;

                while ((match = addressPat.exec(seg.text)) !== null) {
                    const matchStr = match[0];
                    const openAfter = match.index + matchStr.length;
                    const { content } = extractContent(seg.text, openAfter);

                    if (!content.trim()) continue;

                    // buildSuggestion now returns the fully cleaned and punctuated string
                    const result = buildSuggestion(matchStr, content);

                    if (!result) continue;

                    seg.emit(
                        result.original,
                        result.suggestion,
                        match.index,
                        self.description
                    );
                }
            }

            return staleIds;
        },
    },

    AffiliationCheck: {
        name: "Affiliation Check",
        description: "Validate EDP affiliations and corresponding author declaration.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles,
            existingSuggestions = [], rejectedSuggestions = []) {

            const staleIds = new Set();
            const self = this;

            // ── CLEAN SWEEP ───────────────────────────────────────────────────────
            existingSuggestions.forEach(sug => {
                if (sug.styleInfo?.name === self.name) staleIds.add(sug.id);
            });
            const ctx = buildStyleContext({
                texFile, session, Range, anchorlist,
                existingSuggestions, staleIds,
                styleName: self.name,
                markerClass: self.markerClass,
                scope: {},
                excludeMath: false,
                mode: 'query',
                overlapMode: 'refresh',
            });

            // ─────────────────────────────────────────────────────────────────────
            // LOCAL HELPERS
            // ─────────────────────────────────────────────────────────────────────
            function extractAuthorName(content) {
                const given = /\\givenname\s*\{([^}]*)\}/.exec(content);
                const sur = /\\surname\s*\{([^}]*)\}/.exec(content);
                return `${given?.[1] || ''} ${sur?.[1] || ''}`.trim() || content.trim().slice(0, 30);
            }

            function analyseCorresp(content) {
                const correspM = /\\corresp\s*\{/.exec(content);
                if (correspM) {
                    const { content: cc } = extractBracedContent(content, correspM.index + correspM[0].length - 1);
                    const hasHypertarget = /\\hypertarget\s*\{[^}]+\}/.test(cc);
                    const hasEmail = /\\email\s*\{[^}]+\}/.test(cc) || /[\w.+-]+@[\w-]+\.[a-zA-Z]{2,}/.test(cc);
                    return { hasCorresp: true, isComplete: hasHypertarget && hasEmail, missingHypertarget: !hasHypertarget, missingEmail: !hasEmail };
                }
                const thanksM = /\\thanks\s*\{/.exec(content);
                if (thanksM) {
                    const { content: tc } = extractBracedContent(content, thanksM.index + thanksM[0].length - 1);
                    const hasEmail = /\\email\s*\{[^}]+\}/.test(tc) || /[\w.+-]+@[\w-]+\.[a-zA-Z]{2,}/.test(tc);
                    return { hasThanks: true, isComplete: hasEmail, missingEmail: !hasEmail };
                }
                return { hasNothing: true, isComplete: false };
            }

            // ─────────────────────────────────────────────────────────────────────
            // STEP 1: Parse \author{} blocks
            // ─────────────────────────────────────────────────────────────────────
            const authorPat = /\\author\s*\{/gi;
            const authors = [];
            const allAuthorLabels = new Set();
            const inAuthorHypertargets = new Set();
            let m;

            while ((m = authorPat.exec(texFile)) !== null) {
                if (isCommented(texFile, m.index)) continue;
                const oi = m.index + m[0].length - 1;
                const { content, closeIdx } = extractBracedContent(texFile, oi);
                const fullMatch = texFile.slice(m.index, closeIdx + 1);
                const name = extractAuthorName(content);

                const hlabels = new Set();
                const hlPat = /\\myhyperlink\s*(?:\[([^\]]*)\]|\{([^}]*)\})/g;
                let hl;
                while ((hl = hlPat.exec(content)) !== null) {
                    const label = (hl[1] || hl[2] || '').trim();
                    if (label) { hlabels.add(label); allAuthorLabels.add(label); }
                }

                const htPat = /\\hypertarget\s*\{([^}]*)\}/g;
                let ht;
                while ((ht = htPat.exec(content)) !== null) {
                    const label = ht[1].trim();
                    if (label) inAuthorHypertargets.add(label);
                }

                authors.push({ fullMatch, content, name, hlabels, corrInfo: analyseCorresp(content), absIndex: m.index });
            }

            // ─────────────────────────────────────────────────────────────────────
            // STEP 2: Parse \address[N]{} blocks
            // ─────────────────────────────────────────────────────────────────────
            const addrPat = /\\address\s*\[([^\]]*)\]\s*\{/gi;
            const addresses = [];
            const hypertargetMap = new Map();

            while ((m = addrPat.exec(texFile)) !== null) {
                if (isCommented(texFile, m.index)) continue;
                const marker = m[1].trim();
                const oi = m.index + m[0].length - 1;
                const { content, closeIdx } = extractBracedContent(texFile, oi);
                const fullMatch = texFile.slice(m.index, closeIdx + 1);
                const labels = new Set();
                const htPat = /\\hypertarget\s*\{([^}]*)\}/g;
                let ht;
                while ((ht = htPat.exec(content)) !== null) {
                    const label = ht[1].trim();
                    if (label) { labels.add(label); hypertargetMap.set(label, { marker }); }
                }
                addresses.push({ fullMatch, labels, marker, absIndex: m.index });
            }

            const effectiveAuthorLabels = new Set(
                [...allAuthorLabels].filter(l => !inAuthorHypertargets.has(l))
            );
            const isEdpStyle = addresses.length > 0;

            // ─────────────────────────────────────────────────────────────────────
            // CHECK A — \myhyperlink ↔ \hypertarget linking
            // Every author must have at least one \myhyperlink{} that resolves
            // to an \address[] hypertarget. Links to corresp targets (e.g. cor1)
            // do NOT count as affiliation links.
            // ─────────────────────────────────────────────────────────────────────
            if (isEdpStyle) for (const author of authors) {
                // Candidate labels: exclude any that are in-author hypertargets (e.g. cor1 defined inside \corresp{})
                const affLabels = [...author.hlabels].filter(l => !inAuthorHypertargets.has(l));

                // Split into resolved (point to a real \address[]) and unresolved
                const resolvedAffLabels = affLabels.filter(l => hypertargetMap.has(l));
                const unresolvedAffLabels = affLabels.filter(l => !hypertargetMap.has(l));

                if (resolvedAffLabels.length === 0) {
                    // No valid affiliation link at all — fire missing-affiliation query
                    ctx.emitQuery(
                        author.fullMatch,
                        `Author ${author.name} has no affiliation link — \\myhyperlink{} pointing to an \\address[] is missing`,
                        author.absIndex,
                        `Author "${author.name}" is missing \\myhyperlink{} affiliation link`
                    );
                } else {
                    // Has at least one valid affiliation — flag any broken/unresolved links
                    for (const label of unresolvedAffLabels) {
                        ctx.emitQuery(
                            author.fullMatch,
                            `Author ${author.name} links to "${label}" via \\myhyperlink{${label}} but no \\address[] has \\hypertarget{${label}}`,
                            author.absIndex,
                            `\\myhyperlink{${label}} in "${author.name}" has no matching \\address[]`
                        );
                    }
                }
            }

            // ─────────────────────────────────────────────────────────────────────
            // CHECK B — Every \address[] must be referenced by at least one \author
            // ─────────────────────────────────────────────────────────────────────
            if (isEdpStyle) for (const addr of addresses) {
                if (addr.labels.size === 0) {
                    ctx.emitQuery(
                        addr.fullMatch,
                        `\\address[${addr.marker}] has no \\hypertarget{} — it cannot be linked from any \\author{} via \\myhyperlink{}`,
                        addr.absIndex,
                        `\\address[${addr.marker}] is missing \\hypertarget{} anchor`
                    );
                } else {
                    for (const label of addr.labels) {
                        if (!effectiveAuthorLabels.has(label)) {
                            ctx.emitQuery(
                                addr.fullMatch,
                                `\\address[${addr.marker}] (\\hypertarget{${label}}) is not referenced by any \\author{} — add \\myhyperlink{${label}} to the relevant author`,
                                addr.absIndex,
                                `\\address[${addr.marker}] with \\hypertarget{${label}} is unreferenced`
                            );
                        }
                    }
                }
            }

            // ─────────────────────────────────────────────────────────────────────
            // CHECK C — Exactly one complete corresponding author
            // ─────────────────────────────────────────────────────────────────────
            const completeCorrAuthors = authors.filter(a => a.corrInfo.isComplete);
            const partialCorrAuthors = authors.filter(a =>
                (a.corrInfo.hasCorresp || a.corrInfo.hasThanks) && !a.corrInfo.isComplete
            );

            //         if (completeCorrAuthors.length === 0 && partialCorrAuthors.length === 0) {
            //             // C1: No corresponding marker anywhere
            //             authors.forEach(author => {
            //                 ctx.emitQuery(
            //                     author.fullMatch,
            //                     `Author ${author.name} — no corresponding author is declared anywhere. Add \\corresp{\\hypertarget{cor1}{}*Corresponding Author: \\email{address}} to the corresponding author`,
            //                     author.absIndex,
            //                     `No corresponding author declared in any author`
            //                 );
            //             });
            //         } else {
            //             // C2 & C3: Incomplete declarations

            if (completeCorrAuthors.length === 0 && partialCorrAuthors.length === 0) {
                // C1: No corresponding marker anywhere
                ctx.emitQuery(
                    authors[0].fullMatch,
                    `Author ${authors[0].name} — no corresponding author is declared anywhere. Add \\corresp{\\hypertarget{cor1}{}*Corresponding Author: \\email{address}} to the corresponding author`,
                    authors[0].absIndex,
                    `No corresponding author declared in any author`
                );
            } else {
                // C2 & C3: Incomplete declarations
                for (const author of partialCorrAuthors) {
                    if (author.corrInfo.hasCorresp) {
                        const missing = [];
                        if (author.corrInfo.missingHypertarget) missing.push('\\hypertarget{corN}{}');
                        if (author.corrInfo.missingEmail) missing.push('\\email{address}');
                        ctx.emitQuery(
                            author.fullMatch,
                            `Author ${author.name} has \\corresp{} but it is incomplete — missing: ${missing.join(' and ')}`,
                            author.absIndex,
                            `\\corresp{} on "${author.name}" is incomplete`
                        );

                        if (author.corrInfo.missingEmail) {
                            ctx.emitQuery(
                                author.fullMatch,
                                `The corresponding author's email address is not provided. Kindly supply a valid email ID for correspondence.`,
                                author.absIndex,
                                // `Corresponding author "${author.name}" is missing email address`
                                `The corresponding author’s email address is not provided. Kindly supply a valid email ID for correspondence.`
                            );
                        }
                    } else if (author.corrInfo.hasThanks) {
                        ctx.emitQuery(
                            author.fullMatch,
                            `Author ${author.name} has \\thanks{} but no email address was found inside it`,
                            author.absIndex,
                            `\\thanks{} on "${author.name}" is missing an email address`
                        );
                    }
                }

                // C4: Multiple complete corresponding authors
                if (completeCorrAuthors.length > 1) {
                    completeCorrAuthors.forEach(author => {
                        ctx.emitQuery(
                            author.fullMatch,
                            `Author ${author.name} is marked as corresponding author but ${completeCorrAuthors.length} corresponding authors were found — only one is allowed`,
                            author.absIndex,
                            `Multiple corresponding authors (${completeCorrAuthors.map(a => a.name).join(', ')})`
                        );
                    });
                }
            }

            return staleIds;
        },
    },

    AffiliationAddressCheck: {
        name: "Affiliation Address Check",
        description: "Address Pattern Check in Affiliation part",
        markerClass: "ace-Common-highlight",
        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = [], rejectedsuggestions = []) {
            const staleIds = new Set();
            existingSuggestions.forEach(sug => {
                if (sug.styleInfo?.name === this.name) staleIds.add(sug.id);
            });
            const ctx = buildStyleContext({
                texFile, session, Range, anchorlist, staleIds, existingSuggestions,
                styleName: this.name,
                markerClass: this.markerClass,
                scope: {},
                mode: "query",
                overlapMode: "refresh"
            });
            function resolveLatexAccents(text) {
                return text
                    .replace(/\\["'`^~=.]{([a-zA-Z])\}/g, '$1')
                    .replace(/\\c\{([a-zA-Z])\}/g, '$1')
                    .replace(/\\[a-zA-Z]+\{([a-zA-Z])\}/g, '$1');
            }

            function getPlainWords(text) {
                return resolveLatexAccents(text)
                    .replace(/\\[a-zA-Z]+(?:\{[^}]*\}|\[[^\]]*\])*/g, ' ')
                    .replace(/[{}]/g, ' ')
                    .replace(/[,.\d\-@]/g, ' ')
                    .replace(/\s+/g, ' ')
                    .trim()
                    .split(' ')
                    .filter(w => w.length >= 2);
            }

            // const KNOWN_COUNTRIES = new Set([
            //     'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Argentina', 'Armenia',
            //     'Australia', 'Austria', 'Azerbaijan', 'Bahrain', 'Bangladesh', 'Belarus', 'Belgium',
            //     'Bolivia', 'Bosnia', 'Brazil', 'Bulgaria', 'Cambodia', 'Cameroon', 'Canada', 'Chile',
            //     'China', 'Colombia', 'Congo', 'Croatia', 'Cuba', 'Cyprus', 'Czechia', 'Denmark',
            //     'Ecuador', 'Egypt', 'Estonia', 'Ethiopia', 'Finland', 'France', 'Georgia', 'Germany',
            //     'Ghana', 'Greece', 'Guatemala', 'Hungary', 'India', 'Indonesia', 'Iran', 'Iraq',
            //     'Ireland', 'Israel', 'Italy', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kosovo',
            //     'Kuwait', 'Latvia', 'Lebanon', 'Libya', 'Lithuania', 'Luxembourg', 'Malaysia',
            //     'Mexico', 'Moldova', 'Mongolia', 'Morocco', 'Mozambique', 'Myanmar', 'Nepal',
            //     'Netherlands', 'Nigeria', 'Norway', 'Pakistan', 'Palestine', 'Panama', 'Paraguay',
            //     'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania', 'Russia', 'Rwanda',
            //     'Saudi Arabia', 'Senegal', 'Serbia', 'Singapore', 'Slovakia', 'Slovenia', 'Somalia',
            //     'Spain', 'Sudan', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tanzania', 'Thailand',
            //     'Tunisia', 'Turkey', 'Uganda', 'Ukraine', 'United Kingdom', 'UK', 'USA', 'Uruguay',
            //     'Uzbekistan', 'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'
            // ]);
            const KNOWN_CITIES = new Set([
                "Amsterdam", "Athens", "Auckland", "Bangkok", "Barcelona", "Beijing", "Berlin", "Boston",
                "Brussels", "Budapest", "Cairo", "Canberra", "Chicago", "Copenhagen", "Dallas", "Delhi",
                "Dubai", "Dublin", "Edinburgh", "Frankfurt", "Geneva", "Hamburg", "Helsinki", "Houston",
                "Istanbul", "Jakarta", "Jena", "Johannesburg", "Karachi", "Kiev", "Kyiv", "Lagos", "Lima",
                "Lisbon", "London", "Los", "Lyon", "Madrid", "Manchester", "Melbourne", "Mexico", "Miami",
                "Milan", "Montreal", "Moscow", "Mumbai", "Munich", "Nairobi", "Oslo", "Ottawa", "Paris",
                "Prague", "Riyadh", "Rome", "Santiago", "Seoul", "Shanghai", "Singapore", "Stockholm",
                "Sydney", "Taipei", "Tehran", "Tokyo", "Toronto", "Vienna", "Warsaw", "Washington", "Zurich",
            ]);

            const pattern = /\\address\s*(\[[\s\S]*?\])?\s*\{/gi;
            let m;

            while ((m = pattern.exec(texFile)) !== null) {
                let depth = 1;
                let content = "";
                let i = m.index + m[0].length;

                while (i < texFile.length && depth > 0) {
                    if (texFile[i] === '{') depth++;
                    else if (texFile[i] === '}') {
                        depth--;
                        if (depth === 0) break;
                    }
                    content += texFile[i];
                    i++;
                }

                const words = getPlainWords(content);
                console.log("all the plain words inside the author address tag is :", words);
                let hasCountry = false;
                let hasCity = false;

                for (const word of words) {
                    if (!hasCountry && KNOWN_COUNTRIES.has(word)) {
                        hasCountry = true;
                    }
                    if (!hasCity && KNOWN_CITIES.has(word)) {
                        hasCity = true;
                    }
                    const doc = nlp(word);
                    console.log("the city is true or false in the query mode:", doc.has("#city"));
                    if (!hasCity && doc.has('#City')) {
                        hasCity = true;
                    }
                    if (!hasCountry && doc.has('#Country')) {
                        hasCountry = true;
                    }
                }

                if (hasCountry && !hasCity) {
                    hasCity = words.some(w => /^[A-Z][a-z]{2,}$/.test(w));
                }

                if (!hasCountry || !hasCity) {
                    ctx.emitQuery(
                        m[0],
                        "Address missing City or Country",
                        m.index,
                        "The address environment appears to be missing a City or Country name. Please verify."
                    );
                }
            }

            return staleIds;
        }
    },

    abstractReferenceCheck: {
        name: "Abstract Reference Checking",
        description: "Replace reference with Content in abstract",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles,
            existingSuggestions = [], rejectedSuggestions = []) {

            function escapeRegex(str) {
                return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            }

            function extractMacroContent(text, macroName) {
                const pat = new RegExp(`\\\\${macroName}\\s*\\{`, 'g');
                const m = pat.exec(text);
                if (!m) return null;
                let depth = 1, i = m.index + m[0].length, result = '';
                while (i < text.length && depth > 0) {
                    if (text[i] === '{') depth++;
                    else if (text[i] === '}') { depth--; if (depth === 0) break; }
                    result += text[i++];
                }
                return result.trim();
            }

            function extractAllMacroContents(text, macroName) {
                const pat = new RegExp(`\\\\${macroName}\\s*\\{`, 'g');
                const results = [];
                let m;
                while ((m = pat.exec(text)) !== null) {
                    let depth = 1, i = m.index + m[0].length, result = '';
                    while (i < text.length && depth > 0) {
                        if (text[i] === '{') depth++;
                        else if (text[i] === '}') { depth--; if (depth === 0) break; }
                        result += text[i++];
                    }
                    results.push(result.trim());
                }
                return results;
            }

            function formatAuthors(refaugroupContent) {
                const authorContents = extractAllMacroContents(refaugroupContent, 'Refauthor');
                const formatted = authorContents.map(authorContent => {
                    const surname = extractMacroContent(authorContent, 'Refsurname');
                    const initials = extractAllMacroContents(authorContent, 'Refinitial');
                    if (surname && initials.length > 0) {
                        return `${initials.join(' ')} ${surname}`;
                    } else if (surname) {
                        const parts = surname.split(/\s+/);
                        if (parts.length === 1) return surname;
                        const lastWord = parts[parts.length - 1];
                        const abbrev = parts.slice(0, -1).map(n => n.charAt(0).toUpperCase() + '.').join(' ');
                        return `${abbrev} ${lastWord}`;
                    } else {
                        return authorContent.replace(/\\[a-zA-Z]+\{([^}]*)\}/g, '$1').trim();
                    }
                });
                if (formatted.length === 0) return '';
                if (formatted.length === 1) return formatted[0];
                if (formatted.length === 2) return formatted.join(' and ');
                return formatted.slice(0, -1).join(', ') + ' and ' + formatted[formatted.length - 1];
            }

            function formatBibitemToInline(bibContent) {
                const refmiscPat = /\\begin\{refmisc\}([\s\S]*?)\\end\{refmisc\}/;
                const refmiscMatch = refmiscPat.exec(bibContent);
                const refmisc = refmiscMatch ? refmiscMatch[1] : bibContent;

                const refaugroupContent = extractMacroContent(refmisc, 'Refaugroup');
                const authors = refaugroupContent ? formatAuthors(refaugroupContent) : '';
                const title = (extractMacroContent(refmisc, 'Refatit') || '').replace(/\.\s*$/, '');
                const year = (extractMacroContent(refmisc, 'Refyear') || '').replace(/[()]/g, '').trim();
                const doi = extractMacroContent(refmisc, 'Refdoi') || '';

                const parts = [];
                if (authors) parts.push(authors);
                let middle = '';
                if (title) middle += `\\textit{${title}}`;
                if (year) middle += ` (${year})`;
                if (middle) parts.push(middle.trim());

                let inline = `[${parts.join(', ')}`;
                if (doi) inline += `. ${doi}`;
                inline += '.]';
                return inline;
            }

            const abstractPat = /\\begin\{abstract\}([\s\S]*?)\\end\{abstract\}/m;
            const absMatch = abstractPat.exec(texFile);

            const citePat = /\\cite\s*(?:\[[^]]*\])?\{([^}]*)\}/g;
            const citeMatches = absMatch
                ? [...absMatch[0].matchAll(citePat)]
                : [];

            const abstractStart = absMatch ? absMatch.index : 0;
            if (citeMatches.length > 1) {
                const staleIds = new Set();
                existingSuggestions.forEach(s => {
                    if (s.styleInfo?.name === this.name) staleIds.add(s.id);
                });

                const ctx = buildStyleContext({
                    texFile, session, Range, anchorlist,
                    existingSuggestions, staleIds,
                    styleName: this.name,
                    markerClass: this.markerClass,
                    scope: { wholeDocument: true },
                    excludeMath: false,
                    mode: 'query',
                    overlapMode: 'refresh',
                });

                // 1. Extract all the citation keys into a single array and format them
                const citedKeys = citeMatches.map(c => c[1].trim());
                const formattedKeys = `[${citedKeys.join(', ')}]`;

                // 2. Use the formatted string in your emitQuery
                for (const cm of citeMatches) {
                    ctx.emitQuery(
                        cm[0],
                        `Multiple references ${formattedKeys} are cited only in the abstract. Kindly review and confirm if this is appropriate.`,
                        abstractStart + cm.index,
                        `Multiple references ${formattedKeys} are cited only in the abstract`
                    );
                }

                return staleIds;
            }

            // if (citeMatches.length === 1) {
            //     const staleIds = new Set();
            //     existingSuggestions.forEach(s => {
            //         if (s.styleInfo?.name === this.name) staleIds.add(s.id);
            //     });

            //     const emit = makeAnchorEmitter({
            //         texFile, session, Range, anchorlist,
            //         existingSuggestions, staleIds,
            //         styleName: this.name,
            //         markerClass: this.markerClass,

            //     });

            //     const cm = citeMatches[0];
            //     const key = cm[1].trim();
            //     const absIndex = abstractStart + cm.index;

            //     const bibPat = new RegExp(
            //         `\\\\bibitem(?:\\[[^\\]]*\\])?\\{${escapeRegex(key)}\\}\\s*([\\s\\S]*?)(?=\\\\bibitem|\\\\end\\s*\\{thebibliography\\})`,
            //         'm'
            //     );
            //     const bibMatch = bibPat.exec(texFile);

            //     if (bibMatch) {
            //         const bibContent = bibMatch[1].trim();
            //         const inlineCitation = formatBibitemToInline(bibContent);
            //         emit(cm[0], ` \\AQ{Reference ${citeMatches[0][0]} cited only in the abstract has been replaced by the entire reference. Kindly check and include its citation in the main text.}${inlineCitation}`, absIndex, this.description);
            //     }

            //     return staleIds;
            // }

            if (citeMatches.length === 1) {
                const staleIds = new Set();
                existingSuggestions.forEach(s => {
                    if (s.styleInfo?.name === this.name) staleIds.add(s.id);
                });

                const cm = citeMatches[0];
                const key = cm[1].trim();
                const absIndex = abstractStart + cm.index;

                // ── NEW: build body text by excluding the abstract ──────────────────
                const beforeAbstract = texFile.slice(0, absMatch.index);
                const afterAbstract = texFile.slice(absMatch.index + absMatch[0].length);
                const bodyText = beforeAbstract + afterAbstract;

                // Check every \cite{...} in the body for this key
                // (handles multi-key cites like \cite{ref1, ref28, ref5})
                const bodyCitePat = /\\cite\s*\{([^}]*)\}/g;
                let citedInBody = false;
                let bodyMatch;
                while ((bodyMatch = bodyCitePat.exec(bodyText)) !== null) {
                    const keys = bodyMatch[1].split(',').map(k => k.trim());
                    if (keys.includes(key)) {
                        citedInBody = true;
                        break;
                    }
                }
                // ────────────────────────────────────────────────────────────────────

                // Only raise the suggestion when NOT cited anywhere in the body
                if (!citedInBody) {
                    const emit = makeAnchorEmitter({
                        texFile, session, Range, anchorlist,
                        existingSuggestions, staleIds,
                        styleName: this.name,
                        markerClass: this.markerClass,
                    });

                    const bibPat = new RegExp(
                        `\\\\bibitem(?:\\[[^\\]]*\\])?\\{${escapeRegex(key)}\\}\\s*([\\s\\S]*?)(?=\\\\bibitem|\\\\end\\s*\\{thebibliography\\})`,
                        'm'
                    );
                    const bibMatch = bibPat.exec(texFile);

                    if (bibMatch) {
                        const bibContent = bibMatch[1].trim();
                        const inlineCitation = formatBibitemToInline(bibContent);
                        emit(
                            cm[0],
                            ` \\AQ{Reference ${cm[0]} cited only in the abstract has been replaced by the entire reference. Kindly check and include its citation in the main text.}${inlineCitation}`,
                            absIndex,
                            this.description
                        );
                    }
                }

                return staleIds;
            }


            const staleIds = new Set();
            existingSuggestions.forEach(s => {
                if (s.styleInfo?.name === this.name) staleIds.add(s.id);
            });
            return staleIds;
        }
    },


    AbstractFloatingObject: {
        name: "Abstract Remove floating",
        description: "Remove floating objects and their references from the abstract",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles,
            existingSuggestions = [], rejectedSuggestions = []) {

            const staleIds = new Set();
            const emit = makeAnchorEmitter({
                texFile, session, Range, anchorlist, existingSuggestions, staleIds,
                styleName: this.name, markerClass: this.markerClass, overlapMode: 'simple',
            });

            // ── Step 1: Collect all figure labels ─────────────────────────────────
            const figureLables = new Set();
            const tableLabels = new Set();

            const labelPat = /\\label\s*\{([^}]*)\}/gi;

            // Figure labels — \begin{figure} or \begin{figure*}
            const figurePat = /\\begin\s*\{figure\*?\}([\s\S]*?)\\end\s*\{figure\*?\}/gi;
            let fm;
            while ((fm = figurePat.exec(texFile)) !== null) {
                labelPat.lastIndex = 0;
                let lm;
                while ((lm = labelPat.exec(fm[1])) !== null) {
                    figureLables.add(lm[1].trim());
                }
            }

            // Table labels — \begin{table} or \begin{table*}
            const tablePat = /\\begin\s*\{table\*?\}([\s\S]*?)\\end\s*\{table\*?\}/gi;
            let tm;
            while ((tm = tablePat.exec(texFile)) !== null) {
                labelPat.lastIndex = 0;
                let lm;
                while ((lm = labelPat.exec(tm[1])) !== null) {
                    tableLabels.add(lm[1].trim());
                }
            }

            // ── Step 2: Locate the abstract ───────────────────────────────────────
            const abstractPat = /\\begin\s*\{abstract\}([\s\S]*?)\\end\s*\{abstract\}/gi;
            const floatPat = /\\begin\s*\{(table\*?|equation\*?|figure\*?)\}([\s\S]*?)\\end\s*\{\1\}/gi;

            let abstractMatch;
            while ((abstractMatch = abstractPat.exec(texFile)) !== null) {
                const abstractStart = abstractMatch.index;
                const abstractContent = abstractMatch[0];
                const innerContent = abstractMatch[1]; // text between \begin{abstract}...\end{abstract}
                // Offset of inner content relative to texFile
                const innerStart = abstractStart + abstractMatch[0].indexOf(innerContent);

                // ── Step 3: Remove floating environments (existing logic) ──────────
                let result = abstractContent.replace(floatPat, '');
                floatPat.lastIndex = 0;
                if (floatPat.test(abstractContent)) {
                    result = `AQ{Floating object has been deleted please kindly Check it out}\n${result}`;
                }
                if (abstractContent !== result) {
                    emit(abstractContent, result, abstractStart, this.description);
                }

                // ── Step 4: Find \ref{} inside abstract that cite figures or tables ─
                // Scan innerContent so positions are easy to offset back to texFile
                const refPat = /\\ref\s*\{([^}]*)\}/gi;
                let refMatch;
                refPat.lastIndex = 0;

                while ((refMatch = refPat.exec(innerContent)) !== null) {
                    const refFull = refMatch[0];                 // e.g. \ref{fig:results}
                    const labelKey = refMatch[1].trim();          // e.g. fig:results
                    const absIdx = innerStart + refMatch.index; // position in texFile

                    if (isCommented(texFile, absIdx)) continue;

                    if (figureLables.has(labelKey)) {
                        // This \ref points to a figure — flag it
                        const suggestion =
                            `\\AQ{Figure citations are not permitted within the abstract text. ` +
                            `These have been removed. Please review and confirm.}`;
                        emit(refFull, suggestion, absIdx, this.description);

                    } else if (tableLabels.has(labelKey)) {
                        // This \ref points to a table — flag it
                        const suggestion =
                            `\\AQ{Table citations are not permitted within the abstract text. ` +
                            `These have been removed. Please review and confirm.}`;
                        emit(refFull, suggestion, absIdx, this.description);
                    }
                    // If label isn't figure or table, leave it alone
                }
            }

            return staleIds;
        }
    },

    Equationreference: {
        name: "Equation reference",
        description: "Convert 'Eqn.' to 'Eq.' when followed by context",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            try {
                const staleIds = new Set();

                // ── Pattern 1: plain  Eqn.~\ref{...}  or  Eqn. \ref{...} ──────────
                const plainPattern = /Eqn\.(\s*~?\s*)(?=\\ref\{[\w:]+\})/gi;

                // ── Pattern 2: \weblink{Eqn.}{\ref{...}} ────────────────────────────
                const weblinkRefPattern = /\\weblink\{\s*Eqn\.\s*\}\{\s*\\ref\{[\w:]+\}\s*\}/gi;

                // ── Pattern 3: \weblink{Eqn.}{bare-label} ───────────────────────────
                const weblinkBarePattern = /\\weblink\{\s*Eqn\.\s*\}\{[\w:.]+\}/gi;

                // ── Pattern 4: \weblink{Eqn.} \ref{...} (single-arg + separate ref) ─
                const weblinkSepPattern = /\\weblink\{\s*Eqn\.\s*\}\s*(?=\\ref\{[\w:]+\})/gi;

                // Helper: collect all valid absolute indices for stale detection
                const validIndices = new Set();

                const collectIndices = (pattern) => {
                    pattern.lastIndex = 0;
                    let m;
                    while ((m = pattern.exec(texFile)) !== null) {
                        // Find where "Eqn." sits within the full match
                        const eqnOffset = m[0].indexOf('Eqn.');
                        if (eqnOffset !== -1) validIndices.add(m.index + eqnOffset);
                    }
                };

                collectIndices(plainPattern);
                collectIndices(weblinkRefPattern);
                collectIndices(weblinkBarePattern);
                collectIndices(weblinkSepPattern);

                // ── Stale detection ──────────────────────────────────────────────────
                existingSuggestions.forEach((s) => {
                    if ((s.styleInfo?.name ?? s.styleName) !== this.name) return;

                    const row = s.startAnchor?.row ?? s.range?.start?.row;
                    const col = s.startAnchor?.column ?? s.range?.start?.column;

                    const lines = texFile.split('\n');
                    let absoluteIndex = 0;
                    for (let i = 0; i < (row || 0); i++) {
                        absoluteIndex += (lines[i]?.length ?? 0) + 1;
                    }
                    absoluteIndex += col || 0;

                    if (!validIndices.has(absoluteIndex)) {
                        staleIds.add(s.id);
                    }
                });

                // ── Emitter setup ────────────────────────────────────────────────────
                const emit = makeAnchorEmitter({
                    texFile, session, Range, anchorlist,
                    existingSuggestions, staleIds,
                    styleName: this.name,
                    markerClass: this.markerClass,
                    overlapMode: 'refresh',
                });

                // ── Emit for each pattern ────────────────────────────────────────────
                const emitMatches = (pattern) => {
                    pattern.lastIndex = 0;
                    let m;
                    while ((m = pattern.exec(texFile)) !== null) {
                        const eqnOffset = m[0].indexOf('Eqn.');
                        if (eqnOffset === -1) continue;
                        const targetIndex = m.index + eqnOffset;
                        emit('Eqn.', 'Eq.', targetIndex, this.description);
                    }
                };

                emitMatches(plainPattern);
                emitMatches(weblinkRefPattern);
                emitMatches(weblinkBarePattern);
                emitMatches(weblinkSepPattern);

                return staleIds;

            } catch (error) {
                console.error('Error in Equationreference style:', error);
                return new Set();
            }
        },
    },

    Figurereference: {
        name: "Figure reference",
        description: "Ensure 'Fig.' has a dot when followed by content",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            try {
                const staleIds = new Set();


                const pattern = /(?:\\weblink\{(?:Figure|Fig)\s*\}\s*\{[^}]*\})|(?:Figure|Fig)\s*(?=\\ref\{[^}]*\})/gi;

                const validIndices = new Set();
                let m;
                pattern.lastIndex = 0;
                while ((m = pattern.exec(texFile)) !== null) {

                    let matchText = m[0].match(/Figure|Fig/i)[0];
                    let targetIndex = m.index + m[0].indexOf(matchText);
                    validIndices.add(targetIndex);
                }


                existingSuggestions.forEach((s) => {
                    if ((s.styleInfo?.name ?? s.styleName) !== this.name) return;

                    const row = s.startAnchor?.row ?? s.range?.start?.row;
                    const col = s.startAnchor?.column ?? s.range?.start?.column;

                    const lines = texFile.split("\n");
                    let absoluteIndex = 0;
                    for (let i = 0; i < (row || 0); i++) {
                        absoluteIndex += (lines[i]?.length ?? 0) + 1;
                    }
                    absoluteIndex += (col || 0);

                    if (!validIndices.has(absoluteIndex)) {
                        staleIds.add(s.id);
                    }
                });

                const emit = makeAnchorEmitter({
                    texFile, session, Range, anchorlist, existingSuggestions, staleIds,
                    styleName: this.name,
                    markerClass: this.markerClass,
                    overlapMode: "refresh",
                });

                // Emitter
                pattern.lastIndex = 0;
                while ((m = pattern.exec(texFile)) !== null) {
                    let matchText = m[0].match(/Figure|Fig/i)[0];
                    let targetIndex = m.index + m[0].indexOf(matchText);


                    if (matchText !== "Fig.") {
                        emit(matchText, "Fig.", targetIndex, this.description);
                    }
                }

                return staleIds;
            } catch (error) {
                console.error("Error in Figurereference:", error);
                return new Set();
            }
        },
    },

    FigureSentenceStart: {
        name: "Figure sentence start",
        description: "Convert 'Fig.' to 'Figure' at the beginning of a sentence",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            try {
                const staleIds = new Set();


                const pattern = /^\s*(Fig\.)(?=\s+\d+\s*\w+)/gmi;

                const validIndices = new Set();
                let m;
                pattern.lastIndex = 0;
                while ((m = pattern.exec(texFile)) !== null) {

                    validIndices.add(m.index + m[0].indexOf("Fig."));
                }

                // Stale detection
                existingSuggestions.forEach((s) => {
                    if ((s.styleInfo?.name ?? s.styleName) !== this.name) return;

                    const row = s.startAnchor?.row ?? s.range?.start?.row;
                    const col = s.startAnchor?.column ?? s.range?.start?.column;

                    const lines = texFile.split("\n");
                    let absoluteIndex = 0;
                    for (let i = 0; i < (row || 0); i++) {
                        absoluteIndex += (lines[i]?.length ?? 0) + 1;
                    }
                    absoluteIndex += (col || 0);

                    if (!validIndices.has(absoluteIndex)) {
                        staleIds.add(s.id);
                    }
                });

                const emit = makeAnchorEmitter({
                    texFile, session, Range, anchorlist, existingSuggestions, staleIds,
                    styleName: this.name,
                    markerClass: this.markerClass,
                    overlapMode: "refresh",
                });


                pattern.lastIndex = 0;
                while ((m = pattern.exec(texFile)) !== null) {
                    let targetIndex = m.index + m[0].indexOf("Fig.");

                    emit("Fig.", "Figure", targetIndex, this.description);
                }

                return staleIds;
            } catch (error) {
                console.error("Error in FigureSentenceStart:", error);
                return new Set();
            }
        },
    },

    HyphenToEnDash: {
        name: "Hyphen to En-Dash",
        description: "Change hyphen to endash",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles,
            existingSuggestions = [], rejectedSuggestions = []) {

            const staleIds = new Set();

            // ---------------------------------------------------------
            // SETUP 1: For Number Ranges (Isolates text segments safely)
            // ---------------------------------------------------------
            const { segments } = buildStyleContext({
                texFile, session, Range, anchorlist,
                existingSuggestions, staleIds,
                styleName: this.name,
                markerClass: this.markerClass,
                scope: { wholeDocument: true },
                excludeMath: true,
                excludeAllCommands: true,
                excludeEnvironments: [],
            });

            // ---------------------------------------------------------
            // SETUP 2: For Scientific Names (Global document emitter)
            // ---------------------------------------------------------
            const emit = makeAnchorEmitter({
                texFile, session, Range, anchorlist,
                existingSuggestions, staleIds,
                styleName: this.name,
                markerClass: this.markerClass,
                overlapMode: "refresh",
            });


            // =========================================================
            // PART A: Number, Decimal, & Equation Ranges (Segments System)
            // =========================================================

            // 1. Pattern for Standard Numbers and Decimals (e.g., 10-20, 0.1-0.5)
            const standardRangePat = /(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)/gi;

            // 2. Pattern for Equations with Parentheses (e.g., (4)-(8))
            const eqRangePat = /\((\d+)\)-\((\d+)\)/gi;

            for (const seg of segments) {

                // Loop 1: Standard & Decimal Ranges
                standardRangePat.lastIndex = 0;
                let numMatch;
                while ((numMatch = standardRangePat.exec(seg.text)) !== null) {
                    const val1 = parseFloat(numMatch[1]);
                    const val2 = parseFloat(numMatch[2]);

                    if (val1 < val2 && val2 !== 0) {
                        seg.emit(numMatch[0], `${numMatch[1]}–${numMatch[2]}`, numMatch.index, "Change number range hyphen to endash");
                    }
                }

                // Loop 2: Equation Ranges
                eqRangePat.lastIndex = 0;
                let eqMatch;
                while ((eqMatch = eqRangePat.exec(seg.text)) !== null) {
                    const val1 = parseInt(eqMatch[1], 10);
                    const val2 = parseInt(eqMatch[2], 10);


                    seg.emit(eqMatch[0], `(${eqMatch[1]})–(${eqMatch[2]})`, eqMatch.index, "Change equation range hyphen to endash");

                }
            }


            // =========================================================
            // PART B: Scientific Names (Using Global makeAnchorEmitter)
            // =========================================================
            const scientificTerms = [
                "Keller-Segel", "parabolic-parabolic", "convection-diffusion",
                "Cauchy-Schwarz", "Gagliardo-Nirenberg-Ladyzhenskaya", "Vlasov-Poisson",
                "Navier-Stokes", "Runge-Kutta", "Gram-Schmidt", "Gauss-Radau",
                "inf-sup", "Raviart-Thomas", "advection-diffusion", "explicit-implicit",
                "Sherman-Morrison", "reaction-diffusion", "Petrov-Galerkin", "Crank-Nicolson",
                "Gauss-Lobatto", "local-nonlocal", "Euler-Maruyama", "accept-reject",
                "Fokker-Planck", "Vlasov-Poisson-Fokker-Planck", "Dirac-Frenkel",
                "Lie-Trotter", "micro-macro", "log-log", "Wigner-Poisson-Fokker-Planck",
                "Boltzmann-BGK", "Gauss-Legendre", "wetting-drying", "space-time",
                "Navier-Lamé", "Dirichlet-Neumann", "Lax-Milgram", "Whittle-Matérn",
                "Hilbert-Schmidt", "Burkholder-Davis-Gundy", "Borel-Cantelli",
                "advection-diffusion-reaction", "Hermite-Lagrange", "Lagrange-Hermite",
                "Moore-Penrose", "Vietnamese-Swiss", "Courant-Friedrichs-Lewy",
                "Richardson-Zaki", "solid-liquid", "gas-liquid", "Engquist-Osher",
                "Rankine-Hugoniot", "convection-diffusion-reaction", "Poincaré-Steklov",
                "Steklov-Rayleigh", "Neumann-Poincaré"
            ];

            const termsRegexStr = scientificTerms.map(t => t.replace(/-/g, '\\-')).join('|');
            const termPattern = new RegExp(`(?<![a-zA-ZÀ-ÿ])(?:${termsRegexStr})(?![a-zA-ZÀ-ÿ])`, 'gi');

            let termMatch;
            while ((termMatch = termPattern.exec(texFile)) !== null) {
                const originalText = termMatch[0];

                // Note: If you want standard Unicode '–' instead of '--' for named terms, 
                // swap out the line below with: const newText = originalText.replace(/-/g, '–');
                const newText = originalText.replace(/-/g, '--');

                emit(originalText, newText, termMatch.index, "Change scientific term hyphen to endash");
            }

            return staleIds;
        }
    },


    AbbreviationPlurals: {
        name: "Abbreviation in Plurals",
        description: "Standardize abbreviation plural form to match the document majority",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            const staleIds = new Set();

            // ── Step 1: Count both plural forms for every abbreviation ────────────
            //
            //   Apostrophe plural:  LED's
            //   Plain plural:       LEDs   (but NOT LEDs' — that's possessive plural)
            //
            // Pattern note: `(?!')` at the end of the plain pattern ensures
            // we don't accidentally match the start of `LEDs'some_word`.

            const apostrophePat = /\b([A-Z]{2,})'s\b/g;
            const plainPluralPat = /\b([A-Z]{2,})s\b(?!')/g;

            // abbr → { apostrophe: number, plain: number }
            const counts = new Map();

            const tally = (pat, key) => {
                pat.lastIndex = 0;
                let m;
                while ((m = pat.exec(texFile)) !== null) {
                    if (isCommented(texFile, m.index)) continue;
                    const abbr = m[1]; // e.g. "LED"
                    if (!counts.has(abbr)) counts.set(abbr, { apostrophe: 0, plain: 0 });
                    counts.get(abbr)[key]++;
                }
            };

            tally(apostrophePat, 'apostrophe');
            tally(plainPluralPat, 'plain');

            // ── Step 2: Decide what to flag for each abbreviation ─────────────────
            //
            //   Rules:
            //     • BOTH forms must exist (count > 0) — otherwise nothing to standardize
            //     • Tie counts → skip
            //     • Majority stays, minority gets flagged to match majority
            //
            // flagMap: abbr → { flagForm: 'apostrophe'|'plain' }
            //   flagForm = the MINORITY form we will emit suggestions for

            const flagMap = new Map();

            for (const [abbr, { apostrophe, plain }] of counts) {

                // One or both forms absent — nothing to compare
                if (apostrophe === 0 || plain === 0) continue;

                // Tie — no clear majority
                if (apostrophe === plain) continue;

                if (apostrophe > plain) {
                    // LED's × 3, LEDs × 1  →  flag plain (LEDs)  →  suggest LED's
                    flagMap.set(abbr, { flagForm: 'plain' });
                } else {
                    // LEDs × 3, LED's × 1  →  flag apostrophe (LED's)  →  suggest LEDs
                    flagMap.set(abbr, { flagForm: 'apostrophe' });
                }
            }

            // ── Step 3: Stale detection ───────────────────────────────────────────
            //
            //   An existing suggestion is stale when:
            //     a) The abbreviation no longer appears in flagMap at all
            //        (tie, one form removed, both forms removed)
            //     b) The majority direction has REVERSED
            //        e.g. anchor was LED's → LEDs (plain was majority)
            //        but now LED's is majority → anchor is wrong direction

            existingSuggestions.forEach((s) => {
                if ((s.styleInfo?.name ?? s.styleName) !== this.name) return;

                const orig = s.originalText ?? '';

                // Recover: was this anchor flagging an apostrophe form or a plain form?
                // LED's → wasApostrophe = true,  abbr = "LED"
                // LEDs  → wasApostrophe = false, abbr = "LED"
                const wasApostrophe = orig.includes("'s");
                const abbr = wasApostrophe
                    ? orig.slice(0, -2)   // remove "'s"  → "LED"
                    : orig.slice(0, -1);  // remove "s"   → "LED"

                const current = flagMap.get(abbr);

                if (!current) {
                    // No longer flagging this abbreviation (tie / one form disappeared)
                    staleIds.add(s.id);
                    return;
                }

                // Direction check — if majority flipped, the old anchor is wrong
                const nowFlagApostrophe = current.flagForm === 'apostrophe';
                if (wasApostrophe !== nowFlagApostrophe) {
                    staleIds.add(s.id);  // direction reversed → stale
                }
            });

            // ── Step 4: Emit suggestions ──────────────────────────────────────────

            const emit = makeAnchorEmitter({
                texFile, session, Range, anchorlist,
                existingSuggestions, staleIds,
                styleName: this.name,
                markerClass: this.markerClass,
                overlapMode: 'refresh',
            });

            for (const [abbr, { flagForm }] of flagMap) {

                if (flagForm === 'apostrophe') {
                    // Flag LED's  →  suggest LEDs
                    const pat = new RegExp(`\\b${abbr}'s\\b`, 'g');
                    let match;
                    while ((match = pat.exec(texFile)) !== null) {
                        if (isCommented(texFile, match.index)) continue;
                        emit(match[0], `${abbr}s`, match.index, this.description);
                    }

                } else {
                    // Flag LEDs  →  suggest LED's
                    const pat = new RegExp(`\\b${abbr}s\\b(?!')`, 'g');
                    let match;
                    while ((match = pat.exec(texFile)) !== null) {
                        if (isCommented(texFile, match.index)) continue;
                        emit(match[0], `${abbr}'s`, match.index, this.description);
                    }
                }
            }

            return staleIds;
        },
    },

    AbbreviationFirstOccurrence: {
        name: "Abbreviation First occurrence",
        description: "Replace subsequent occurrences of a defined abbreviation's full form with its short form",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            const staleIds = new Set();

            const SKIP_WORDS = new Set([
                'of', 'the', 'a', 'an', 'and', 'or', 'for',
                'in', 'on', 'at', 'to', 'with', 'by', 'from', 'as',
            ]);

            // ── Strip leading/trailing SKIP_WORDS from a captured phrase ──────────
            // "The World Wide Web"    → "World Wide Web"
            // "for Central Bureau of Investigation" → "Central Bureau of Investigation"
            function trimSkipWords(phrase) {
                const words = phrase.trim().split(/\s+/);
                let start = 0;
                let end = words.length - 1;
                while (start <= end && SKIP_WORDS.has(words[start].toLowerCase())) start++;
                while (end >= start && SKIP_WORDS.has(words[end].toLowerCase())) end--;
                return words.slice(start, end + 1).join(' ');
            }

            // ── Validates initials of significant words match the abbreviation ─────
            function initialsMatch(fullForm, abbr) {
                const initials = fullForm
                    .trim()
                    .split(/\s+/)
                    .filter(w => !SKIP_WORDS.has(w.toLowerCase()))
                    .map(w => (w[0] ?? '').toUpperCase())
                    .join('');
                return initials === abbr.toUpperCase();
            }

            // ── Definition pattern ─────────────────────────────────────────────────
            // wordChunk starts with [A-Z] — prevents lowercase words like "the",
            // "breakthroughs" from starting a phrase (avoids greedy overcapture)
            const SKIP_RE = [...SKIP_WORDS].join('|');
            const wordChunk = '[A-Z][a-zA-Z-]+';
            const gapChunk = `(?:\\s+(?:${SKIP_RE}))?`;
            const phraseRe = `${wordChunk}(?:${gapChunk}\\s+${wordChunk}){1,10}`;
            const defPat = new RegExp(`(${phraseRe})\\s*\\(([A-Z]{2,10})\\)`, 'g');

            // ── STEP 1: Find all definitions in entire document ────────────────────
            const definitions = new Map();

            let dm;
            while ((dm = defPat.exec(texFile)) !== null) {
                const rawForm = dm[1].trim();
                const abbr = dm[2];

                if (isCommented(texFile, dm.index)) {
                    defPat.lastIndex = dm.index + 1;
                    continue;
                }

                // ── Trim leading/trailing skip words BEFORE initialsMatch ─────────
                // "The World Wide Web" → "World Wide Web"
                const fullForm = trimSkipWords(rawForm);

                if (!initialsMatch(fullForm, abbr)) {
                    defPat.lastIndex = dm.index + 1;
                    continue;
                }

                if (definitions.has(abbr)) continue;

                // ── Find the REAL start of the trimmed fullForm in the file ───────
                // After trimming "The", defStart must point to "World", not "The"
                const trimmedStart = texFile.indexOf(fullForm, dm.index);
                if (trimmedStart === -1) continue; // safety

                definitions.set(abbr, {
                    fullForm,
                    defStart: trimmedStart,                    // "World Wide Web" start
                    defEnd: dm.index + dm[0].length,        // after closing ")"
                });
            }

            // ── STEP 2: Search entire document for subsequent occurrences ──────────
            const validIndices = new Map();

            definitions.forEach(({ fullForm, defStart, defEnd }, abbr) => {
                const escaped = fullForm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                const occPat = new RegExp(`\\b${escaped}\\b`, 'gi');

                let om;
                while ((om = occPat.exec(texFile)) !== null) {
                    const matchStart = om.index;
                    const matchEnd = matchStart + om[0].length;

                    // Skip the definition span itself
                    if (matchStart >= defStart && matchEnd <= defEnd) continue;

                    // Skip commented lines
                    if (isCommented(texFile, matchStart)) continue;

                    // Detect re-definition: "Full Form (ABBR)" again
                    const afterText = texFile.slice(matchEnd);
                    const reDefCheck = afterText.match(/^(\s*\([A-Z]{2,10}\))/);

                    if (reDefCheck) {
                        const originalText = texFile.slice(matchStart, matchEnd + reDefCheck[1].length);
                        validIndices.set(matchStart, { abbr, originalText });
                    } else {
                        const originalText = texFile.slice(matchStart, matchEnd);
                        validIndices.set(matchStart, { abbr, originalText });
                    }
                }
            });

            // ── Stale detection ────────────────────────────────────────────────────
            existingSuggestions.forEach((s) => {
                if ((s.styleInfo?.name ?? s.styleName) !== this.name) return;

                const row = s.startAnchor?.row ?? s.range?.start?.row ?? 0;
                const col = s.startAnchor?.column ?? s.range?.start?.column ?? 0;

                const lines = texFile.split('\n');
                let absIdx = 0;
                for (let i = 0; i < row; i++) absIdx += (lines[i]?.length ?? 0) + 1;
                absIdx += col;

                if (!validIndices.has(absIdx)) staleIds.add(s.id);
            });

            // ── Emit ───────────────────────────────────────────────────────────────
            const emit = makeAnchorEmitter({
                texFile, session, Range, anchorlist, existingSuggestions, staleIds,
                styleName: this.name,
                markerClass: this.markerClass,
                overlapMode: 'refresh',
            });

            validIndices.forEach(({ abbr, originalText }, absIndex) => {
                emit(originalText, abbr, absIndex, this.description);
            });

            return staleIds;
        },
    },


    Derivation: {
        name: "Derivation d to Roman",
        description: "Change d to \\mathrm{d}",
        markerClass: "ace-Common-highlight",
        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = [], rejectedSuggestions = []) {
            const staleIds = new Set();
            const context = buildStyleContext({
                texFile, session, Range, anchorlist, existingSuggestions, staleIds,
                styleName: this.name,
                markerClass: this.markerClass,
                scope: { wholeDocument: true },
                excludeMath: false, // We WANT to see inside $...$
                // excludeEnvironments: ['thebibliography']
                onlyMath: true
            });


            // const regex = /(?<!\\mathrm\{\s*|\\textrm\{\s*|\\text\{\s*)(?<!~|^|[a-zA-Z0-9])\bd([a-zA-z])\b(?!~)/g;
            const regex = /(?<!\\mathrm\{\s*|\\textrm\{\s*|\\text\{\s*)(?<!~|^|[a-zA-Z0-9])\bd(?![_])([a-zA-z])\b(?!~)/g;

            context.segments.forEach(seg => {
                let match;

                regex.lastIndex = 0;

                while ((match = regex.exec(seg.text)) !== null) {
                    const fullMatch = match[0]; // e.g., "dx"
                    const variable = match[1];  // e.g., "x"
                    const suggestion = `\\,\\mathrm{d}${variable}`;


                    seg.emit(
                        fullMatch,      // Original text found
                        suggestion,     // What to change it to
                        match.index,    // Local offset
                        `Standardize differential '${variable}' to roman type.` // Description
                    );
                }
            });
            return staleIds;
        }
    },
    exponential: {
        name: "exponential",
        description: "Standardize exponential 'e' to roman type.",
        markerClass: "ace-Common-highlight",
        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = [], rejectedSuggestions = []) {
            const staleIds = new Set();
            let { segments } = buildStyleContext({
                texFile, session, Range, anchorlist, staleIds, existingSuggestions,
                styleName: this.name,
                markerClass: this.markerClass,
                scope: { wholeDocument: true },
                excludeMath: false,
                onlyMath: true,
            });
            let pattern = /(?<!\\mathrm\{\s*)(?<!\\textrm\{\s*)(?<!\\text\{\s*)(?<!\\|~|[a-zA-Z0-9])\be\b(?=\^|[\+\-\=\/\)\s])(?!~)/g;

            for (let seg of segments) {
                let match;
                pattern.lastIndex = 0;
                while ((match = pattern.exec(seg.text)) !== null) {
                    seg.emit(match[0], '\\mathrm{e}', match.index, this.description);
                }
            }
            return staleIds;
        }
    },

    // imaginary: {
    //     name: "imaginary",
    //     description: "Standardize imaginary 'i' to roman type.",
    //     markerClass: "ace-Common-highlight",
    //     execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = [], rejectedSuggestions = []) {
    //         const staleIds = new Set();
    //         console.log("it is coming inside the segments of imaginary it is coming inside the funtion imaginary values")
    //         let { segments } = buildStyleContext({
    //             texFile, session, Range, anchorlist, staleIds, existingSuggestions,
    //             styleName: this.name,
    //             markerClass: this.markerClass,
    //             scope: { wholeDocument: true },
    //             excludeMath: false,
    //             onlyMath: true,
    //         });
    //         let pattern = /(?<!\\|~|[a-zA-Z]|_)\bi\b(?=\s|[\+\-\=\/\)\s]|\d)|(?<=\d)i\b/g;

    //         for (let seg of segments) {

    //             let match;
    //             pattern.lastIndex = 0;
    //             while ((match = pattern.exec(seg.text)) !== null) {
    //                 console.log("it is coming inside the segments of imaginary ", match[0])

    //                 seg.emit(match[0], '\\mathrm{i}', match.index, this.description);
    //             }
    //         }
    //         return staleIds;
    //     }
    // },

    // ScalarMultiplication: {
    //     name: "ScalarMultiplication",
    //     description: "Change explicit multiplication to implicit variable formatting inside parentheses.",
    //     markerClass: "ace-Common-highlight",

    //     execute(texFile, session, Range, anchorlist, fileName, Allfiles,
    //         existingSuggestions = [], rejectedSuggestions = []) {

    //         const staleIds = new Set();

    //         // 1. Configure the context to include math blocks and command tokens
    //         const { segments } = buildStyleContext({
    //             texFile, session, Range, anchorlist,
    //             existingSuggestions, staleIds,
    //             styleName: this.name,
    //             markerClass: this.markerClass,
    //             scope: { wholeDocument: true },
    //             excludeMath: false,        // CRITICAL: Must be false to read inside math mode
    //             excludeAllCommands: false, // CRITICAL: Must be false to read \times and \cdot
    //             excludeEnvironments: [],
    //         });

    //         // 2. Build a dynamic sequence pattern restricted by literal parentheses (...)
    //         // Matches a single letter variable optionally followed by ^ or _ modifiers (e.g., c^2, x_{i})
    //         const varPart = /[a-zA-Z](?:(?:\^|_)(?:\d+|[a-zA-Z0-9]|\{[^}]+\}))?/.source;
    //         const opPart = /\s*\\(?:times|cdot)\s*/.source;

    //         // FORCE PARENTHESES: Requires literal '(' at start and ')' at end, capturing the inner content
    //         const multiplicationPattern = new RegExp(`\\(\\s*(${varPart}(?:${opPart}${varPart})+)\\s*\\)`, 'gi');

    //         // 3. Iterate through text segments and apply updates
    //         for (const seg of segments) {
    //             multiplicationPattern.lastIndex = 0;
    //             let match;

    //             while ((match = multiplicationPattern.exec(seg.text)) !== null) {
    //                 const originalText = match[0]; // Entire match including parentheses, e.g., "(a \times b)"
    //                 const innerContent = match[1]; // Captured group matching inside the parentheses, e.g., "a \times b"

    //                 // Strip out all explicit operators and extra spacing from the inside content
    //                 const cleanInner = innerContent.replace(/\s*\\(?:times|cdot)\s*/gi, '');

    //                 // Reconstruct the replacement string with the wrapping parentheses preserved
    //                 const newText = `(${cleanInner})`;

    //                 if (originalText !== newText) {
    //                     seg.emit(
    //                         originalText,
    //                         newText,
    //                         match.index,
    //                         this.description
    //                     );
    //                 }
    //             }
    //         }

    //         return staleIds;
    //     }
    // },

    nameCapitalize: {
        name: "Capitalize Names",
        description: "Capitalize each word of the author name",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles,
            existingSuggestions = [], rejectedSuggestions = []) {

            const staleIds = new Set();

            // ── Helper: capitalize plain text words only ──
            function capitalizeWords(str) {
                return str
                    .split(' ')
                    .map(w => {
                        if (w.startsWith('\\')) return w;
                        if (w.length === 0) return w;
                        if (w.toLowerCase() === 'and') return 'and';
                        return w.charAt(0).toUpperCase() + w.slice(1);
                    })
                    .join(' ');
            }

            // ── Helper: extract content inside balanced braces ──
            function extractBraceContent(text, openBraceIndex) {
                let depth = 1, i = openBraceIndex + 1, content = '';
                while (i < text.length && depth > 0) {
                    if (text[i] === '{') depth++;
                    else if (text[i] === '}') { depth--; if (depth === 0) break; }
                    content += text[i]; i++;
                }
                return { content, endIndex: i };
            }

            // ── Use buildStyleContext scoped to \author command only ──
            const { emitSuggestion } = buildStyleContext({
                texFile, session, Range, anchorlist,
                existingSuggestions, staleIds,
                styleName: this.name,
                markerClass: this.markerClass,

                // Scope only to \author{...} blocks
                scope: { commands: ['author'] },

                // Do NOT exclude math or commands globally —
                // we handle tag filtering manually below
                excludeMath: false,
                excludeAllCommands: false,
            });

            // ── Main: scan every \author{...} in the file ──
            const authorPattern = /\\author\s*(?:\[[^\]]*\])?\s*\{/gi;
            let match;

            while ((match = authorPattern.exec(texFile)) !== null) {
                const authorOpenBrace = match.index + match[0].length - 1;
                const { content: authorContent } = extractBraceContent(texFile, authorOpenBrace);

                // ── CASE 1: \givenname{...} and \surname{...} exist ──
                const namedTagPattern = /\\(givenname|surname)\s*\{/gi;
                namedTagPattern.lastIndex = 0;
                let namedMatch;
                let foundNamedTags = false;

                while ((namedMatch = namedTagPattern.exec(authorContent)) !== null) {
                    foundNamedTags = true;

                    const tagName = namedMatch[1];
                    // Absolute position of this \givenname or \surname in texFile
                    const tagAbsStart = authorOpenBrace + 1 + namedMatch.index;
                    const openBrace = tagAbsStart + namedMatch[0].length - 1;

                    const { content: nameContent, endIndex: nameEndIndex } =
                        extractBraceContent(texFile, openBrace);

                    const capitalized = capitalizeWords(nameContent);
                    if (capitalized === nameContent) continue; // already correct

                    const fullTag = texFile.slice(tagAbsStart, nameEndIndex + 1);
                    const suggested = `\\${tagName}{${capitalized}}`;

                    // Emit anchor only on \givenname{...} or \surname{...}
                    emitSuggestion(fullTag, suggested, tagAbsStart, this.description);
                }

                if (foundNamedTags) continue; // CASE 1 handled — skip CASE 2

                // ── CASE 2: Plain name before any LaTeX command ──
                // e.g. \author{Elise grosjec \hyperlink{aff1}}
                //       → target only "Elise grosjec"
                const plainNameMatch = authorContent.match(/^([^\\}]+)/);
                if (!plainNameMatch) continue;

                const plainText = plainNameMatch[1].trimEnd();
                const capitalized = capitalizeWords(plainText);
                if (capitalized === plainText) continue; // already correct

                // Absolute position: right after the opening '{' of \author{
                const plainAbsStart = authorOpenBrace + 1;

                // Emit anchor only on the plain name portion
                emitSuggestion(plainText, capitalized, plainAbsStart, this.description);
            }

            return staleIds;
        }
    },

    // sectionHeading: {
    //     name: "Section Heading Casing",
    //     description: "Section/chapter → Sentence Case; subsection/subsubsection → Sentence case. Preserves LaTeX commands and math.",
    //     markerClass: "ace-Common-highlight",

    //     execute(texFile, session, Range, anchorlist,
    //         fileName, Allfiles,
    //         existingSuggestions = [],
    //         rejectedSuggestions = []) {

    //         const staleIds = new Set();

    //         const emit = makeAnchorEmitter({
    //             texFile,
    //             session,
    //             Range,
    //             anchorlist,
    //             existingSuggestions,
    //             staleIds,
    //             styleName: this.name,
    //             markerClass: this.markerClass,
    //             overlapMode: 'simple',
    //         });


    //         const headingPat = /\\((?:sub)*section|chapter|paragraph|subparagraph)\s*(\*?)\s*\{/gi;
    //         let match;

    //         while ((match = headingPat.exec(texFile)) !== null) {
    //             if (isCommented(texFile, match.index)) continue;

    //             const cmdName = match[1].toLowerCase();
    //             const starSuffix = match[2];


    //             const isTitleCase = (cmdName === 'section');

    //             let depth = 1, i = match.index + match[0].length, content = '';
    //             while (i < texFile.length && depth > 0) {
    //                 if (texFile[i] === '{') depth++;
    //                 else if (texFile[i] === '}') { depth--; if (depth === 0) break; }
    //                 content += texFile[i]; i++;
    //             }

    //             const fullMatch = texFile.slice(match.index, i + 1);
    //             const commandPart = `\\${cmdName}${starSuffix}{`;
    //             console.log("the cmdname and the starsSuffix is:", cmdName, "the starsSuffix is:", starSuffix, "the content is:", content);

    //             if (cmdName === "section") {

    //                 let newContent = HeadingSentenceCase(content).trim();

    //                 // 2. Check if the string ends with a period
    //                 if (newContent.endsWith(".")) {
    //                     newContent = newContent.slice(0, -1); // Removes the last character
    //                 }
    //                 const suggestion = `${commandPart}${newContent}}`;
    //                 if (fullMatch === suggestion) continue;


    //                 emit(
    //                     fullMatch,
    //                     suggestion,
    //                     match.index,
    //                     this.description,
    //                 );

    //             } else {
    //                 const newContent = HeadingSentenceCase(content);
    //                 const suggestion = `${commandPart}${newContent}}`;
    //                 if (fullMatch === suggestion) continue;
    //                 // Anchor on the full heading block — absIndex = start of \command
    //                 emit(
    //                     fullMatch,          // originalText
    //                     suggestion,         // suggestionText
    //                     match.index,        // absIndex — start of \section / \subsection / etc.
    //                     this.description,   // shown in suggestion sidebar
    //                 );
    //             }
    //         }

    //         return staleIds;
    //     }
    // },

    // sectionHeading: {
    //     name: "Section Heading Casing",
    //     description: "Section/chapter → Sentence Case; subsection/subsubsection → Sentence case. Preserves LaTeX commands and math.",
    //     markerClass: "ace-Common-highlight",

    //     execute(texFile, session, Range, anchorlist,
    //         fileName, Allfiles,
    //         existingSuggestions = [],
    //         rejectedSuggestions = []) {

    //         const staleIds = new Set();


    //         const abbrFullForms = new Map();
    //         {
    //             const SKIP_WORDS = new Set([
    //                 'of', 'the', 'a', 'an', 'and', 'or', 'for',
    //                 'in', 'on', 'at', 'to', 'with', 'by', 'from', 'as',
    //             ]);
    //             const SKIP_RE = [...SKIP_WORDS].join('|');
    //             const wordChunk = '[A-Z][a-zA-Z-]+';
    //             const gapChunk = `(?:\\s+(?:${SKIP_RE}))?`;
    //             const phraseRe = `${wordChunk}(?:${gapChunk}\\s+${wordChunk}){1,10}`;
    //             const defPat = new RegExp(`(${phraseRe})\\s*\\(([A-Z]{2,10})\\)`, 'g');

    //             function trimSkipWords(phrase) {
    //                 const words = phrase.trim().split(/\s+/);
    //                 let s = 0, e = words.length - 1;
    //                 while (s <= e && SKIP_WORDS.has(words[s].toLowerCase())) s++;
    //                 while (e >= s && SKIP_WORDS.has(words[e].toLowerCase())) e--;
    //                 return words.slice(s, e + 1).join(' ');
    //             }

    //             function initialsMatch(fullForm, abbr) {
    //                 return fullForm.trim().split(/\s+/)
    //                     .filter(w => !SKIP_WORDS.has(w.toLowerCase()))
    //                     .map(w => (w[0] ?? '').toUpperCase())
    //                     .join('') === abbr.toUpperCase();
    //             }

    //             let dm;
    //             while ((dm = defPat.exec(texFile)) !== null) {
    //                 if (isCommented(texFile, dm.index)) continue;
    //                 const fullForm = trimSkipWords(dm[1].trim());
    //                 const abbr = dm[2];
    //                 if (!initialsMatch(fullForm, abbr)) continue;
    //                 if (abbrFullForms.has(fullForm.toLowerCase())) continue; // first def wins
    //                 abbrFullForms.set(fullForm.toLowerCase(), fullForm);
    //             }
    //         }


    //         function restoreAbbrForms(text) {
    //             let result = text;
    //             for (const [lowerForm, originalForm] of abbrFullForms) {
    //                 const escaped = lowerForm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    //                 const re = new RegExp(`\\b${escaped}\\b`, 'gi');
    //                 result = result.replace(re, originalForm);
    //             }
    //             return result;
    //         }


    //         const emit = makeAnchorEmitter({
    //             texFile, session, Range, anchorlist, existingSuggestions, staleIds,
    //             styleName: this.name,
    //             markerClass: this.markerClass,
    //             overlapMode: 'simple',
    //         });

    //         const headingPat = /\\((?:sub)*section|chapter|paragraph|subparagraph)\s*(\*?)\s*\{/gi;
    //         let match;

    //         while ((match = headingPat.exec(texFile)) !== null) {
    //             if (isCommented(texFile, match.index)) continue;

    //             const cmdName = match[1].toLowerCase();
    //             const starSuffix = match[2];
    //             const isTitleCase = (cmdName === 'section');

    //             let depth = 1, i = match.index + match[0].length, content = '';
    //             while (i < texFile.length && depth > 0) {
    //                 if (texFile[i] === '{') depth++;
    //                 else if (texFile[i] === '}') { depth--; if (depth === 0) break; }
    //                 content += texFile[i]; i++;
    //             }

    //             if (content === content.toLowerCase()) continue;

    //             const fullMatch = texFile.slice(match.index, i + 1);
    //             const commandPart = `\\${cmdName}${starSuffix}{`;

    //             if (cmdName === 'section') {
    //                 let newContent = HeadingSentenceCase(content).trim();
    //                 if (newContent.endsWith('.')) newContent = newContent.slice(0, -1);


    //                 newContent = restoreAbbrForms(newContent);

    //                 const suggestion = `${commandPart}${newContent}}`;
    //                 if (fullMatch === suggestion) continue;
    //                 emit(fullMatch, suggestion, match.index, this.description);

    //             } else {
    //                 let newContent = HeadingSentenceCase(content);


    //                 newContent = restoreAbbrForms(newContent);

    //                 const suggestion = `${commandPart}${newContent}}`;
    //                 if (fullMatch === suggestion) continue;
    //                 emit(fullMatch, suggestion, match.index, this.description);
    //             }
    //         }

    //         return staleIds;
    //     }
    // },


    sectionHeading: {
        name: "Section Heading Casing",
        description: "Section/chapter → Sentence Case; subsection/subsubsection → Sentence case. Preserves LaTeX commands and math.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {

            const staleIds = new Set();


            const abbrFullForms = new Map();
            {
                const SKIP_WORDS = new Set([
                    'of', 'the', 'a', 'an', 'and', 'or', 'for',
                    'in', 'on', 'at', 'to', 'with', 'by', 'from', 'as',
                ]);
                const SKIP_RE = [...SKIP_WORDS].join('|');
                const wordChunk = '[A-Z][a-zA-Z-]+';
                const gapChunk = `(?:\\s+(?:${SKIP_RE}))?`;
                const phraseRe = `${wordChunk}(?:${gapChunk}\\s+${wordChunk}){1,10}`;
                const defPat = new RegExp(`(${phraseRe})\\s*\\(([A-Z]{2,10})\\)`, 'g');

                function trimSkipWords(phrase) {
                    const words = phrase.trim().split(/\s+/);
                    let s = 0, e = words.length - 1;
                    while (s <= e && SKIP_WORDS.has(words[s].toLowerCase())) s++;
                    while (e >= s && SKIP_WORDS.has(words[e].toLowerCase())) e--;
                    return words.slice(s, e + 1).join(' ');
                }

                function initialsMatch(fullForm, abbr) {
                    return fullForm.trim().split(/\s+/)
                        .filter(w => !SKIP_WORDS.has(w.toLowerCase()))
                        .map(w => (w[0] ?? '').toUpperCase())
                        .join('') === abbr.toUpperCase();
                }

                let dm;
                while ((dm = defPat.exec(texFile)) !== null) {
                    if (isCommented(texFile, dm.index)) continue;
                    const fullForm = trimSkipWords(dm[1].trim());
                    const abbr = dm[2];
                    if (!initialsMatch(fullForm, abbr)) continue;
                    if (abbrFullForms.has(fullForm.toLowerCase())) continue; // first def wins
                    abbrFullForms.set(fullForm.toLowerCase(), fullForm);
                }
            }


            function restoreAbbrForms(text) {
                let result = text;
                for (const [lowerForm, originalForm] of abbrFullForms) {
                    const escaped = lowerForm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                    const re = new RegExp(`\\b${escaped}\\b`, 'gi');
                    result = result.replace(re, originalForm);
                }
                return result;
            }


            const emit = makeAnchorEmitter({
                texFile, session, Range, anchorlist, existingSuggestions, staleIds,
                styleName: this.name,
                markerClass: this.markerClass,
                overlapMode: 'simple',
            });

            const headingPat = /\\((?:sub)*section|chapter|paragraph|subparagraph)\s*(\*?)\s*\{/gi;
            let match;

            while ((match = headingPat.exec(texFile)) !== null) {
                if (isCommented(texFile, match.index)) continue;

                const cmdName = match[1].toLowerCase();
                const starSuffix = match[2];
                const isTitleCase = (cmdName === 'section');

                let depth = 1, i = match.index + match[0].length, content = '';
                while (i < texFile.length && depth > 0) {
                    if (texFile[i] === '{') depth++;
                    else if (texFile[i] === '}') { depth--; if (depth === 0) break; }
                    content += texFile[i]; i++;
                }

                // if (content === content.toLowerCase()) continue;

                const fullMatch = texFile.slice(match.index, i + 1);
                const commandPart = `\\${cmdName}${starSuffix}{`;

                if (cmdName === 'section') {
                    let newContent = HeadingSentenceCase(content).trim();
                    if (newContent.endsWith('.')) newContent = newContent.slice(0, -1);


                    newContent = restoreAbbrForms(newContent);

                    const suggestion = `${commandPart}${newContent}}`;
                    if (fullMatch === suggestion) continue;
                    emit(fullMatch, suggestion, match.index, this.description);

                } else {
                    let newContent = HeadingSentenceCase(content);


                    newContent = restoreAbbrForms(newContent);

                    const suggestion = `${commandPart}${newContent}}`;
                    if (fullMatch === suggestion) continue;
                    emit(fullMatch, suggestion, match.index, this.description);
                }
            }

            return staleIds;
        }
    },


    quotation: {
        name: "Replace Quotation",
        description: "Replace paired single quotes with double quotes and strip inner LaTeX formatting.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles,
            existingSuggestions = [], rejectedSuggestions = []) {

            const staleIds = new Set();
            const self = this;
            const { segments } = buildStyleContext({
                texFile, session, Range, anchorlist,
                existingSuggestions, staleIds,
                styleName: self.name,
                markerClass: self.markerClass,
                scope: { wholeDocument: true },
                excludeMath: true,
                excludeAllCommands: false,
                excludeEnvironments: ['thebibliography']
            });

            function stripFormatting(text) {
                let result = text;
                const pat = /\\(?:textit|textbf|textsc|textsl|emph)\s*\{/gi;
                let match;

                while ((match = pat.exec(result)) !== null) {
                    let startIdx = match.index;
                    let innerStartIdx = startIdx + match[0].length;
                    let depth = 1;
                    let i = innerStartIdx;
                    while (i < result.length && depth > 0) {
                        if (result[i] === '{') depth++;
                        if (result[i] === '}') depth--;
                        i++;
                    }
                    if (depth === 0) {
                        let endIdx = i;
                        let innerText = result.slice(innerStartIdx, endIdx - 1);
                        result = result.slice(0, startIdx) + innerText + result.slice(endIdx);
                        pat.lastIndex = 0;
                    } else {
                        break;
                    }
                }
                return result;
            }
            const quotePattern = /(?:^|[\s\(\[\{])'(.*?)'(?=$|[\s\)\!\?\,\.\}\]])/gm;

            for (const seg of segments) {

                quotePattern.lastIndex = 0;
                let match;

                while ((match = quotePattern.exec(seg.text)) !== null) {
                    let fullMatch = match[0];
                    let content = match[1];

                    const leadingCharMatch = fullMatch.match(/^[^\']/);
                    const leadingChar = leadingCharMatch ? leadingCharMatch[0] : "";

                    let targetText = fullMatch;
                    let targetIndex = match.index;

                    if (leadingChar) {
                        targetText = fullMatch.slice(1);
                        targetIndex = match.index + 1;
                    }

                    let cleanedContent = stripFormatting(content);

                    const suggestion = `"${cleanedContent}"`;
                    seg.emit(targetText, suggestion, targetIndex, self.description);
                }
            }

            return staleIds;
        }
    },

    // unitfont: {
    //     name: "Unit Fonts",
    //     description: "Units must be in roman (\\mathrm) with a non-breaking space.",
    //     markerClass: "ace-Common-highlight",
    //     execute(texFile, session, Range, anchorlist, fileName, Allfile, existingSuggestions = [], rejectedSuggestions = []) {
    //         const staleIds = new Set();

    //         // 1. Build context targeting ONLY math environments
    //         const { segments } = buildStyleContext({
    //             texFile, session, Range, anchorlist,
    //             existingSuggestions, staleIds,
    //             styleName: this.name,
    //             markerClass: this.markerClass,
    //             scope: { wholeDocument: true },
    //             // onlyMath: ['$', '\\['],   // specific math kinds
    //             onlyMath: true,      // Restrict search to $...$, \[...\], equations, etc.
    //             excludeMath: false,
    //         });

    //         // 2. Updated Regex: Looks for a number followed by a unit
    //         const pattern = /(\d+\s?~*\.*)(m\.s|kg\.m|s|A|K|mol|cd|C|V|Ω|T|Wb|J|W|Pa|Hz|GHz|rad|sr|N|Wb|F|S|H|eV|u|Lx|lm|lx|Bq|Gy|Sv|kat|dB|kg|mm|m)(?!\w)/gm;

    //         // 3. Loop through segments
    //         for (const seg of segments) {
    //             pattern.lastIndex = 0; // Reset regex state for each segment
    //             let match;

    //             while ((match = pattern.exec(seg.text)) !== null) {
    //                 const fullMatch = match[0];
    //                 const num = match[1];
    //                 const unit = match[2];

    //                 // 4. Create the suggestion: Number + Non-breaking space + \mathrm{unit}
    //                 const suggestion = `${num}\u00A0\\mathrm{${unit}}`;

    //                 // 5. Emit using segment's local index
    //                 seg.emit(fullMatch, suggestion, match.index, this.description);
    //             }
    //         }

    //         return staleIds;
    //     }
    // },

    // unitFormat: {
    //     name: "Unit Formatting",
    //     description: "Provides a non-breaking space between a number and a unit",
    //     markerClass: "ace-Common-highlight",

    //     execute(texFile, session, Range, anchorlist,
    //         fileName, Allfiles,
    //         existingSuggestions = [],
    //         rejectedSuggestions = []) {

    //         const staleIds = new Set();
    //         const emit = makeAnchorEmitter({
    //             texFile, session, Range, anchorlist, existingSuggestions, staleIds, styleName: this.name,
    //             markerClass: this.markerClass,
    //         });

    //         const pattern = /(\d+\$*\s?~*\.*)(m\.s|kg\.m|s|A|K|mol|cd|C|V|Ω|T|Wb|J|W|Pa|Hz|GHz|rad|sr|N|Wb|F|S|H|eV|u|Lx|lm|lx|Bq|Gy|Sv|kat|dB|kg|mm|m)(?!\w)/gm;
    //         let match;

    //         while ((match = pattern.exec(texFile)) !== null) {
    //             const fullMatch = match[0];
    //             const num = match[1];
    //             const unit = match[2];
    //             const suggestion = `${num}\u00A0\\mathrm{${unit}}`;
    //             emit(fullMatch, suggestion, match.index, this.description);
    //         }

    //         return staleIds;
    //     }
    // },


    latinPhrases: {
        name: "Latin Phrases Italics",
        description: "Convert latin phrases to italic format using \\emph, except etc which becomes roman.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles,
            existingSuggestions = [], rejectedSuggestions = []) {

            const staleIds = new Set();

            // 1. Build context using the framework
            const { segments } = buildStyleContext({
                texFile, session, Range, anchorlist,
                existingSuggestions, staleIds,
                styleName: this.name,
                markerClass: this.markerClass,
                scope: { wholeDocument: true },
                excludeMath: true,
                // We exclude all commands so we don't accidentally suggest 
                // wrapping something already inside \textit{...} or \emph{...}
                excludeAllCommands: true,
                excludeEnvironments: [
                    'frontmatter', 'abstract', 'table', 'tabular', 'figure',
                    'equation', 'align', 'align*', 'theorem', 'proposition',
                    'lemma', 'proof', 'thebibliography', 'itemize'
                ],
            });

            // 2. Define Patterns
            const latinPattern = /\b(ad hoc|ad hominem|a posteriori|a priori|bona fide|carpe diem|de facto|de jure|exempli gratia|e\.g\.?|id est|i\.e\.?|in situ|in vitro|in vivo|ipso facto|mea culpa|modus operandi|per se|pro bono|quid pro quo|status quo|vice versa|ad infinitum|terra firma|curriculum vitae|alma mater|alter ego|deus ex machina|casus belli|et al\.?|per annum|per capita|persona non grata|vox populi|post mortem|in medias res|tabula rasa|magnum opus|sic semper tyrannis|veni vidi vici|sub rosa)/gmi;
            const etcPattern = /\betc\.?\b/gi;

            // 3. Process Segments
            for (const seg of segments) {

                // Handle Latin Phrases -> \emph{}
                latinPattern.lastIndex = 0;
                let lMatch;
                while ((lMatch = latinPattern.exec(seg.text)) !== null) {
                    const fullMatch = lMatch[0];
                    seg.emit(
                        fullMatch,
                        `\\emph{${fullMatch}}`,
                        lMatch.index,
                        this.description
                    );
                }

                // Handle etc -> \textup{}
                etcPattern.lastIndex = 0;
                let eMatch;
                while ((eMatch = etcPattern.exec(seg.text)) !== null) {
                    const fullMatch = eMatch[0];
                    // Only suggest if it isn't already \textup{etc.}
                    if (fullMatch !== "\\textup{etc.}") {
                        seg.emit(
                            fullMatch,
                            `\\textup{etc.}`,
                            eMatch.index,
                            this.description
                        );
                    }
                }
            }

            return staleIds;
        }
    },



    replaceZeroBefore: {
        name: "Include Zero in Fraction",
        description: "Replace .5 to 0.5 — include 0 before fractions if missing.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {

            const staleIds = new Set();

            const { segments } = buildStyleContext({
                texFile, session, Range, anchorlist,
                existingSuggestions, staleIds,
                styleName: this.name,
                markerClass: this.markerClass,

                scope: { wholeDocument: true },
                excludeMath: true,
                excludeInner: ['url', 'href', 'verb', 'texttt'],
                excludeEnvironments: ['verbatim', 'lstlisting', 'minted'],
            });

            // Match a dot followed by digits ONLY when preceded by:
            //   - whitespace  (\s)
            //   - start of string (^)
            //   - an opening brace or bracket ({ [)
            //   - a tilde (non-breaking space in LaTeX: ~)
            //   - a comma or semicolon (list context)
            //
            // This deliberately EXCLUDES:
            //   - a letter before the dot  → A.2, Fig.3, Sec.1 are untouched
            //   - a digit before the dot   → 3.14 is already correct
            //   - a closing brace/bracket  → value} .5 would still match via \s
            //
            // The unit-word after the number (.5 km, .5 GHz) is fine: the match
            // is just the ".5" portion and the suggestion is "0.5"; the unit stays.
            const pattern = /(?<=[\s\~\,\;\(\[\{]|^)\.(\d+)/gm;

            for (const seg of segments) {
                pattern.lastIndex = 0;
                let m;
                while ((m = pattern.exec(seg.text)) !== null) {
                    const fullMatch = m[0];          // e.g. ".5"
                    const suggestion = `0${fullMatch}`;  // e.g. "0.5"

                    seg.emit(
                        fullMatch,
                        suggestion,
                        m.index,
                        this.description
                    );
                }
            }
            return staleIds;
        }
    },


    statementPlacement: {
        name: "Statement Placement",
        description: "Place statement values before reference and after acknowledgement.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();

            const ackRegex = /\\section\*?\{Acknowledgment\}[\s\S]*?(?=\\textcolor|\\section)/igm;
            const refRegex = /\\begin\{(thebibliography|bibliography)\}(\{\d+\})*/igm;
            const statementRegex = /(\\textcolor\{[^\}]*})?\{\\section\*?\{([^}]+)\}([\s\S]*?)(?=\\section|%*\\begin?\{thebibliography|bibliography\}|\\textcolor\{[^\}]*}\{?\\section)/gmsi;

            const order = [
                "Funding",
                "Conflicts of interest",
                "Data availability statement",
                "Author contribution statement",
                "Ethics approval",
                "Supplementary Material"
            ];

            // ── Collect all statements ──
            let tempFile = texFile;
            const statementsMap = {};

            tempFile = tempFile.replace(statementRegex, (match, _color, title, content) => {
                const key = title.trim().toLowerCase();
                statementsMap[key] = content.trim();
                return '';
            });

            const statementsBlock = order
                .map(title => {
                    const key = title.toLowerCase();
                    if (statementsMap[key]) {
                        return `\\section*{\\textbf{${title}}}\n${statementsMap[key]}`;
                    }
                    return null;
                })
                .filter(Boolean)
                .join('\n\n');

            if (!statementsBlock) return staleIds;

            // ── Find insertion point ──
            const ackMatch = tempFile.match(ackRegex);
            const refMatch = tempFile.match(refRegex);

            let insertIndex;
            if (ackMatch) {
                insertIndex = tempFile.indexOf(ackMatch[0]) + ackMatch[0].length;
            } else if (refMatch) {
                insertIndex = tempFile.indexOf(refMatch[0]);
            } else {
                insertIndex = tempFile.length;
            }

            const suggestion = tempFile.slice(0, insertIndex) +
                '\n\n' + statementsBlock + '\n\n' +
                tempFile.slice(insertIndex);

            if (texFile === suggestion) return staleIds;

            // ── Anchor the entire document as one replacement ──
            const position = {
                startRow: 0,
                startCol: 0,
                endRow: texFile.split('\n').length - 1,
                endCol: texFile.split('\n').pop().length
            };

            if (isRejectedByLivePosition(position, this.name, texFile)) return staleIds;

            const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
            if (overlapping.length > 0) {
                overlapping.forEach(old => staleIds.add(old.id));
            } else {
                if (isAlreadyAnchored(position, this.name, existingSuggestions)) return staleIds;
            }

            createAnchor(session, Range, position,
                texFile, suggestion,
                this.markerClass, this.name, this.description, anchorlist);

            return staleIds;
        }
    },

    ReferenceCompleteness: {
        name: "Check Reference Completeness",
        description: "Check if reference is complete (authors, title, journal, volume, pages, year).",
        markerClass: "ace-common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = [], rejectedSuggestions = []) {
            if (!texFile) return new Set();

            const staleIds = new Set();
            existingSuggestions.forEach(s => {
                if (s.styleInfo?.name === this.name) staleIds.add(s.id);
            });
            function hasField(text, cmdName) {
                const re = new RegExp(`\\\\${cmdName}\\s*\\{`, "i");
                const m = re.exec(text);
                if (!m) return false;
                // walk braces to confirm content exists
                let depth = 1, i = m.index + m[0].length, hasContent = false;
                while (depth > 0 && i < text.length) {
                    if (text[i] === "{") depth++;
                    else if (text[i] === "}") { depth--; if (depth === 0) break; }
                    else if (depth === 1 && text[i].trim() !== "") hasContent = true;
                    i++;
                }
                return hasContent;
            }
            function hasAuthor(text) {
                return hasField(text, "Refauthor");
            }
            function hasPublisher(text) {
                return hasField(text, "Refpubname") || hasField(text, "Refpubloc");
            }

            const requiredFields = {
                refjrnl: [
                    { label: "Author (\\Refauthor)", check: t => hasAuthor(t) },
                    { label: "Year (\\Refyear)", check: t => hasField(t, "Refyear") },
                    { label: "Article title (\\Refatit)", check: t => hasField(t, "Refatit") },
                    { label: "Journal title (\\Refjtit)", check: t => hasField(t, "Refjtit") },
                    { label: "Volume (\\Refvol)", check: t => hasField(t, "Refvol") },
                    { label: "Pages (\\Refpages)", check: t => hasField(t, "Refpages") },
                ],
                refbook: [
                    { label: "Author (\\Refauthor)", check: t => hasAuthor(t) },
                    { label: "Year (\\Refyear)", check: t => hasField(t, "Refyear") },
                    { label: "Book title (\\Refbtit)", check: t => hasField(t, "Refbtit") },
                    { label: "Publisher (\\Refpubname)", check: t => hasPublisher(t) },
                ],
                refedbk: [
                    { label: "Author (\\Refauthor)", check: t => hasAuthor(t) },
                    { label: "Year (\\Refyear)", check: t => hasField(t, "Refyear") },
                    { label: "Chapter title (\\Refchaptit)", check: t => hasField(t, "Refchaptit") },
                    { label: "Book title (\\Refbtit)", check: t => hasField(t, "Refbtit") },
                    { label: "Pages (\\Refpages)", check: t => hasField(t, "Refpages") },
                    { label: "Publisher (\\Refpubloc)", check: t => hasPublisher(t) },
                ],
                refthesis: [
                    { label: "Author (\\Refauthor)", check: t => hasAuthor(t) },
                    { label: "Year (\\Refyear)", check: t => hasField(t, "Refyear") },
                    { label: "Thesis title (\\Refchaptit)", check: t => hasField(t, "Refchaptit") },
                    { label: "Thesis type (\\Refcomment)", check: t => hasField(t, "Refcomment") },
                    { label: "Institution (\\Refpubname)", check: t => hasPublisher(t) },
                ],
                refother: [
                    { label: "Author (\\Refauthor)", check: t => hasAuthor(t) },
                    { label: "Year (\\Refyear)", check: t => hasField(t, "Refyear") },
                    { label: "Title (\\Refatit)", check: t => hasField(t, "Refatit") },
                    { label: "Publisher (\\Refpubloc)", check: t => hasPublisher(t) },
                ],
            };


            const bibitemPattern = /\\bibitem\{([^}]*)\}([\s\S]*?)(?=\\bibitem|\\end\{thebibliography\})/gi;
            const envBlockPattern = /\\begin\{(refjrnl|refbook|refthesis|refother|refedbk)\}([\s\S]*?)\\end\{\1\}/gi;
            const bibliographyPattern = /\\begin\{thebibliography\}([\s\S]*?)\\end\{thebibliography\}/gi;

            const ctx = buildStyleContext({
                texFile, session, Range, anchorlist,
                existingSuggestions, staleIds,
                styleName: this.name,
                markerClass: this.markerClass,
                scope: { wholeDocument: true },
                excludeMath: false,
                mode: 'query',
                overlapMode: 'refresh',
            });

            ctx.segments.forEach(seg => {
                let bibMatch;
                bibitemPattern.lastIndex = 0;

                while ((bibMatch = bibitemPattern.exec(seg.text)) !== null) {
                    const fullMatch = bibMatch[0];
                    const bibKey = bibMatch[1];
                    const absIndex = seg.absStart + bibMatch.index;

                    if (isCommented(texFile, absIndex)) continue;


                    envBlockPattern.lastIndex = 0;
                    const envMatch = envBlockPattern.exec(fullMatch);
                    if (!envMatch) continue;

                    const envType = envMatch[1];
                    const envContent = envMatch[0];
                    const envStart = absIndex + envMatch.index;

                    const rules = requiredFields[envType];
                    if (!rules) continue;

                    const missing = rules
                        .filter(rule => !rule.check(envContent))
                        .map(rule => rule.label);

                    if (missing.length === 0) continue;

                    ctx.emitQuery(
                        envContent,
                        `Reference "${bibKey}" is incomplete.`,
                        envStart,
                        `This ${envType} entry is missing: ${missing.join(", ")}.`
                    );
                }
            });

            return staleIds;
        }
    },

    ReferenceFormatting: {
        name: "Reference Formatting",
        description: "Reference section year, title, volume, pages, journal title etc.",
        markerClass: "ace-Common-highlight",
        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = [], rejectedSuggestions = []) {
            try {

                // ── helpers ──────────────────────────────────────────────────────────────

                function getContentInsideBrace(src, i) {
                    let content = "", depth = 1;
                    while (depth > 0 && i < src.length) {
                        if (src[i] === "{") depth++;
                        else if (src[i] === "}") { depth--; if (depth === 0) break; }
                        content += src[i++];
                    }
                    return content;
                }


                function stripCmd(s, cmd) {
                    const re = new RegExp(`^\\\\${cmd}\\{([\\s\\S]*)\\}$`);
                    const mt = s.match(re);
                    return mt ? mt[1] : null;
                }

                function hasCmd(s, cmd) {
                    return new RegExp(`\\\\${cmd}\\{`).test(s);
                }

                // Extract bare 4-digit year from any form
                function extractYear(s) {
                    const m = s.match(/(\d{4})/);
                    return m ? m[1] : null;
                }

                // Extract bare page range digits with -- separator from any form e.g "3-25" "3--25." "3--25,"
                function extractPageRange(s) {
                    const m = s.match(/(\d+)\s*-{1,2}\s*(\d+)/);
                    return m ? `${m[1]}--${m[2]}` : null;
                }

                // Extract bare volume/number from \textbf{15} or just 15
                function extractVolNum(s) {
                    const fromBf = stripCmd(s.trim(), "textbf");
                    if (fromBf !== null) return fromBf.trim();
                    const m = s.match(/^(\d+)$/);
                    return m ? m[1] : null;
                }

                // ── expected-value functions per env ─────────────────────────────────────

                const expected = {
                    // \Refyear
                    Refyear: {
                        refjrnl: y => `(${y})`,
                        refbook: y => `(${y}).`,
                        refedbk: y => `(${y})`,
                        refthesis: y => `(${y}).`,
                        refother: y => `(${y}).`,
                    },
                    // \Refvol  — only refjrnl uses it
                    Refvol: {
                        refjrnl: v => `\\textbf{${v}}`,
                    },
                    // \Refpages — refjrnl + refedbk
                    Refpages: {
                        refjrnl: r => `${r}.`,
                        refedbk: r => `${r}.`,
                    },
                    // \Refjtit — refjrnl: \textit{Abbrev.}
                    Refjtit: {
                        refjrnl: inner => {
                            // inner should be \textit{something}
                            // Just check it is wrapped in \textit{}
                            return `\\textit{${stripCmd(inner.trim(), "textit") ?? inner.trim()}}`;
                        }
                    },
                    // \Refatit — refjrnl: plain Roman, dot at end
                    //            refother: \textit{...}.
                    Refatit: {
                        refjrnl: inner => {
                            // Remove any \textit or \textbf wrapper, ensure dot at end
                            let t = stripCmd(inner.trim(), "textit") ?? stripCmd(inner.trim(), "textbf") ?? inner.trim();
                            if (!t.endsWith(".")) t = t + ".";
                            return t;
                        },
                        refother: inner => {
                            let t = stripCmd(inner.trim(), "textit") ?? inner.trim();
                            if (!t.endsWith(".")) t = t + ".";
                            return `\\textit{${t}}`;
                        }
                    },
                    // \Refbtit
                    Refbtit: {
                        // refbook: \textit{Title}, — italic + trailing comma
                        refbook: inner => {
                            let t = stripCmd(inner.trim(), "textit") ?? inner.trim();
                            t = t.replace(/[,.]$/, ""); // strip any trailing comma/dot
                            return `\\textit{${t}},`;
                        },
                        // refedbk: In: \textit{Title}.
                        refedbk: inner => {
                            // strip leading "In:" or "in:" if already there to normalise
                            let t = inner.trim().replace(/^[Ii]n:\s*/, "");
                            t = stripCmd(t, "textit") ?? t;
                            t = t.replace(/[,.]$/, "");
                            return `In: \\textit{${t}}.`;
                        }
                    },
                    // \Refchaptit
                    Refchaptit: {
                        // refedbk: plain Roman, trailing comma
                        refedbk: inner => {
                            let t = stripCmd(inner.trim(), "textit") ?? inner.trim();
                            t = t.replace(/[,.]$/, "");
                            return `${t},`;
                        },
                        // refthesis: \textit{...}.
                        refthesis: inner => {
                            let t = stripCmd(inner.trim(), "textit") ?? inner.trim();
                            t = t.replace(/[,.]$/, "");
                            if (!t.endsWith(".")) t = t + ".";
                            return `\\textit{${t}}`;
                        }
                    },
                    // \Refedition — refbook: "1st edition." full word + dot
                    Refedition: {
                        refbook: inner => {
                            // normalise: extract ordinal + ensure "edition" not "ed."
                            let t = inner.trim().replace(/[,.]$/, "");
                            t = t.replace(/\bed\b\.?/i, "edition");
                            if (!t.endsWith(".")) t = t + ".";
                            return t;
                        }
                    },
                    // \Refseries — refbook: trailing comma
                    Refseries: {
                        refbook: inner => {
                            let t = inner.trim().replace(/[,.]$/, "");
                            return `${t},`;
                        }
                    },
                    // \Refcomment — refthesis: "Ph.D. thesis,"
                    Refcomment: {
                        refthesis: inner => {
                            let t = inner.trim().replace(/[,.]$/, "");
                            // normalise PhD / PhD. / phd -> Ph.D.
                            t = t.replace(/\bPhD\.?\b/gi, "Ph.D.").replace(/\bphd\.?\b/gi, "Ph.D.");
                            // ensure ends with comma
                            if (!t.endsWith(",")) t = t + ",";
                            return t;
                        }
                    }
                };

                // Fields to check and their extractor (what to pull out of innerContent)
                // extractor returns the "canonical comparable value" from raw inner text
                // so we can call expected[field][env](canonicalValue)
                const fieldExtractors = {
                    Refyear: extractYear,
                    Refvol: extractVolNum,
                    Refpages: extractPageRange,
                    Refjtit: s => s.trim(),   // pass as-is; expected fn normalises
                    Refatit: s => s.trim(),
                    Refbtit: s => s.trim(),
                    Refchaptit: s => s.trim(),
                    Refedition: s => s.trim(),
                    Refseries: s => s.trim(),
                    Refcomment: s => s.trim(),
                };

                // ── main scan ─────────────────────────────────────────────────────────────

                const staleIds = new Set();
                const emit = makeAnchorEmitter({
                    texFile, session, Range, anchorlist,
                    existingSuggestions, staleIds,
                    styleName: this.name,
                    markerClass: this.markerClass,
                    overlapMode: 'simple'
                });

                const bibliographyPattern = /\\begin\{thebibliography\}([\s\S]*?)\\end\{thebibliography\}/gi;
                const bibitemPattern = /\\bibitem\{[^}]*\}([\s\S]*?)(?=\\bibitem|\\end\{thebibliography\})/gi;
                const documentClassPattern = /\\begin\{(refjrnl|refbook|refthesis|refother|refedbk)\}([\s\S]*?)\\end\{\1\}/gi;

                // Dynamically build field-tag regex from the keys we care about
                const allFields = Object.keys(fieldExtractors);
                // Matches \RefXxx{ — captured group 1 = field name
                const fieldTagPattern = new RegExp(
                    `\\\\(${allFields.join("|")})\\{`, "gi"
                );

                let m;
                while ((m = bibliographyPattern.exec(texFile)) !== null) {
                    const biblioContent = m[0];
                    const biblioStart = m.index;

                    let bibitems;
                    bibitemPattern.lastIndex = 0;
                    while ((bibitems = bibitemPattern.exec(biblioContent)) !== null) {
                        const itemContent = bibitems[0];
                        const itemStart = biblioStart + bibitems.index;

                        let classitems;
                        documentClassPattern.lastIndex = 0;
                        while ((classitems = documentClassPattern.exec(itemContent)) !== null) {
                            const classcontent = classitems[0];
                            const classStart = itemStart + classitems.index;
                            const envType = classitems[1];

                            fieldTagPattern.lastIndex = 0;
                            let fieldMatch;
                            while ((fieldMatch = fieldTagPattern.exec(classcontent)) !== null) {
                                const fieldName = fieldMatch[1];  // e.g. "Refyear", "Refvol"
                                const tagEndInClass = fieldMatch.index + fieldMatch[0].length;
                                const innerContent = getContentInsideBrace(classcontent, tagEndInClass);

                                // Do we have a rule for this field+env combination?
                                const envRules = expected[fieldName];
                                if (!envRules) continue;
                                const ruleForEnv = envRules[envType];
                                if (!ruleForEnv) continue; // this field is not checked in this env

                                // Extract the canonical value (year digits, page range, etc.)
                                const extractor = fieldExtractors[fieldName];
                                const canonical = extractor(innerContent);
                                if (!canonical) continue; // can't extract — skip

                                // What should the inner content be?
                                const expectedInner = ruleForEnv(canonical);
                                if (!expectedInner) continue;

                                // Already correct?
                                if (innerContent.trim() === expectedInner) continue;

                                // ---- emit suggestion ----
                                const originalToken = `\\${fieldName}{${innerContent}}`;
                                const suggestedToken = `\\${fieldName}{${expectedInner}}`;
                                const tokenStartInFile = classStart + fieldMatch.index;
                                const tokenEndInFile = tokenStartInFile + originalToken.length;

                                console.log(
                                    `[RefFormatting] ${envType} \\${fieldName}: {${innerContent}} → {${expectedInner}}`
                                );
                                emit(originalToken, suggestedToken, tokenStartInFile, this.description);
                            }
                        }
                    }
                }

                return staleIds;
            } catch (error) {
                console.error("Error in reference formatting:", error);
            }
        }
    },


    URLValidation: eplStyles.URLValidations,

    AppendixFormatting: {
        name: "Appendix word capitalization",
        description: "Change the small appendix into captial letter",
        markerClass: "ace-Common-highlight",
        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = [], rejectedSuggestions = []) {
            try {
                const staleIds = new Set();
                const emit = makeAnchorEmitter({
                    texFile, session, Range, anchorlist, existingSuggestions, staleIds,
                    styleName: this.name, markerClass: this.markerClass, overlapMode: 'simple',
                });
                let pattern = /(\\weblink\s*\{)(appendix)\}/gi;
                let appendixpattern = /(appendix)\s*~?\\ref/gi
                let match;
                while ((match = pattern.exec(texFile)) !== null) {

                    emit(match[2], "Appendix", match.index + match[1].length, this.description);
                }
                let m;
                while ((m = appendixpattern.exec(texFile)) !== null) {
                    emit(m[1], "Appendix", m.index, this.description);
                }
                return staleIds;

            } catch (error) {
                console.log("the error in the appendix is :", error)
            }

        }
    },


    TitleCasing: {
        name: "TitleCasing",
        description: "Title command must be in Title Casing (and have no trailing period).",
        markerClass: "ace-Common-highlight",
        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            const staleIds = new Set();
            try {
                const emit = makeAnchorEmitter({
                    texFile, session, Range, anchorlist, existingSuggestions, staleIds,
                    styleName: this.name, markerClass: this.markerClass, overlapMode: 'simple'
                });

                const pattern = /\\title\s*(\[[^\]]*\])?\s*\{/gi;
                let match;
                while ((match = pattern.exec(texFile)) != null) {
                    if (isCommented(texFile, match.index)) continue;

                    const optionalArg = match[1] || "";
                    let depth = 1, i = match.index + match[0].length, content = '';

                    while (i < texFile.length && depth > 0) {
                        if (texFile[i] === '{') depth++;
                        else if (texFile[i] === '}') { depth--; if (depth === 0) break; }
                        content += texFile[i]; i++;
                    }
                    const fullMatch = texFile.slice(match.index, i + 1);
                    const normalizedContent = content.replace(/\s+/g, ' ').trim();
                    let newContent = changeToTitleCase(normalizedContent);


                    if (newContent.trim().endsWith('.')) {
                        newContent = newContent.replace(/\.\s*$/, '');
                    }
                    let suggestion = `\\title${optionalArg}{${newContent}}`;

                    if (fullMatch !== suggestion) {
                        emit(fullMatch, suggestion, match.index, this.description);
                    }
                }
                return staleIds;
            } catch (error) {
                console.log("error in title case", error);
            }
        }
    },


    DocumentSpellCheck: {
        name: "DocumentSpellCheck",
        description: "Spell Checking in Entire Document",
        markerClass: "ace-misspell-highlight",

        async execute(
            texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = [],
            isCancelled = null,
            asyncContext = null
        ) {
            const staleIds = new Set();
            if (!spell) return staleIds;

            const isIncremental = asyncContext?.isIncremental === true;
            const batchSize = asyncContext?.batchSize ?? 50;
            const onBatchCommit = asyncContext?.onBatch;
            const localAnchorList = isIncremental ? [] : anchorlist;

            const emit = makeAnchorEmitter({
                texFile, session, Range, anchorlist: localAnchorList,
                existingSuggestions, staleIds,
                styleName: this.name,
                markerClass: this.markerClass,
                overlapMode: 'skip-if-same',
            });

            const flushAnchorBatch = async () => {
                if (!isIncremental || !onBatchCommit || localAnchorList.length === 0) return;
                const batch = localAnchorList.splice(0, localAnchorList.length);
                const batchStaleIds = staleIds.size > 0 ? new Set(staleIds) : null;
                staleIds.clear();
                await onBatchCommit({ anchors: batch, staleIds: batchStaleIds });
                await new Promise(r => setTimeout(r, 0));
            };

            const processTypos = async (typos) => {
                for (const { word, absIndex, suggestion } of typos) {
                    if (typeof isCancelled === 'function' && isCancelled()) {
                        return false;
                    }

                    emit(
                        word,
                        suggestion,
                        absIndex,
                        `Spelling: Did you mean "${suggestion}"?`
                    );

                    if (isIncremental && localAnchorList.length >= batchSize) {
                        const batch = localAnchorList.splice(0, batchSize);
                        const batchStaleIds = staleIds.size > 0 ? new Set(staleIds) : null;
                        staleIds.clear();
                        await onBatchCommit({ anchors: batch, staleIds: batchStaleIds });
                        await new Promise(r => setTimeout(r, 0));
                    }
                }
                return true;
            };

            try {
                if (isIncremental && onBatchCommit) {
                    await runSpellWorker(texFile, {
                        batchSize,
                        isCancelled,
                        onBatch: async (workerTypos) => {
                            if (typeof isCancelled === 'function' && isCancelled()) return;
                            await processTypos(workerTypos);
                        },
                    });

                    if (typeof isCancelled === 'function' && isCancelled()) {
                        localAnchorList.forEach(item => {
                            if (item.markerId) session.removeMarker(item.markerId);
                            if (item.startAnchor?.detach) item.startAnchor.detach();
                            if (item.endAnchor?.detach) item.endAnchor.detach();
                        });
                        return staleIds;
                    }

                    await flushAnchorBatch();
                } else {
                    const typos = await runSpellWorker(texFile);

                    if (typeof isCancelled === 'function' && isCancelled()) {
                        console.log('[DocumentSpellCheck] cancelled after worker execution');
                        return staleIds;
                    }

                    await processTypos(typos);
                }

                return staleIds;

            } catch (err) {
                console.error('[DocumentSpellCheck] error processing background pipeline:', err);
                return staleIds;
            }
        }
    },

    keywordFormatting: {
        name: "Keyword Formatting",
        description: "Standardize keyword casing and add a trailing period.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {

            const staleIds = new Set();
            const emit = makeAnchorEmitter({
                texFile, session, Range, anchorlist,
                existingSuggestions, staleIds,
                styleName: this.name,
                markerClass: this.markerClass,
                overlapMode: 'simple',
            });

            const keywordsPat = /\\keywords\s*(\[[^\]]*\])?\s*\{/gi;
            let match;

            while ((match = keywordsPat.exec(texFile)) !== null) {
                if (isCommented(texFile, match.index)) continue;

                const optionalArg = match[1] || "";

                // Balanced brace extraction
                let depth = 1, i = match.index + match[0].length, content = '';
                while (i < texFile.length && depth > 0) {
                    if (texFile[i] === '{') depth++;
                    else if (texFile[i] === '}') { depth--; if (depth === 0) break; }
                    content += texFile[i]; i++;
                }

                const fullMatch = texFile.slice(match.index, i + 1);

                // let newContent = changeToSentenceCase(content);
                let newContent = changeToKeywordCase(content);
                console.log("the newContent in the keyword formatting is:", newContent);
                // let newContent = content[0].toUpperCase() + content.slice(1);
                console.log("the keyword correct suggestion is:", newContent);
                // Ensure the content ends with a period
                const trimmed = newContent.trim();
                if (trimmed.length > 0 && !trimmed.endsWith('.')) {
                    // Places the period before any trailing whitespace
                    newContent = newContent.replace(/(\S)(\s*)$/, '$1.$2');
                }

                const suggestion = `\\keywords${optionalArg}{${newContent}}`;

                if (fullMatch !== suggestion) {
                    emit(fullMatch, suggestion, match.index, this.description);
                }
            }
            return staleIds;
        }
    },



    removeVerticalLinesInTable: {
        name: "Remove Table Vertical Lines",
        description: "Removes vertical lines in tables from column definition.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const pattern = /\\begin\{tabular\}\{([^\}]*)\}/g;
            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const columns = match[1];
                const cleanCols = columns.replace(/\|/g, '');
                const suggestion = `\\begin{tabular}{${cleanCols}}`;

                if (fullMatch === suggestion) continue;

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                }

                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(session, Range, position,
                        fullMatch, suggestion,
                        this.markerClass, this.name, this.description, anchorlist);
                }
            }

            return staleIds;
        }
    },



    mathToRoman: {
        name: "Math Functions to Roman",
        description: "Convert math functions to roman style, skipping those already formatted.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles,
            existingSuggestions = [], rejectedSuggestions = []) {

            const staleIds = new Set();

            const { segments } = buildStyleContext({
                texFile, session, Range, anchorlist,
                existingSuggestions, staleIds,
                styleName: this.name,
                markerClass: this.markerClass,
                scope: { wholeDocument: true },
                excludeMath: false,
                onlyMath: true,
                excludeAllCommands: false,
            });

            const functions = [
                "cos", "sin", "tan", "exp", "log",
                "max", "min", "sup", "inf", "lim",
                "ln", "det", "ker",
                "sum", "prod", "int",
            ];

            const operators = [
                "diag", "rank", "trace", "span", "sign",
                "cov", "var", "corr", "erf", "sinc",
                "Res", "supp", "proj", "dist",
                "argmin", "argmax",
            ];

            const funcRegex = new RegExp(
                `(?<!\\\\|\\{)\\b(${functions.join('|')})\\b`, 'g'
            );
            const operatorRegex = new RegExp(
                `(?<!\\\\operatorname\\{)(?<!\\\\|\\{)\\b(${operators.join('|')})\\b`, 'g'
            );

            const alreadyRomanPattern =
                /\\(?:mathrm|operatorname|text|textrm|textbf|textit|textsf)\{[^}]*$/;

            // ── FIX 1: use seg.absStart (not seg.startIndex which is undefined) ──
            const emitted = new Set();

            for (const seg of segments) {

                // ── Pass 1: standard functions  sin → \sin ────────────────────────
                funcRegex.lastIndex = 0;
                let match;

                while ((match = funcRegex.exec(seg.text)) !== null) {
                    const word = match[0];

                    // FIXED: seg.absStart not seg.startIndex
                    const absPos = seg.absStart + match.index;
                    const key = `${absPos}:${word}`;

                    if (emitted.has(key)) continue;

                    const lookback = seg.text.slice(
                        Math.max(0, match.index - (word.length + 16)),
                        match.index
                    );
                    if (alreadyRomanPattern.test(lookback)) continue;
                    if (match.index > 0 && seg.text[match.index - 1] === '\\') continue;

                    seg.emit(word, `\\${word}`, match.index, this.description);
                    emitted.add(key);
                }

                // ── Pass 2: custom operators  diag → \operatorname{diag} ──────────
                operatorRegex.lastIndex = 0;

                while ((match = operatorRegex.exec(seg.text)) !== null) {
                    const word = match[0];

                    // FIXED: seg.absStart not seg.startIndex
                    const absPos = seg.absStart + match.index;
                    const key = `${absPos}:${word}`;

                    if (emitted.has(key)) continue;

                    const lookback = seg.text.slice(
                        Math.max(0, match.index - (word.length + 18)),
                        match.index
                    );
                    if (alreadyRomanPattern.test(lookback)) continue;
                    if (/\\operatorname\{$/.test(lookback)) continue;
                    if (match.index > 0 && seg.text[match.index - 1] === '\\') continue;

                    seg.emit(word, `\\operatorname{${word}}`, match.index, this.description);
                    emitted.add(key);
                }
            }

            return staleIds;
        }
    },

    MathOperatorAlignment: {
        name: "Math Operator Alignment",
        description: "In multi-line equations, relation operators (=, <, >, \\leq, etc.) must be at the beginning of each line, not at the end.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = [], rejectedSuggestions = []) {
            const staleIds = new Set();

            function isCommented(text, index) {
                let s = index; while (s > 0 && text[s - 1] !== '\n') s--;
                for (let i = s; i < index; i++) if (text[i] === '%' && (i === 0 || text[i - 1] !== '\\')) return true;
                return false;
            }

            function emitSuggestion(originalText, suggestionText, absIndex, description) {
                const position = getPositionFromIndex(texFile, absIndex, originalText.length);
                if (isRejectedByLivePosition(position, this.name, originalText)) return;
                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) return;
                }
                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(session, Range, position, originalText, suggestionText,
                        this.markerClass, this.name, description, anchorlist);
                }
            }

            // Only check MULTI-line display environments (align, eqnarray, gather, multline)
            const multiLinePat = /\\begin\{(align|eqnarray|gather|multline)\*?\}([\s\S]*?)\\end\{\1\*?\}/g;
            let envMatch;

            while ((envMatch = multiLinePat.exec(texFile)) !== null) {
                if (isCommented(texFile, envMatch.index)) continue;
                const envBody = envMatch[2];
                const bodyAbsStart = envMatch.index + envMatch[0].indexOf(envBody);

                // Split body into rows by \\
                const rows = envBody.split(/\\\\/);
                if (rows.length <= 1) continue; // single row — no alignment issue

                let charPos = 0;
                for (const row of rows) {
                    const trimmedRow = row.trimEnd();

                    // Detect: row ends with a relation operator (optionally preceded by spaces)
                    // Operators: = < > \leq \geq \neq \approx \equiv \sim \simeq \propto
                    const endOpMatch = /\s*([=<>]|\\(?:leq|geq|neq|approx|equiv|sim|simeq|propto))\s*$/.exec(trimmedRow);

                    if (endOpMatch) {
                        const operator = endOpMatch[1];
                        const lineAbsIdx = bodyAbsStart + charPos;
                        const lineEnd = charPos + row.length;

                        // Find the operator's absolute position in texFile
                        const opOffset = trimmedRow.lastIndexOf(operator);
                        const opAbsIdx = bodyAbsStart + charPos + opOffset;

                        // The whole row that has the trailing operator
                        const rowText = row;
                        // Suggestion: move operator to the start of the NEXT row
                        // We anchor on the operator itself and suggest removing it from here
                        // (the next row will get a separate suggestion to add it)
                        const opFull = texFile.slice(opAbsIdx, opAbsIdx + operator.length);

                        if (!isCommented(texFile, opAbsIdx)) {
                            emitSuggestion.call(this,
                                opFull,
                                '', // remove from end of this line
                                opAbsIdx,
                                `Operator "${operator}" should be at the beginning of the next line, not the end of this line`
                            );
                        }
                    }
                    charPos += row.length + 2; // +2 for \\
                }
            }

            return staleIds;
        }
    },







    // EnergyLevelRoman: {
    //     name: "Energy Level Roman",
    //     description: "Spectroscopic term symbols (1S0, 3P1, 1D2) and orbital labels (1s, 2p, 3d) must use Roman (upright) letters.",
    //     markerClass: "ace-Common-highlight",

    //     execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = [], rejectedSuggestions = []) {
    //         const staleIds = new Set();

    //         function isCommented(text, index) {
    //             let s = index; while (s > 0 && text[s - 1] !== '\n') s--;
    //             for (let i = s; i < index; i++) if (text[i] === '%' && (i === 0 || text[i - 1] !== '\\')) return true;
    //             return false;
    //         }

    //         function emitSuggestion(originalText, suggestionText, absIndex, description) {
    //             if (originalText === suggestionText) return;
    //             const position = getPositionFromIndex(texFile, absIndex, originalText.length);
    //             if (isRejectedByLivePosition(position, this.name, originalText)) return;
    //             const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
    //             if (overlapping.length > 0) {
    //                 overlapping.forEach(old => staleIds.add(old.id));
    //             } else {
    //                 if (isAlreadyAnchored(position, this.name, existingSuggestions)) return;
    //             }
    //             if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
    //                 createAnchor(session, Range, position, originalText, suggestionText,
    //                     this.markerClass, this.name, description, anchorlist);
    //             }
    //         }

    //         const mathRanges = getMathRanges(texFile);

    //         for (const range of mathRanges) {
    //             const { content, contentStart } = range;
    //             if (isCommented(texFile, range.start)) continue;

    //             // ── Spectroscopic term symbols ────────────────────────────────────
    //             // Pattern: optional ^ then {digit} or digit, then L-letter, then optional _J
    //             // L ∈ S,P,D,F,G,H  (uppercase)
    //             // NOT already wrapped in \mathrm{} or \text{}
    //             //
    //             // Match examples: ^1S_0, ^{3}P_1, 1D_2, ^1S_0^o
    //             // We match the L-letter only (that's what needs to be roman)
    //             const termPat = /(?<!\\mathrm\{)(?<!\\text\{)(?<=\^?\{?\d+\}?)([SPDFGHI])(?=[_^}\s\\]|$)/g;
    //             let tm;
    //             while ((tm = termPat.exec(content)) !== null) {
    //                 const absIdx = contentStart + tm.index;
    //                 if (isCommented(texFile, absIdx)) continue;

    //                 // Verify the character before is indeed a digit/brace (part of term symbol)
    //                 const before = content.slice(Math.max(0, tm.index - 3), tm.index);
    //                 if (!/[\d}]$/.test(before)) continue;

    //                 const letter = tm[1];
    //                 const suggestion = `\\mathrm{${letter}}`;

    //                 emitSuggestion.call(this,
    //                     letter, suggestion, absIdx,
    //                     `Spectroscopic term letter '${letter}' should be Roman: \\mathrm{${letter}}`
    //                 );
    //             }

    //             // ── Orbital labels ────────────────────────────────────────────────
    //             // Pattern: digit followed by orbital letter (s,p,d,f) in math mode
    //             // e.g. 1s, 2p, 3d, 4f — the letter should be roman
    //             const orbPat = /(?<!\\mathrm\{)(?<=\d)([spdf])(?=[^a-zA-Z]|$)/g;
    //             let om;
    //             while ((om = orbPat.exec(content)) !== null) {
    //                 const absIdx = contentStart + om.index;
    //                 if (isCommented(texFile, absIdx)) continue;

    //                 emitSuggestion.call(this,
    //                     om[1], `\\mathrm{${om[1]}}`, absIdx,
    //                     `Orbital label '${om[1]}' after digit should be Roman: \\mathrm{${om[1]}}`
    //                 );
    //             }
    //         }

    //         return staleIds;
    //     }
    // },

    BibliographyTags: {
        name: "Bibliography Tags",
        description: "Ensures mandatory prefixes (Preprint, Dataset, Code) are present in the bibliography.",
        markerClass: "ace-Common-highlight",
        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = [], rejectedSuggestions = []) {
            const staleIds = new Set();
            const emit = makeAnchorEmitter({
                texFile, session, Range, anchorlist,
                existingSuggestions, staleIds,
                styleName: this.name,
                markerClass: this.markerClass,
            });

            let bibliographyPattern = /\\begin\{thebibliography\}([\s\S]*?)(?:\\end\{thebibliography\})/gi;
            let bibitems = /\\bibitem\{([^}]*)\}([\s\S]*?)(?=\\bibitem|\\end\{thebibliography\})/gi;
            let Refdoipattern = /\\Refdoi\{/gi;
            let preprintpattern = /\\Refpreprint\{/gi;

            let match;
            while ((match = bibliographyPattern.exec(texFile)) !== null) {
                bibitems.lastIndex = 0;
                let bibitemmatch;
                while ((bibitemmatch = bibitems.exec(match[0])) !== null) {
                    let refdoimatch;
                    while ((refdoimatch = Refdoipattern.exec(bibitemmatch[0])) != null) {
                        const innerRefdata = getdatainsidebrackets(bibitemmatch[0], refdoimatch.index + refdoimatch[0].length);
                        console.log("the data inside the refdoi is :", innerRefdata, /dataset/gi.test(innerRefdata));
                        if (/dataset/g.test(innerRefdata)) {
                            let originalText = `${refdoimatch[0]}${innerRefdata}}`
                            let suggestion = `${refdoimatch[0]}Dataset ${innerRefdata}}`
                            console.log("the dataset contained doi is:", suggestion);
                            emit(originalText, suggestion, match.index + bibitemmatch.index + refdoimatch.index, this.description);
                        }
                        if (/code/g.test(innerRefdata)) {
                            let originalText = `${refdoimatch[0]}${innerRefdata}}`
                            let suggestion = `${refdoimatch[0]}Code ${innerRefdata}}`
                            console.log("the dataset contained doi is:", suggestion);
                            emit(originalText, suggestion, match.index + bibitemmatch.index + refdoimatch.index, this.description);
                        }
                    }
                    let preprintmatch;
                    while ((preprintmatch = preprintpattern.exec(bibitemmatch[0])) !== null) {
                        let innerpreprintcontent = getdatainsidebrackets(bibitemmatch[0], preprintmatch.index + preprintmatch[0].length);
                        if (/arXiv:/g.test(innerpreprintcontent)) {
                            let originalText = `${preprintmatch[0]}${innerpreprintcontent}}`
                            let suggestion = `${preprintmatch[0]}Preprint ${innerpreprintcontent}}`;
                            emit(originalText, suggestion, match.index + bibitemmatch.index + preprintmatch.index, this.description)
                        }
                    }

                }
            }
            return staleIds;
        }
    },


    AuthorNameAbbreviations: {
        name: "Author Name Abbreviation",
        description: "Authors' first names should be abbreviated in references",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles,
            existingSuggestions = [], rejectedSuggestions = []) {
            const staleIds = new Set();
            const emit = makeAnchorEmitter({
                texFile, session, Range, anchorlist,
                existingSuggestions, staleIds,
                styleName: this.name,
                markerClass: this.markerClass,
                overlapMode: 'simple'
            });

            function getdatainsidebrackets(file, i) {
                let content = "";
                let depth = 1;
                while (i < file.length && depth > 0) {
                    if (file[i] === "{") depth++;
                    if (file[i] === "}") depth--;
                    if (depth === 0) break;
                    content = content + file[i];
                    i++;
                }
                return content;
            }

            // Helper to cleanly convert a string of names into initials (e.g., "henry well" -> "H.W.")
            // It splits by space or period, ensuring existing initials aren't mangled.
            function makeInitials(text) {
                let words = text.split(/[\s\.]+/).filter(w => w.length > 0);
                return words.map(w => {
                    let clean = w.replace(/[^a-zA-Z]/g, '');
                    return clean.length > 0 ? clean[0].toUpperCase() + "." : "";
                }).join("");
            }

            const bibitemspattern = /\\bibitem\{([^}]*)?\}([\s\S]*?)(?=\\bibitem|\\end\{thebibliography\})/gi;
            const refsurnamepattern = /\\Refsurname\{/gi;

            let match;
            while ((match = bibitemspattern.exec(texFile)) !== null) {
                const bibitemContent = match[0];
                const bibitemAbsIndex = match.index;

                let refsurname;
                refsurnamepattern.lastIndex = 0;

                while ((refsurname = refsurnamepattern.exec(bibitemContent)) !== null) {
                    const surnameStartIndex = refsurname.index;
                    const surnameInnerContent = getdatainsidebrackets(bibitemContent, surnameStartIndex + refsurname[0].length);

                    // Get the text exactly BEFORE the \Refsurname starts
                    const textBefore = bibitemContent.slice(0, surnameStartIndex);

                    // Regex to check if the text right before ends with \Refinitial{...} and optional spaces/tilde
                    // Captures the content inside \Refinitial
                    const initialMatch = textBefore.match(/\\Refinitial\{((?:[^{}]|(?:\{[^{}]*\}))*)\}(?:\s*~?\s*)$/);

                    if (initialMatch) {
                        // ── SCENARIO A: \Refinitial ALREADY EXISTS ──
                        const initialContent = initialMatch[1]; // e.g., "henry well"
                        const initialFullString = initialMatch[0]; // e.g., "\Refinitial{henry well}~"
                        if (initialContent.trim() === "al.") {
                            continue; // Skip abbreviation if it's "al." (e.g., "et al.")
                        }

                        const newInitials = makeInitials(initialContent);

                        const original = `${initialFullString}\\Refsurname{${surnameInnerContent}}`;
                        const result = `\\Refinitial{${newInitials}}~\\Refsurname{${surnameInnerContent}}`;

                        // Only emit if it actually needs changing (e.g., skips if already "H.W.")
                        if (original !== result) {
                            const absoluteIndex = bibitemAbsIndex + surnameStartIndex - initialFullString.length;
                            emit(original, result, absoluteIndex, this.description);
                        }
                    } else {
                        // ── SCENARIO B: NO \Refinitial EXISTS (Your Original Logic) ──
                        let names = surnameInnerContent.trim().split(/\s+/g);

                        if (names.length > 1) {
                            let surname = names.pop(); // Removes and stores the last element (Surname)
                            let initials = makeInitials(names.join(" ")); // Converts the rest to initials

                            const original = `\\Refsurname{${surnameInnerContent}}`;
                            const result = `\\Refinitial{${initials}}~\\Refsurname{${surname}}`;

                            if (original !== result) {
                                const absoluteIndex = bibitemAbsIndex + surnameStartIndex;
                                emit(original, result, absoluteIndex, this.description);
                            }
                        }
                    }
                }
            }

            return staleIds;
        }
    },

    JournalFormatting: {
        name: "Journal Formatting in bibliography",
        description: "Change \\Refjtit content into abbreviations",
        markerClass: "ace-Common-highlight",
        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = [], rejectedSuggestions = []) {
            const staleIds = new Set();
            const emit = makeAnchorEmitter({
                texFile, session, Range, anchorlist,
                existingSuggestions, staleIds,
                styleName: this.name,
                markerClass: this.markerClass,
                overlapMode: 'simple'
            })
            const bibitemspattern = /\\bibitem\{([^}]*)?\}([\s\S]*?)(?=\\bibitem|\\end\{thebibliography\})/gi;
            const RefjtitPattern = /\\Refjtit\{/gi;
            const textitpattern = /\\textit\{/gi;

            const abbr = {
                "MATHEMATICS OF COMPUTATION": "Math. Comput."
            };

            function getdatainsidebrackets(file, i) {
                let content = "";
                let depth = 1;
                while (i < file.length && depth > 0) {
                    if (file[i] === "{") depth++;
                    else if (file[i] === "}") {
                        depth--;
                        if (depth === 0) break;
                    }
                    content = content + file[i];
                    i++;
                }
                return content;
            }

            let match;
            while ((match = bibitemspattern.exec(texFile)) !== null) {
                const bibitemContent = match[0];
                const bibitemGlobalStart = match.index;
                RefjtitPattern.lastIndex = 0;
                let journalMatch;
                while ((journalMatch = RefjtitPattern.exec(bibitemContent)) !== null) {
                    const journalContent = getdatainsidebrackets(bibitemContent, journalMatch.index + journalMatch[0].length);
                    textitpattern.lastIndex = 0;
                    let texitcontents;
                    while ((texitcontents = textitpattern.exec(journalContent)) !== null) {
                        let texitcontent = getdatainsidebrackets(journalContent, texitcontents.index + texitcontents[0].length);
                        console.log("the texitcontents are:", texitcontent);
                        let cleanitem = texitcontent.trim();
                        if (abbr[cleanitem]) {
                            let originalText = `\\textit{${texitcontent}}`;
                            let suggestion = `\\textit{${abbr[cleanitem]}}`;
                            const absoluteIndex = bibitemGlobalStart + journalMatch.index + journalMatch[0].length + texitcontents.index;
                            emit(originalText, suggestion, absoluteIndex, this.description);
                        }

                    }

                }
            }
            return staleIds;
        }
    },

    titleFormatting: {
        name: "EDP title Formatting",
        description: "Change \\Refjtit content into abbreviations",
        markerClass: "ace-Common-highlight",
        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = [], rejectedSuggestions = []) {
            const staleIds = new Set();
            const emit = makeAnchorEmitter({
                texFile, session, Range, anchorlist,
                existingSuggestions, staleIds,
                styleName: this.name,
                markerClass: this.markerClass,
                overlapMode: 'simple'
            });
            const titlepattern = /\\title\{/gi;
            let match;

            while ((match = titlepattern.exec(texFile)) !== null) {
                let innerContent = getdatainsidebrackets(texFile, match.index + match[0].length);
                console.log("the innerContent inside the title is :", innerContent);
                let titlecaseContent = changeToTitleCase(innerContent);
                if (innerContent !== titlecaseContent) {
                    let originalText = `${match[0]}${innerContent}}`;
                    let suggestionText = `${match[0]}${titlecaseContent}}`
                    emit(originalText, suggestionText, match.index, this.description);
                }
            }
            return staleIds;
        }
    },

    TableStructureCheck: {
        name: "Table Structure Check",
        description: "Tables must not be images; remove vertical lines; center multi-column headers; left-align headings.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = [], rejectedSuggestions = []) {
            const staleIds = new Set();

            function isCommented(text, index) {
                let s = index;
                while (s > 0 && text[s - 1] !== '\n') s--;
                for (let i = s; i < index; i++)
                    if (text[i] === '%' && (i === 0 || text[i - 1] !== '\\')) return true;
                return false;
            }

            function emitSuggestion(originalText, suggestionText, absIndex, description) {
                if (originalText === suggestionText) return;
                const position = getPositionFromIndex(texFile, absIndex, originalText.length);
                if (isRejectedByLivePosition(position, this.name, originalText)) return;
                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) return;
                }
                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(session, Range, position, originalText, suggestionText,
                        this.markerClass, this.name, description, anchorlist);
                }
            }

            // Scan all \begin{table}...\end{table} blocks
            const tablePat = /\\begin\{table\*?\}([\s\S]*?)\\end\{table\*?\}/gi;
            let tableMatch;

            while ((tableMatch = tablePat.exec(texFile)) !== null) {
                if (isCommented(texFile, tableMatch.index)) continue;
                const tableBody = tableMatch[1];
                const tableBodyStart = tableMatch.index + tableMatch[0].indexOf(tableBody);

                // ── CHECK A: \includegraphics inside table ────────────────────────
                // const incPat = /\\includegraphics\s*(?:\[[^\]]*\])?\s*\{[^}]*\}/g;
                // let incMatch;
                // while ((incMatch = incPat.exec(tableBody)) !== null) {
                //     if (isCommented(tableBody, incMatch.index)) continue;
                //     emitSuggestion.call(this,
                //         incMatch[0],
                //         '% [Table data must not be in image format — replace with tabular data]',
                //         tableBodyStart + incMatch.index,
                //         'Tables must not use image format. Replace \\includegraphics with tabular data.'
                //     );
                // }

                // Scan all \begin{tabular}{spec}...body...\end{tabular} inside this table
                const tabularPat = /\\begin\{tabular\}\s*(\{[^}]*\})([\s\S]*?)\\end\{tabular\}/gi;
                let tabMatch;

                while ((tabMatch = tabularPat.exec(tableBody)) !== null) {
                    if (isCommented(tableBody, tabMatch.index)) continue;

                    const specFull = tabMatch[1];
                    const specInner = specFull.slice(1, -1);
                    const tabBody = tabMatch[2];
                    const specAbsIdx = tableBodyStart + tabMatch.index + tabMatch[0].indexOf(specFull);
                    const tabBodyAbs = tableBodyStart + tabMatch.index + tabMatch[0].indexOf(tabBody);

                    // ── CHECK B: Vertical lines in column spec ────────────────────
                    if (specInner.includes('|')) {
                        const cleanSpec = specInner.replace(/\|/g, '');
                        emitSuggestion.call(this,
                            specFull, `{${cleanSpec}}`, specAbsIdx,
                            `Remove vertical lines from tabular spec → {${cleanSpec}}`
                        );
                    }



                    // ── CHECK C: \multicolumn spanning >1 col must be centered ─────
                    const mcPat = /\\multicolumn\s*\{(\d+)\}\s*\{([^}]*)\}\s*\{([^}]*)\}/g;
                    let mcMatch;
                    while ((mcMatch = mcPat.exec(tabBody)) !== null) {
                        if (isCommented(tabBody, mcMatch.index)) continue;
                        const span = parseInt(mcMatch[1], 10);
                        const align = mcMatch[2].replace(/\|/g, '').trim();
                        if (span > 1 && align !== 'c') {
                            const fixedAlign = mcMatch[2].replace(/[lr]/g, 'c');
                            const suggestion = `\\multicolumn{${mcMatch[1]}}{${fixedAlign}}{${mcMatch[3]}}`;
                            emitSuggestion.call(this,
                                mcMatch[0], suggestion, tabBodyAbs + mcMatch.index,
                                `\\multicolumn spanning ${span} columns must be centered: use {c} not {${align}}`
                            );
                        }
                    }
                }
            }

            return staleIds;
        }
    },


    DefaultTableAlignment: {
        name: "Table Default Left Alignment",
        description: "Tables headings default left-align.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = [], rejectedSuggestions = []) {
            const staleIds = new Set();

            const emit = makeAnchorEmitter({
                texFile, session, Range, anchorlist,
                existingSuggestions, staleIds,
                styleName: this.name,
                markerClass: this.markerClass,
                overlapMode: 'simple'
            });

            const pattern = /\\begin\s*\{\s*tabular\s*\}\s*\{/gi;
            // Escape backslashes for \extracolsep and \fill
            const extracolspace = /@\{\\extracolsep\\fill\}([\s\S]*?)@\{\\extracolsep\\fill\}/i;
            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                const fullmatchindex = match.index;
                const fullmatchlength = match[0].length;

                let content = "";
                let bracketCount = 1;
                let i = fullmatchindex + fullmatchlength;

                while (bracketCount > 0 && i < texFile.length) {
                    if (texFile[i] === "{") bracketCount++;
                    else if (texFile[i] === "}") {
                        bracketCount--;
                        if (bracketCount === 0) break;
                    }
                    content += texFile[i];
                    i++;
                }

                let suggestion;
                // Check if content contains @{\extracolsep\fill}
                const extraMatch = content.match(extracolspace);

                if (extraMatch) {
                    // extraMatch[1] is the alignment string (e.g., lllllllll)
                    const newAlign = extraMatch[1].replace(/[rc]/gi, "l");
                    // Use backticks and the variable name to reconstruct the string
                    suggestion = `@{\\extracolsep\\fill}${newAlign}@{\\extracolsep\\fill}`;
                } else {
                    suggestion = content.replace(/[rc]/gi, "l");
                }

                if (content !== suggestion) {
                    const startPos = fullmatchindex + fullmatchlength;
                    const endPos = startPos + content.length;

                    emit(
                        content,
                        suggestion,
                        startPos,
                        `Table columns should be left-aligned (l).`
                    );
                }
            }
            return staleIds;
        }
    },
    MulitColumnCentering: {
        name: "MultiColumn Centering",
        description: "Table multicolumn spanning >1 column must be centered",
        markerClass: "ace-Common-highlight",
        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = [], rejectedSuggestions = []) {
            const staleIds = new Set();
            // Regex with 'g' flag and capturing: 1: span, 2: align, 3: content
            const pattern = /\\multicolumn\s*\{(\d+)\}\s*\{([^}]*)\}\s*\{([^}]*)\}/gi;
            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const span = parseInt(match[1], 10);
                const currentAlign = match[2];
                const content = match[3];

                // Only enforce centering if it spans more than 1 column
                if (span > 1) {
                    // Check if alignment contains 'l' or 'r'
                    if (/[lr]/i.test(currentAlign)) {
                        // Create the new alignment (e.g., '|l|' becomes '|c|')
                        const fixedAlign = currentAlign.replace(/[lr]/gi, "c");

                        // Reconstruct the full command as the suggestion
                        const suggestion = `\\multicolumn{${span}}{${fixedAlign}}{${content}}`;

                        const absIndex = match.index;
                        const originalText = fullMatch;
                        const position = getPositionFromIndex(texFile, absIndex, originalText.length);

                        // Standard Guards
                        if (isRejectedByLivePosition(position, this.name, originalText)) continue;

                        const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                        if (overlapping.length > 0) {
                            overlapping.forEach(old => staleIds.add(old.id));
                        } else {
                            if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                        }

                        if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                            createAnchor(session, Range, position, originalText, suggestion, this.markerClass, this.name,
                                `Multicolumn spanning ${span} columns must be centered. Change "${currentAlign}" to "${fixedAlign}".`,
                                anchorlist
                            );
                        }
                    }
                }
            }
            return staleIds;
        }
    },
    InpressDOI: {
        name: "DOI only if Inpress",
        description: "DOI must be added for 'in press' references.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = [], rejectedSuggestions = []) {
            const staleIds = new Set();
            const self = this;

            existingSuggestions.forEach(s => {
                if (s.styleInfo?.name === self.name) staleIds.add(s.id);
            });

            const ctx = buildStyleContext({
                texFile, session, Range, anchorlist,
                existingSuggestions, staleIds,
                styleName: self.name,
                markerClass: self.markerClass,
                scope: { wholeDocument: true },
                mode: "query",
                overlapMode: "refresh"
            });

            const bibliographyPattern = /\\begin\{thebibliography\}([\s\S]*?)\\end\{thebibliography\}/gi;
            const bibitemPattern = /\\bibitem\s*(\[[^\]]*\])?\s*\{[^}]+\}/gi; // matches \bibitem[..]{..} header only
            const inpressPattern = /in\s*press/i;
            const doiPattern = /https?:\/\/doi\.org\//i;

            let bibMatch;

            while ((bibMatch = bibliographyPattern.exec(texFile)) !== null) {
                const bibStart = bibMatch.index;
                const bibContent = bibMatch[0];

                // ── Collect all \bibitem header positions first ──────────────────
                const bibitemHeaders = [];
                bibitemPattern.lastIndex = 0;
                let hm;
                while ((hm = bibitemPattern.exec(bibContent)) !== null) {
                    bibitemHeaders.push({
                        headerStart: hm.index,       // relative to bibContent
                        headerEnd: hm.index + hm[0].length,
                        headerText: hm[0],
                    });
                }

                // ── For each bibitem, content runs from its headerEnd to next headerStart ──
                for (let i = 0; i < bibitemHeaders.length; i++) {
                    const current = bibitemHeaders[i];
                    const nextStart = i + 1 < bibitemHeaders.length
                        ? bibitemHeaders[i + 1].headerStart
                        : bibContent.indexOf('\\end{thebibliography}');

                    const itemBody = bibContent.slice(current.headerEnd, nextStart);
                    const fullEntry = bibContent.slice(current.headerStart, nextStart);

                    const hasInpress = inpressPattern.test(itemBody);
                    doiPattern.lastIndex = 0;
                    const hasDoi = doiPattern.test(itemBody);

                    if (hasInpress && !hasDoi) {
                        // ── Point to the \bibitem line start, not mid-content ────
                        // Walk back from headerStart to find the beginning of that line
                        let lineStart = bibStart + current.headerStart;
                        while (lineStart > 0 && texFile[lineStart - 1] !== '\n') lineStart--;

                        ctx.emitQuery(
                            fullEntry.trim(),
                            `DOI is missing for this "in press" reference — add https://doi.org/... to the entry`,
                            lineStart,   // ← stable line start, so \AQ{} guard works correctly
                            `"in press" reference is missing a DOI link`
                        );
                    }
                }
            }

            return staleIds;
        }
    },
    TableContentCheck: {
        name: "Table Content Check",
        description: "Replace hyphens with en-dashes, write digits as numerals, move recurring units to column header.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = [], rejectedSuggestions = []) {
            const staleIds = new Set();

            function isCommented(text, index) {
                let s = index;
                while (s > 0 && text[s - 1] !== '\n') s--;
                for (let i = s; i < index; i++)
                    if (text[i] === '%' && (i === 0 || text[i - 1] !== '\\')) return true;
                return false;
            }

            function emitSuggestion(originalText, suggestionText, absIndex, description) {
                if (originalText === suggestionText) return;
                const position = getPositionFromIndex(texFile, absIndex, originalText.length);
                if (isRejectedByLivePosition(position, this.name, originalText)) return;
                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) return;
                }
                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(session, Range, position, originalText, suggestionText,
                        this.markerClass, this.name, description, anchorlist);
                }
            }

            // ── Written digit map ─────────────────────────────────────────────────
            const WRITTEN_DIGITS = {
                zero: '0', one: '1', two: '2', three: '3', four: '4',
                five: '5', six: '6', seven: '7', eight: '8', nine: '9',
                ten: '10', eleven: '11', twelve: '12', hundred: '100', thousand: '1000',
            };

            // ── Unit pattern: short strings like kg, m/s, Hz, \mu m, cm^{-1} ──────
            const UNIT_PAT = /^(?:\\?[a-zA-Z\u03bc]+(?:\^[\{-]?[\d\}]+)?(?:\/\\?[a-zA-Z]+(?:\^[\{-]?[\d\}]+)?)?)$/;

            // ── Scan all \begin{tabular} environments ─────────────────────────────
            const tabularFullPat = /\\begin\{tabular\}\s*\{[^}]*\}([\s\S]*?)\\end\{tabular\}/gi;
            let tabMatch;

            while ((tabMatch = tabularFullPat.exec(texFile)) !== null) {
                if (isCommented(texFile, tabMatch.index)) continue;

                const rawBody = tabMatch[1];
                const bodyAbsStart = tabMatch.index + tabMatch[0].indexOf(rawBody);

                // Use the shared parser — precise absolute offsets per cell
                const { headerCells, contentRows } = parseTabularBody(rawBody, bodyAbsStart);
                if (!headerCells.length || !contentRows.length) continue;

                // ── CHECK E: Hyphens → en-dashes ─────────────────────────────────
                for (const row of contentRows) {
                    for (const cell of row) {
                        if (!cell.text) continue;

                        // Skip pure math cells
                        if (/^\$[^$]+\$$/.test(cell.text)) continue;

                        // Pattern 1: text word - text word (not compound-word)
                        // Requires whitespace around the hyphen
                        // absIdx of hyphen pattern = cell.absIdx + match.index
                        const textHyphenPat = /\s+-\s+/g;
                        let hm;
                        while ((hm = textHyphenPat.exec(cell.text)) !== null) {
                            const orig = hm[0];
                            const sug = orig.replace('-', '--');
                            const absIdx = cell.absIdx + hm.index;
                            emitSuggestion.call(this,
                                orig, sug, absIdx,
                                `Replace hyphen with en-dash: "${orig.trim()}" → "${sug.trim()}"`
                            );
                        }

                        // Pattern 2: numeric range N-N (not already --)
                        const numRangePat = /(\d+)\s*-(?!-)\s*(\d+)/g;
                        let nm;
                        while ((nm = numRangePat.exec(cell.text)) !== null) {
                            const orig = nm[0];
                            const sug = `${nm[1]}--${nm[2]}`;
                            const absIdx = cell.absIdx + nm.index;
                            emitSuggestion.call(this,
                                orig, sug, absIdx,
                                `Replace hyphen with en-dash in range: "${orig}" → "${sug}"`
                            );
                        }
                    }
                }


                // ── CHECK G: Recurring units → move to column header ─────────────
                const numCols = headerCells.length;

                for (let ci = 0; ci < numCols; ci++) {
                    // Collect the unit (if any) from each data row for this column
                    const colUnits = contentRows.map(row => {
                        const cell = row[ci];
                        if (!cell || !cell.text) return null;

                        // Pattern A: "1.5 kg" — number(s) then space then unit
                        const numUnitM = /^[\d.eE+\-${}\\]+\s+([a-zA-Z\/\\^{}_\-\u03bc]+)$/.exec(cell.text);
                        if (numUnitM && UNIT_PAT.test(numUnitM[1])) return numUnitM[1];

                        // Pattern B: entire cell is a unit string (pure unit column)
                        if (UNIT_PAT.test(cell.text) && cell.text.length <= 12
                            && !/^\d+$/.test(cell.text)) return cell.text;

                        return null;
                    });

                    // Find the longest run of identical non-null units
                    let maxRun = 0, maxRunUnit = null;
                    let runLen = 0, runUnit = null;

                    for (const u of colUnits) {
                        if (u !== null && u === runUnit) {
                            runLen++;
                            if (runLen > maxRun) { maxRun = runLen; maxRunUnit = runUnit; }
                        } else {
                            runLen = 1; runUnit = u;
                            if (u !== null && runLen > maxRun) { maxRun = runLen; maxRunUnit = u; }
                        }
                    }

                    if (maxRun >= 2 && maxRunUnit) {
                        const hdr = headerCells[ci];
                        if (!hdr || !hdr.text) continue;

                        // Skip if header already contains the unit in brackets
                        if (hdr.text.includes(`(${maxRunUnit})`) ||
                            hdr.text.includes(`[${maxRunUnit}]`)) continue;

                        const suggestion = `${hdr.text} (${maxRunUnit})`;
                        emitSuggestion.call(this,
                            hdr.text, suggestion, hdr.absIdx,
                            `Recurring unit "${maxRunUnit}" in column "${hdr.text}" — add to header as (${maxRunUnit})`
                        );
                    }
                }
            }

            return staleIds;
        }
    },

    MathSymbolCheck: {
        name: "Mathematical Symbols",
        description: "Mathematical symbols must not be written in full (e.g., 'plus' → +)",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = [], rejectedSuggestions = []) {
            const staleIds = new Set();

            // Mapping of words to their correct LaTeX symbolic representation
            const SYMBOL_MAP = {
                "plus": "$+$",
                "minus": "$-$",
                "percent": "\\%",
                "equals": "$=$",
                "equal to": "$=$",
                "times": "$\\times$",
                "divided by": "$\\div$",
                "plus or minus": "$\\pm$",
                "less than": "$<$",
                "greater than": "$>$"
            };

            // Create a regex pattern from the map keys
            // Result: /\b(plus|minus|percent|equals|equal to|...)\b/gi
            const SYMBOL_PAT = new RegExp(`\\b(${Object.keys(SYMBOL_MAP).join('|')})\\b`, 'gi');

            // Locate tabular blocks
            const tabularPat = /\\begin\{tabular\}(?:\{[^}]*\})?([\s\S]*?)\\end\{tabular\}/gi;
            let tabMatch;

            while ((tabMatch = tabularPat.exec(texFile)) !== null) {
                const tabBody = tabMatch[1];
                const tabBodyStart = tabMatch.index + tabMatch[0].indexOf(tabBody);

                SYMBOL_PAT.lastIndex = 0; // Reset regex index for the new block
                let symMatch;

                while ((symMatch = SYMBOL_PAT.exec(tabBody)) !== null) {
                    const originalText = symMatch[0];
                    const suggestion = SYMBOL_MAP[originalText.toLowerCase()];
                    const absIndex = tabBodyStart + symMatch.index;

                    const position = getPositionFromIndex(texFile, absIndex, originalText.length);

                    // Standard Guard Clauses
                    if (isRejectedByLivePosition(position, this.name, originalText)) continue;

                    const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                    if (overlapping.length > 0) {
                        overlapping.forEach(old => staleIds.add(old.id));
                    } else {
                        if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                    }

                    // Create the Anchor/Suggestion
                    if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                        createAnchor(
                            session,
                            Range,
                            position,
                            originalText,
                            suggestion,
                            this.markerClass,
                            this.name,
                            `Mathematical symbols must not be written in full. Change "${originalText}" to "${suggestion}".`,
                            anchorlist
                        );
                    }
                }
            }
            return staleIds;
        }
    },
    figToPlural: {
        name: "Fig to Plural",
        description: "Convert figure ref to plural if more than one figure ref present.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const pattern = /\\figref\{([^}]*)\}/g;
            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const inside = match[1];
                const cleaned = inside.replace(/\s*,\s*/g, ',').replace(/\s*-\s*/g, '-');
                const parts = cleaned.split(',');

                let count = 0;
                parts.forEach(p => {
                    if (p.includes('-')) count += 2;
                    else count++;
                });

                if (count <= 1) continue;

                const updated = cleaned.replace(/^([fig|figure]*)/, '$1s');
                const suggestion = `\\figref{${updated}}`;

                if (fullMatch === suggestion) continue;

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                }

                createAnchor(session, Range, position,
                    fullMatch, suggestion,
                    this.markerClass, this.name, this.description, anchorlist);
            }

            return staleIds;
        }
    },

    // citeInFigure: {
    //     name: "Citation in Figure",
    //     description: "Citation present in figure but not anywhere else in the text.",
    //     markerClass: "ace-Common-highlight",

    //     execute(texFile, session, Range, anchorlist,
    //         fileName, Allfiles,
    //         existingSuggestions = [],
    //         rejectedSuggestions = []) {
    //         const staleIds = new Set();
    //         const figurePattern = /\\begin\{figure\}([\s\S]*?)\\end\{figure\}/g;
    //         const captionPattern = /\\caption\{((?:[^{}]*(?:\{(?:[^{}]*(?:\{(?:[^{}]*(?:\{[^{}]*\})*[^{}]*)*\})*[^{}]*)*\})*[^{}]*)*)\}/g;
    //         const citePattern = /\\cite\{([^}]*)\}/g;
    //         let figMatch;

    //         while ((figMatch = figurePattern.exec(texFile)) !== null) {
    //             const figFull = figMatch[0];
    //             const figStart = figMatch.index;
    //             let capMatch;

    //             captionPattern.lastIndex = 0;
    //             while ((capMatch = captionPattern.exec(figFull)) !== null) {
    //                 const capFull = capMatch[0];
    //                 const capContent = capMatch[1];
    //                 const capAbsIdx = figStart + figMatch[0].indexOf(capFull);

    //                 let citeM;
    //                 citePattern.lastIndex = 0;

    //                 while ((citeM = citePattern.exec(capContent)) !== null) {
    //                     const citeFull = citeM[0];
    //                     const keys = citeM[1].split(',').map(k => k.trim());

    //                     const hasSingleOccurrence = keys.some(k => {
    //                         const occurrences = (texFile.match(
    //                             new RegExp(`\\\\cite\\{[^}]*\\b${k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b[^}]*\\}`, 'g')
    //                         ) || []);
    //                         return occurrences.length === 1;
    //                     });

    //                     if (!hasSingleOccurrence) continue;

    //                     const citeAbsIdx = capAbsIdx +
    //                         capFull.indexOf(capContent) +
    //                         citeM.index;

    //                     const suggestion = `${citeFull} \\AQ{The reference is not cited in the text.}`;
    //                     const position = getPositionFromIndex(texFile, citeAbsIdx, citeFull.length);

    //                     if (isRejectedByLivePosition(position, this.name, citeFull)) continue;

    //                     const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
    //                     if (overlapping.length > 0) {
    //                         overlapping.forEach(old => staleIds.add(old.id));
    //                     } else {
    //                         if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
    //                     }

    //                     createAnchor(session, Range, position,
    //                         citeFull, suggestion,
    //                         this.markerClass, this.name,
    //                         'Citation in figure not cited in text',
    //                         anchorlist);
    //                 }
    //             }
    //         }

    //         return staleIds;
    //     }
    // },

    checkFigureForLegend: {
        name: "Figure Legend Check",
        description: "Checks whether the figure has a legend present in it.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            const staleIds = new Set();
            const figurePattern = /\\begin\{figure\}([\s\S]*?)\\end\{figure\}/g;
            let match;

            while ((match = figurePattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const hasCaption = /\\caption\{[\s\S]*?\}/.test(fullMatch);

                if (hasCaption) continue;

                // ── Anchor the \begin{figure} line as a query ──
                const firstNewline = fullMatch.indexOf('\n');
                const firstLine = firstNewline !== -1
                    ? fullMatch.slice(0, firstNewline)
                    : fullMatch;

                const position = getPositionFromIndex(texFile, match.index, firstLine.length);

                if (isRejectedByLivePosition(position, this.name, firstLine)) continue;

                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                }

                createAnchor(session, Range, position,
                    firstLine, firstLine,
                    this.markerClass, this.name,
                    'Legend (\\caption) missing in this figure',
                    anchorlist,
                    { queryOnly: true });
            }

            return staleIds;
        }
    },

    DecimalFormatting: {
        name: "Decimal Formatting",
        description: "Replace decimals like '.5' with '0.5'.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {

            const staleIds = new Set();

            // Initialize the reusable emitter
            const emit = makeAnchorEmitter({
                texFile,
                session,
                Range,
                anchorlist,
                existingSuggestions,
                staleIds,
                styleName: this.name,
                markerClass: this.markerClass,
            });

            // Logic: Match a '.' followed by digits, but ONLY if NOT preceded by another digit
            const decimalPattern = /(^|[^\w])(\.\d+)/g;
            let match;

            while ((match = decimalPattern.exec(texFile)) !== null) {
                // match[1] is the boundary (start of string or non-digit)
                // match[2] is the actual decimal part (e.g., ".5")
                const prefix = match[1];
                const decimalPart = match[2];

                const fullMatch = match[0];
                const suggestion = `${prefix}0${decimalPart}`;

                // We use the fullMatch and its index so that the boundary character 
                // is included in the highlight, ensuring the user sees exactly 
                // what is being modified.
                emit(
                    fullMatch,          // originalText 
                    suggestion,         // suggestionText
                    match.index,        // absIndex
                    this.description    // description for sidebar
                );
            }

            return staleIds;
        }
    },


    numberSentenceStart: {
        name: "numberSentenceStart",
        description: "Spell out numbers and units when they start a sentence.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = [], rejectedSuggestions = []) {
            const staleIds = new Set();

            const unitSpelling = {
                "kg": "kilograms", "m": "meters", "s": "seconds",
                "cm": "centimeters", "km": "kilometers", "g": "grams",
                "ml": "milliliters", "l": "liters"
            };

            const { segments } = buildStyleContext({
                texFile, session, Range, anchorlist, existingSuggestions, staleIds,
                styleName: this.name,
                markerClass: this.markerClass,
                scope: { wholeDocument: true },
                excludeMath: true,
                excludeComments: true
            });

            const pattern = /(?<=\.||^)\t*(\d+)\s+([a-z]+)/gi;

            for (const seg of segments) {
                let match;
                while ((match = pattern.exec(seg.text)) !== null) {
                    const numberPart = match[0];
                    const numValue = parseInt(match[1]);
                    const unitAbbr = match[2].toLowerCase();


                    const absoluteIndex = seg.startInFile + match.index;


                    const textBefore = texFile.substring(0, absoluteIndex).trim();


                    const isSentenceStart = textBefore.length === 0 ||
                        /[.?!]$/.test(textBefore) ||
                        texFile.substring(absoluteIndex - 2, absoluteIndex) === '\n\n';

                    if (isSentenceStart && unitSpelling[unitAbbr]) {

                        let spelledNumber = numberToWords(numValue);

                        spelledNumber = spelledNumber.charAt(0).toUpperCase() + spelledNumber.slice(1);

                        const spelledUnit = unitSpelling[unitAbbr];
                        const suggestionText = `${spelledNumber} ${spelledUnit}`;


                        seg.emit(
                            numberPart,
                            suggestionText,
                            match.index,
                            this.description
                        );
                    }
                }
            }

            return staleIds;
        }
    },

    // mathFunctionsRoman: {
    //     name: "Math Functions in Roman",
    //     description: "Remove \\textit{} around math functions (cos, sin, tan, etc.).",
    //     markerClass: "ace-Common-highlight",
    //     execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
    //         const staleIds = new Set();
    //         // 1. Define common math functions that should be Roman (not italic)
    //         const mathFunctions = ["cos", "sin", "tan", "exp", "log", "lim", "Tr", "det"];

    //         // 2. Target \textit{...} blocks
    //         const pattern = /\\textit\{([^}]*?)\}/g;
    //         pattern.lastIndex = 0; // Essential to prevent the 2-keystroke flicker

    //         let match;
    //         while ((match = pattern.exec(texFile)) !== null) {
    //             const content = match[1];
    //             const originalText = match[0];

    //             // 3. Precise Check: Does the content contain one of the math functions?
    //             // We check for word boundaries to avoid matching "cost" for "cos"
    //             const hasMathFunc = mathFunctions.some(func => {
    //                 const regex = new RegExp(`\\b${func}\\b`);
    //                 return regex.test(content);
    //             });

    //             if (hasMathFunc) {
    //                 const suggestionText = content;
    //                 const pos = getPositionFromIndex(texFile, match.index, originalText.length);

    //                 const position = {
    //                     startRow: pos.startRow,
    //                     startCol: pos.startCol,
    //                     endRow: pos.endRow,
    //                     endCol: pos.endCol,
    //                 };

    //                 // 4. Overlap Logic (The "Refresh" Strategy)
    //                 const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
    //                 if (overlapping.length > 0) {
    //                     // Mark old IDs as stale to trigger a fresh redraw of the dotted line
    //                     overlapping.forEach(old => staleIds.add(old.id));
    //                 } else {
    //                     // Check if already anchored or rejected
    //                     if (isAlreadyAnchored(position, this.name, existingSuggestions, originalText)) continue;
    //                     if (isRejectedByLivePosition(position, this.name, originalText)) continue;
    //                 }

    //                 // 5. Create/Renew Anchor
    //                 createAnchor(
    //                     session, Range, position,
    //                     originalText, suggestionText,
    //                     this.markerClass, this.name, this.description,
    //                     anchorlist
    //                 );
    //             }
    //         }
    //         return staleIds;
    //     }
    // },

    MathFunctions: {
        name: "Math Functions to Roman",
        description: "Ensure math functions like sin, cos, etc., are in Roman font (upright).",
        markerClass: "ace-Common-highlight",
        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = [], rejectedSuggestions = []) {
            const staleIds = new Set();
            const context = buildStyleContext({
                texFile, session, Range, anchorlist, existingSuggestions, staleIds,
                styleName: this.name,
                markerClass: this.markerClass,
                scope: { wholeDocument: true },
                excludeMath: false,
                onlyMath: true
            });
            const mathFunctions = ["cos", "sin", "tan", "exp", "log", "lim", "Tr", "det"];
            let possibilities = mathFunctions.join('|');

            const pattern = new RegExp(`\\\\(?:textit|mathit)\\s*\\{\\s*(\\\\(?:${possibilities})(?:\\s*|\\{|\\()[\\s\\S]*?)\\s*\\}`, 'gi');

            context.segments.forEach(seg => {
                let m;
                pattern.lastIndex = 0;
                while ((m = pattern.exec(seg.text)) !== null) {
                    console.log("it is working and it finding the tan two", m[0])
                    const fullMatch = m[0];
                    if (true) {
                        seg.emit(fullMatch, m[1], m.index, this.description);
                    }
                }
            });



            return staleIds;


        }
    },
    // ordinalNumbers: {
    //     name: "Ordinal Numbers Format",
    //     description: "Convert superscript or spaced ordinals (1^{st}, n th) to inline text (1st, nth).",
    //     markerClass: "ace-Common-highlight",
    //     beforeImage: "/images/description/OrdinalNumbersBefore.png",
    //     afterImage: "/images/description/OrdinalNumbersAfter.png",

    //     execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = [], rejectedSuggestions = []) {
    //         const staleIds = new Set();
    //         const aggressivePattern = /(\b\d+|(?<=\$)[a-zA-Z])(?:\$?\s*\^?\$?\s*|\\textsuperscript)\{?\s*(?:\\rm\s+|\\?text\{)?(st|nd|rd|th)\b(?:\s*\}?\}?\$?)/gi;

    //         let match;
    //         while ((match = aggressivePattern.exec(texFile)) !== null) {
    //             const fullMatch = match[0];
    //             const base = match[1];
    //             const suffix = match[2].toLowerCase();

    //             const suggestion = `${base}${suffix}`;

    //             if (fullMatch.trim() === suggestion) continue;

    //             const pos = getPositionFromIndex(texFile, match.index, fullMatch.length);

    //             if (isRejectedByLivePosition(pos, this.name, fullMatch)) continue;

    //             const overlapping = getOverlappingAnchors(pos, this.name, existingSuggestions);
    //             if (overlapping.length > 0) {
    //                 overlapping.forEach(old => staleIds.add(old.id));
    //             } else {
    //                 if (isAlreadyAnchored(pos, this.name, existingSuggestions)) continue;
    //             }

    //             if (typeof findCommandorNot === 'function' && findCommandorNot(pos.startRow, pos.startCol, texFile)) {
    //                 continue;
    //             }

    //             createAnchor(
    //                 session, Range, pos,
    //                 fullMatch, suggestion,
    //                 this.markerClass, this.name, this.description,
    //                 anchorlist
    //             );
    //         }
    //         return staleIds;
    //     }
    // },

    ordinalNumbers: {
        name: "Ordinal Numbers Format",
        description: "Convert superscript or spaced ordinals (1^{st}, n th) to inline text (1st, nth).",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = [], rejectedSuggestions = []) {
            const staleIds = new Set();
            const self = this;

            const { segments } = buildStyleContext({
                texFile, session, Range, anchorlist,
                existingSuggestions, staleIds,
                styleName: self.name,
                markerClass: self.markerClass,
                scope: { wholeDocument: true },
                excludeMath: false,
                excludeAllCommands: false,
                overlapMode: 'simple',
            });


            // const aggressivePattern = /(\b\d+|(?<=\$)[a-zA-Z])(?:\$?\s*\^?\$?\s*|\\textsuperscript)\{?\s*(?:\\rm\s+|\\?text\{)?(st|nd|rd|th)\b(?:\s*\}?\}?\$?)/gi;
            const aggressivePattern = /(\b\d+|(?<=\$)[a-zA-Z])(?:\s*\^?\s*|\\textsuperscript)\{?\s*(?:\\rm\s+|\\?text\{)?(st|nd|rd|th)\b(?:\s*\}?\s*\s*\}?)/gi;

            for (const seg of segments) {
                aggressivePattern.lastIndex = 0;
                let match;

                while ((match = aggressivePattern.exec(seg.text)) !== null) {
                    const fullMatch = match[0];
                    const base = match[1];
                    const suffix = match[2].toLowerCase();


                    const suggestion = `${base}${suffix}`;


                    if (fullMatch.trim() === suggestion) continue;

                    seg.emit(
                        fullMatch,
                        suggestion,
                        match.index,
                        self.description
                    );
                }
            }

            return staleIds;
        },
    },

    standardSpacing: {
        name: "Typesetting Spacing",
        description: "Ensures correct spacing for Degrees, Percentages, and Units.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            const staleIds = new Set();

            const { segments } = buildStyleContext({
                texFile,
                session,
                Range,
                anchorlist,
                existingSuggestions,
                staleIds,
                styleName: this.name,
                markerClass: this.markerClass,
                scope: { wholeDocument: true },
                excludeMath: true, // ── IGNORES $...$, \[...\] and math environments ──
                excludeInner: ['url', 'href', 'verb', 'cite', 'ref'],
                excludeEnvironments: ['verbatim', 'lstlisting'],
            });

            const rules = [
                // Pattern 1: Percentage (10% -> 10 %)
                { regex: /(\d)(%)/g, build: (g1, g2) => `${g1} ${g2}` },
                // Pattern 2: Degree (10° -> 10 °)
                { regex: /(\d)(°)/g, build: (g1, g2) => `${g1} ${g2}` },
                // Pattern 3: SI Units (10kg -> 10 kg)
                { regex: /(\d)(kg|mg|ml|km|cm|mm|ms|GeV|MeV)\b/g, build: (g1, g2) => `${g1} ${g2}` }
            ];

            for (const seg of segments) {
                rules.forEach(rule => {
                    rule.regex.lastIndex = 0;
                    let match;
                    while ((match = rule.regex.exec(seg.text)) !== null) {
                        const originalText = match[0];
                        const suggestionText = rule.build(match[1], match[2]);

                        // Use seg.emit to automatically handle the absolute index mapping
                        seg.emit(
                            originalText,
                            suggestionText,
                            match.index,
                            this.description
                        );
                    }
                });
            }

            return staleIds;
        }
    },

    latinPhrasesRoman: {
        name: "Latin Phrases in Roman",
        description: "Remove \\textit{} wrapper from Latin phrases (ad hoc, in situ, etc.).",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles,
            existingSuggestions = [], rejectedSuggestions = []) {

            const staleIds = new Set();

            const { segments } = buildStyleContext({
                texFile, session, Range, anchorlist,
                existingSuggestions, staleIds,
                styleName: this.name,
                markerClass: this.markerClass,
                scope: { wholeDocument: true },
                excludeMath: true,
                // Keep this false to "see" the \textit command
                excludeAllCommands: false,
                excludeOnlyEnvironments: ['thebibliography', 'table'],
            });

            const latinWords = [
                "ad hoc", "ad hominem", "a posteriori", "a priori", "bona fide",
                "de facto", "de jure", "et al.", "e.g.", "i.e.", "in situ",
                "in vitro", "in vivo", "per se", "status quo", "vice versa"
            ];

            const italicPattern = /\\textit\{([^}]*?)\}/g;

            for (const seg of segments) {
                // CRITICAL CHECK: 
                // If buildStyleContext is working, the bibliography text 
                // shouldn't even be in the 'segments' array.
                // But if your texFile has a malformed \begin{thebibliography}, 
                // it might leak through.

                italicPattern.lastIndex = 0;
                let match;

                while ((match = italicPattern.exec(seg.text)) !== null) {
                    const fullMatch = match[0];
                    const content = match[1];

                    const hasLatin = latinWords.some(phrase => {
                        const escapedPhrase = phrase.replace(/\./g, '\\.');
                        const regex = new RegExp(`\\b${escapedPhrase}\\b`, 'i');
                        return regex.test(content);
                    });

                    if (hasLatin) {
                        seg.emit(
                            fullMatch,
                            content,
                            match.index,
                            `Latin phrase "${content}" should be in Roman type, not italics.`
                        );
                    }
                }
            }
            return staleIds;
        }
    },

    FigureLegendFinding: {
        name: "missing figure legend",
        description: "checking for main figures without captions",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            const staleIds = new Set();

            // 1. Only match 'figure' (not subfigure)
            const figPattern = /\\begin\{figure\*?\}([\s\S]*?)\\end\{figure\*?\}/gi;
            let match;

            while ((match = figPattern.exec(texFile)) !== null) {
                if (isCommented(texFile, match.index)) continue;

                const content = match[1]; // The inner content of the figure

                // 2. Remove nested subfigures so their captions don't count for the parent
                const cleanedContent = content.replace(/\\begin\{subfigure\*?\}([\s\S]*?)\\end\{subfigure\*?\}/gi, "");

                // 3. Check for the caption in the remaining content
                const hasCaption = /\\caption\s*\{/.test(cleanedContent);

                if (!hasCaption) {
                    const position = getPositionFromIndex(texFile, match.index, match[0].length);

                    if (isRejectedByLivePosition(position, this.name, match[0])) continue;
                    const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);

                    if (overlapping.length > 0) {
                        overlapping.forEach(old => staleIds.add(old.id));
                    } else {
                        if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                    }

                    const prevline = position.startRow > 0 ? session.getLine(position.startRow - 1) || "" : "";
                    if (!prevline.trim().startsWith("\\AQ{")) {
                        anchorlist.push({
                            id: `${this.name}__${crypto.randomUUID()}`,
                            startAnchor: session.doc.createAnchor(position.startRow, position.startCol),
                            endAnchor: session.doc.createAnchor(position.endRow, position.endCol),
                            markerId: null,
                            originalText: match[0].split('\n')[0],
                            suggestionText: null,
                            queryOnly: true,
                            styleInfo: {
                                name: this.name,
                                description: `This figure environment is missing a legend (caption).`
                            }
                        });
                    }
                }
            }
            return staleIds;
        }
    },

    SubFigureCaptionMissing: {
        name: "missing subfigure legend",
        description: "checking for subfigures without captions",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = []) {
            const staleIds = new Set();

            // 1. Regex to match only subfigure or subfigure* environments
            const subfigPattern = /\\begin\{subfigure\*?\}([\s\S]*?)\\end\{subfigure\*?\}/gi;
            let match;

            while ((match = subfigPattern.exec(texFile)) !== null) {
                // Skip if the block is commented out
                if (isCommented(texFile, match.index)) continue;

                const content = match[1]; // The inner content of the subfigure

                // 2. Check if \caption{...} exists inside this specific subfigure
                const hasCaption = /\\caption\s*\{/.test(content);

                if (!hasCaption) {
                    // Determine the row/col position in the Ace Editor
                    const position = getPositionFromIndex(texFile, match.index, match[0].length);

                    // 3. Framework Safety Checks (Overlap & Rejection)
                    if (isRejectedByLivePosition(position, this.name, match[0])) continue;
                    const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);

                    if (overlapping.length > 0) {
                        overlapping.forEach(old => staleIds.add(old.id));
                    } else {
                        if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                    }

                    // 4. Existing Query Check
                    // This checks the line immediately above \begin{subfigure}
                    const prevline = position.startRow > 0 ? session.getLine(position.startRow - 1) || "" : "";

                    if (!prevline.trim().startsWith("\\AQ{")) {
                        anchorlist.push({
                            id: `${this.name}__${crypto.randomUUID()}`,
                            startAnchor: session.doc.createAnchor(position.startRow, position.startCol),
                            endAnchor: session.doc.createAnchor(position.endRow, position.endCol),
                            markerId: null,
                            // This shows the \begin{subfigure} line in your React sidebar
                            originalText: match[0].split('\n')[0],
                            suggestionText: null,
                            queryOnly: true,
                            styleInfo: {
                                name: this.name,
                                description: `This subfigure is missing a legend (caption).`
                            }
                        });
                    }
                }
            }
            return staleIds;
        }
    },
    unusedCite: eplStyles.UnusedCiteFinding,

    UnusedLabelsFinding: {
        name: "Unused Labels",
        description: "Finding \\label{} inside tables and figures that have no matching \\ref or \\weblink",
        markerClass: "ace-Common-highlight",
        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = [], rejectedSuggestions = []) {
            const staleIds = new Set();
            const self = this;

            // ── STEP 1: CLEAN SWEEP ───────────────────────────────────────────────
            existingSuggestions.forEach(s => {
                if (s.styleInfo?.name === self.name) staleIds.add(s.id);
            });

            // ── STEP 2: Build context for the query emitter ───────────────────────
            const ctx = buildStyleContext({
                texFile, session, Range, anchorlist, existingSuggestions, staleIds,
                styleName: self.name,
                markerClass: self.markerClass,
                scope: {},
                excludeMath: false,
                mode: 'query',
                overlapMode: 'refresh',
            });

            // ── STEP 3: Collect ALL \ref, \eqref, and \weblink keys from document ─
            const usedRefs = new Set();
            // Regex matches \ref{key}, \eqref{key}, OR \weblink{Text}{key}
            const refPat = /\\(?:ref|eqref)\{([^}]*)\}|\\weblink\{[^}]*\}\{([^}]*)\}/g;
            let m;
            while ((m = refPat.exec(texFile)) !== null) {
                if (isCommented(texFile, m.index)) continue;
                // m[1] contains \ref keys, m[2] contains \weblink keys
                const matchKeys = m[1] || m[2];
                matchKeys.split(',').forEach(k => usedRefs.add(k.trim()));
            }

            // ── STEP 4: Scan \label{} inside table and figure environments ─────────
            const envPat = /\\begin\{(table|figure|equation)\*?\}([\s\S]*?)\\end\{(table|figure|equation)\*?\}/gi;
            while ((m = envPat.exec(texFile)) !== null) {
                if (isCommented(texFile, m.index)) continue;
                const envBody = m[2];
                const envBodyAbs = m.index + m[0].indexOf(m[2]);
                const envName = m[1].toLowerCase();

                const labelPat = /\\label\{([^}]*)\}/g;
                let lm;
                while ((lm = labelPat.exec(envBody)) !== null) {
                    const absIndex = envBodyAbs + lm.index;
                    if (isCommented(texFile, absIndex)) continue;

                    const key = lm[1].trim();
                    const fullMatch = lm[0];

                    if (usedRefs.has(key)) {
                        continue;
                    }

                    let customizedQuery = `Label "${key}" inside ${envName} has no matching \\ref`;
                    if (envName.includes("figure")) {
                        customizedQuery = `Figure ${key} was not cited in the text, we have inserted the citation in the text. Please check.`;
                    } else if (envName.includes("table")) {
                        customizedQuery = `Table ${key} was not cited in the text, we have inserted the citation in the text. Please check.`;
                    }

                    ctx.emitQuery(
                        fullMatch,
                        `label "${key}" is never cited — add \\ref{${key}} or \\weblink{...}{${key}} somewhere or remove this label`,
                        absIndex,
                        customizedQuery
                    );
                }
            }

            return staleIds;
        },
    },
    UnusedReferenceFinding: {
        name: "Unused References",
        description: "Finding \\ref{} or \\weblink{} that have no matching \\label anywhere",
        markerClass: "ace-Common-highlight",
        execute(texFile, session, Range, anchorlist, fileName, Allfiles, existingSuggestions = [], rejectedSuggestions = []) {
            const staleIds = new Set();
            const self = this;

            // ── STEP 1: CLEAN SWEEP ───────────────────────────────────────────────
            existingSuggestions.forEach(s => {
                if (s.styleInfo?.name === self.name) staleIds.add(s.id);
            });

            // ── STEP 2: Build context ─────────────────────────────────────────────
            const ctx = buildStyleContext({
                texFile, session, Range, anchorlist, existingSuggestions, staleIds,
                styleName: self.name,
                markerClass: self.markerClass,
                scope: { wholeDocument: true },
                excludeMath: false,
                mode: 'query',
                overlapMode: 'refresh',
            });

            // ── STEP 3: Collect ALL \label keys from the ENTIRE file ──────────────
            const definedLabels = new Set();
            const labelPat = /\\label\{([^}]*)\}/g;
            let m;
            while ((m = labelPat.exec(texFile)) !== null) {
                if (isCommented(texFile, m.index)) continue;
                m[1].split(',').forEach(k => definedLabels.add(k.trim()));
            }

            // ── STEP 4: Scan \ref{}, \eqref{}, and \weblink{}{} in the doc body ───
            const refPat = /\\(?:ref|eqref)\{([^}]*)\}|\\weblink\{[^}]*\}\{([^}]*)\}/g;
            for (const seg of ctx.segments) {
                refPat.lastIndex = 0;
                while ((m = refPat.exec(seg.text)) !== null) {
                    const absIndex = seg.absStart + m.index;
                    if (isCommented(texFile, absIndex)) continue;

                    // Extract key from either \ref (m[1]) or \weblink (m[2])
                    const keyMatch = m[1] || m[2];
                    const key = keyMatch.trim();
                    const fullMatch = m[0];

                    if (definedLabels.has(key)) {
                        continue;
                    }

                    // Predict reference type using common prefixes
                    let refType = "generic";
                    if (/^(fig|figure):/i.test(key)) {
                        refType = "figure";
                    } else if (/^(tab|table):/i.test(key)) {
                        refType = "table";
                    }

                    let customizedQuery = `Reference [${key}] is not cited in the text. Kindly check and provide the appropriate citation.`;
                    if (refType === "figure") {
                        customizedQuery = `Figure ${key} is cited in the text; the corresponding image and caption are not provided. Kindly supply the required figure details.`;
                    } else if (refType === "table") {
                        customizedQuery = `Table ${key} is cited in the text; the corresponding table and caption are not provided. Kindly supply the required table details.`;
                    }

                    ctx.emitQuery(
                        fullMatch,
                        `reference "${key}" has no matching \\label{${key}} — add the label or fix the key`,
                        absIndex,
                        customizedQuery
                    );
                }
            }
            return staleIds;
        },
    },
    FigureRef: eplStyles.FigureRef,
    UnusedbibFinding: eplStyles.UnusedBibitemFinding,

    FigureCaptionCheck: {
        name: "Figure Caption Position",
        description: "Caption must appear BELOW the image. Anchors any \\caption that appears before \\includegraphics inside \\begin{figure} or \\begin{subfigure}.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles,
            existingSuggestions = [], rejectedSuggestions = []) {

            const staleIds = new Set();
            const self = this;

            const emit = makeAnchorEmitter({
                texFile, session, Range, anchorlist,
                existingSuggestions, staleIds,
                styleName: self.name,
                markerClass: self.markerClass,
                overlapMode: 'simple',
            });

            // ── Helpers ───────────────────────────────────────────────────────────
            function isCommented(index) {
                let s = index;
                while (s > 0 && texFile[s - 1] !== '\n') s--;
                for (let i = s; i < index; i++)
                    if (texFile[i] === '%' && (i === 0 || texFile[i - 1] !== '\\')) return true;
                return false;
            }

            function extractBraced(text, openBraceIdx) {
                let depth = 1, i = openBraceIdx + 1, content = '';
                while (i < text.length && depth > 0) {
                    if (text[i] === '{') depth++;
                    else if (text[i] === '}') { depth--; if (depth === 0) break; }
                    content += text[i]; i++;
                }
                return { content, closeIdx: i };
            }

            function extractCaption(text, startIdx) {
                const km = /\\caption\s*\*?\s*\{/.exec(text.slice(startIdx));
                if (!km) return null;
                const braceOpenIdx = startIdx + km.index + km[0].length - 1;
                const { content, closeIdx } = extractBraced(text, braceOpenIdx);
                return {
                    fullText: text.slice(startIdx + km.index, closeIdx + 1),
                    content,
                    localStart: startIdx + km.index,
                    localEnd: closeIdx,
                };
            }

            // ── Check if caption is BEFORE image in a block ───────────────────────
            function checkCaptionPosition(blockText, blockAbsStart) {
                const captionIdx = blockText.search(/\\caption\s*\*?\s*\{/);
                const includeIdx = blockText.search(/\\includegraphics/);

                if (captionIdx === -1 || includeIdx === -1) return;
                if (captionIdx >= includeIdx) return; // already correct

                const cap = extractCaption(blockText, captionIdx);
                if (!cap) return;

                const absIndex = blockAbsStart + cap.localStart;
                if (isCommented(absIndex)) return;

                emit(
                    cap.fullText,
                    '',          // SuggestionAction removes caption here and re-inserts after image
                    absIndex,
                    `\\caption appears BEFORE \\includegraphics — move it below the image`,
                    { isCaptionMove: true, captionText: cap.fullText }
                );
            }

            // ── Scan all \begin{figure} blocks ────────────────────────────────────
            const figurePat = /\\begin\{figure\*?\}([\s\S]*?)\\end\{figure\*?\}/gi;
            let figMatch;

            while ((figMatch = figurePat.exec(texFile)) !== null) {
                if (isCommented(figMatch.index)) continue;

                const figBody = figMatch[1];
                const figBodyStart = figMatch.index + figMatch[0].indexOf(figBody);

                // Check each \begin{subfigure} first
                const subfigPat = /\\begin\{subfigure\}(?:\[[^\]]*\])?\s*\{[^}]*\}([\s\S]*?)\\end\{subfigure\}/gi;
                let sfMatch;
                while ((sfMatch = subfigPat.exec(figBody)) !== null) {
                    if (isCommented(figBodyStart + sfMatch.index)) continue;
                    const sfBody = sfMatch[1];
                    const sfBodyStart = figBodyStart + sfMatch.index + sfMatch[0].indexOf(sfBody);
                    checkCaptionPosition(sfBody, sfBodyStart);
                }

                // Check top-level \caption in the figure body
                const captionPat = /\\caption\s*\*?\s*\{/g;
                let capM;
                while ((capM = captionPat.exec(figBody)) !== null) {
                    // Skip if inside a subfigure
                    const before = figBody.slice(0, capM.index);
                    const openSubs = (before.match(/\\begin\{subfigure\}/gi) || []).length;
                    const closeSubs = (before.match(/\\end\{subfigure\}/gi) || []).length;
                    if (openSubs !== closeSubs) continue;

                    if (isCommented(figBodyStart + capM.index)) continue;

                    const cap = extractCaption(figBody, capM.index);
                    if (!cap) continue;

                    // Check if any top-level \includegraphics comes BEFORE this caption
                    const incPat = /\\includegraphics/g;
                    let incM, hasIncBefore = false;
                    incPat.lastIndex = 0;
                    while ((incM = incPat.exec(figBody)) !== null) {
                        if (incM.index >= cap.localStart) break;
                        const incBefore = figBody.slice(0, incM.index);
                        const incOpenSubs = (incBefore.match(/\\begin\{subfigure\}/gi) || []).length;
                        const incCloseSubs = (incBefore.match(/\\end\{subfigure\}/gi) || []).length;
                        if (incOpenSubs === incCloseSubs) { hasIncBefore = true; break; }
                    }
                    if (hasIncBefore) continue; // caption is already below an image

                    // Find the FIRST top-level \includegraphics AFTER this caption
                    let firstTopLevelInc = null;
                    incPat.lastIndex = cap.localEnd;
                    while ((incM = incPat.exec(figBody)) !== null) {
                        const incBefore = figBody.slice(0, incM.index);
                        const incOpenSubs = (incBefore.match(/\\begin\{subfigure\}/gi) || []).length;
                        const incCloseSubs = (incBefore.match(/\\end\{subfigure\}/gi) || []).length;
                        if (incOpenSubs === incCloseSubs) { firstTopLevelInc = incM; break; }
                    }
                    if (!firstTopLevelInc) continue;

                    emit(
                        cap.fullText,
                        '',
                        figBodyStart + cap.localStart,
                        `\\caption appears BEFORE \\includegraphics in figure — move it below the image`,
                        { isCaptionMove: true, captionText: cap.fullText }
                    );
                    break; // one main caption per figure
                }
            }

            return staleIds;
        },
    },

    // ProbabilityPTextMode: {
    //     name: "Probability p — italic in text mode",
    //     description: "\\textbf{p}, {\\bf p}, \\rm{p}, \\rm p, \\textrm{p} → \\textit{p} in document text, or \\emph{p} inside equation environments. Skipped inside figure, table, theorem etc.",
    //     markerClass: "ace-Common-highlight",

    //     execute(texFile, session, Range, anchorlist, fileName, Allfiles,
    //         existingSuggestions = [], rejectedSuggestions = []) {

    //         const staleIds = new Set();
    //         const self = this;

    //         // ── Environment sets ──────────────────────────────────────────────────
    //         // Matches inside these → suggest \emph{p}
    //         const EQUATION_ENVS = new Set([
    //             'equation', 'equation*',
    //             'align', 'align*',
    //             'eqnarray', 'eqnarray*',
    //             'math', 'displaymath',
    //             'multline', 'multline*',
    //             'gather', 'gather*',
    //         ]);

    //         // Matches inside these → skip entirely (no suggestion)
    //         const SKIP_ENVS = new Set([
    //             'figure', 'figure*',
    //             'table', 'table*',
    //             'theorem', 'lemma',
    //             'proof', 'corollary',
    //             'proposition', 'definition',
    //             'remark', 'example',
    //             'algorithm', 'algorithmic',
    //         ]);

    //         // ── Environment stack builder ─────────────────────────────────────────
    //         // Returns the ordered list of \begin{env} environments that are OPEN
    //         // at absolute character index `idx` in `texFile`.
    //         function getEnvStackAt(idx) {
    //             const stack = [];
    //             const envPat = /\\(begin|end)\s*\{([^}]+)\}/g;
    //             let m;
    //             while ((m = envPat.exec(texFile)) !== null) {
    //                 if (m.index >= idx) break;
    //                 const env = m[2].trim();
    //                 if (m[1] === 'begin') {
    //                     stack.push(env);
    //                 } else {
    //                     // Pop the innermost matching open env
    //                     const last = stack.lastIndexOf(env);
    //                     if (last !== -1) stack.splice(last, 1);
    //                 }
    //             }
    //             return stack;
    //         }

    //         // ── Comment guard ─────────────────────────────────────────────────────
    //         function isCommented(index) {
    //             let s = index;
    //             while (s > 0 && texFile[s - 1] !== '\n') s--;
    //             for (let i = s; i < index; i++)
    //                 if (texFile[i] === '%' && (i === 0 || texFile[i - 1] !== '\\')) return true;
    //             return false;
    //         }

    //         // ── Suggestion selector ───────────────────────────────────────────────
    //         // Returns the correct replacement string based on environment context,
    //         // or null if the match should be skipped.
    //         function getSuggestion(letter, envStack) {
    //             const inEquation = envStack.some(e => EQUATION_ENVS.has(e));
    //             const inSkip = envStack.some(e => SKIP_ENVS.has(e));

    //             if (inSkip) return null;                    // no suggestion in these envs
    //             if (inEquation) return `\\emph{${letter}}`;    // inside equation → \emph{p}
    //             return `\\textit{${letter}}`;                   // plain document text → \textit{p}
    //         }

    //         // ── Unified pattern covering all 3 forms ──────────────────────────────
    //         //
    //         // Form 1: \textbf{p}  \textrm{p}  \mathrm{p}  \mbox{p}  \text{p}  \rm{p}
    //         //         Regex group 1 captures the letter.
    //         //
    //         // Form 2: {\bf p}  {\rm p}
    //         //         Brace-declaration style. Group 2 captures the letter.
    //         //
    //         // Form 3: \rm p  \bf p
    //         //         Bare declaration + space + letter (no braces).
    //         //         Group 3 captures the letter.
    //         //         Negative lookahead (?![a-zA-Z]) prevents matching \rm problem etc.
    //         //
    //         // NOT matched (excluded by design):
    //         //   \textit{p}   already italic — no change needed
    //         //   \emph{p}     already emph   — no change needed
    //         //   \textbf{pc}  p is not alone inside braces
    //         //   \textbf{x}   not p or P
    //         //
    //         const PROB_P_PAT = /(?:(?:\\(?:textbf|textrm|mathrm|mbox|text|rm)\s*\{([pP])\})|(?:\{\\(?:bf|rm)\s+([pP])\})|(?:\\(?:bf|rm)\s+([pP])(?![a-zA-Z])))/g;

    //         let match;
    //         while ((match = PROB_P_PAT.exec(texFile)) !== null) {
    //             if (isCommented(match.index)) continue;

    //             // Extract the letter (p or P) from whichever group matched
    //             const letter = match[1] || match[2] || match[3];
    //             const originalText = match[0];
    //             const absIndex = match.index;

    //             // Get environment context at this position
    //             const envStack = getEnvStackAt(absIndex);
    //             const suggestion = getSuggestion(letter, envStack);

    //             // Skip: wrong environment (figure, table, theorem, etc.)
    //             if (suggestion === null) continue;

    //             // Skip: would produce no change (already correct)
    //             if (originalText === suggestion) continue;

    //             // ── Anchor emission ───────────────────────────────────────────────
    //             const position = getPositionFromIndex(texFile, absIndex, originalText.length);

    //             if (isRejectedByLivePosition(position, self.name, originalText)) continue;

    //             const overlapping = getOverlappingAnchors(position, self.name, existingSuggestions);
    //             if (overlapping.length > 0) {
    //                 overlapping.forEach(old => staleIds.add(old.id));
    //             } else {
    //                 if (isAlreadyAnchored(position, self.name, existingSuggestions)) continue;
    //             }

    //             if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
    //                 createAnchor(
    //                     session, Range, position,
    //                     originalText, suggestion,
    //                     self.markerClass, self.name,
    //                     `"${originalText}" should be "${suggestion}" — probability p must be italic`,
    //                     anchorlist
    //                 );
    //             }
    //         }

    //         return staleIds;
    //     }
    // },
    ProbabilityPTextMode: {
        name: "Probability p — italic in text mode",
        description: "\\textbf{p}, {\\bf p}, \\rm{p}, \\rm p, \\textrm{p} → \\textit{p} in document text, or \\emph{p} inside equation environments. Only flags when followed by a probability operator (=, <, >, ≥, ≤).",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles,
            existingSuggestions = [], rejectedSuggestions = []) {

            const staleIds = new Set();
            const self = this;

            const { segments } = buildStyleContext({
                texFile, session, Range, anchorlist,
                existingSuggestions, staleIds,
                styleName: self.name,
                markerClass: self.markerClass,

                scope: { wholeDocument: true },
                excludeMath: false,          // scan inside equation/align too
                overlapMode: 'simple',

                // ── Skip these environments entirely ──────────────────────────────
                excludeEnvironments: [
                    'figure', 'figure*',
                    'table', 'table*',
                    'theorem', 'lemma', 'proof',
                    'corollary', 'proposition',
                    'definition', 'remark', 'example',
                    'algorithm', 'algorithmic',
                ],

                // ── Already-correct commands: skip their content ──────────────────
                excludeInner: ['textit', 'emph'],
            });

            // ── Equation environment set ──────────────────────────────────────────
            // Used in getEnvStackAt to decide \emph vs \textit.
            const EQUATION_ENVS = new Set([
                'equation', 'equation*',
                'align', 'align*',
                'eqnarray', 'eqnarray*',
                'math', 'displaymath',
                'multline', 'multline*',
                'gather', 'gather*',
            ]);

            // ── Environment stack at absolute position ────────────────────────────
            // Scans \begin/\end commands up to `idx` to build the live env stack.
            // This tells us whether the match is inside equation, align, etc.
            function getEnvStackAt(idx) {
                const stack = [];
                const envPat = /\\(begin|end)\s*\{([^}]+)\}/g;
                let m;
                while ((m = envPat.exec(texFile)) !== null) {
                    if (m.index >= idx) break;
                    const env = m[2].trim();
                    if (m[1] === 'begin') {
                        stack.push(env);
                    } else {
                        const last = stack.lastIndexOf(env);
                        if (last !== -1) stack.splice(last, 1);
                    }
                }
                return stack;
            }

            // ── Probability operator lookahead ────────────────────────────────────
            // A match is only flagged when it is immediately followed (allowing
            // optional whitespace) by one of these probability operators:
            //   =   <   >   ≥   ≤   \leq   \geq
            //
            // This implements the requirement:
            //   "Restrict checks to patterns like: P=, p<, p>, p≥, p≤"
            //   "Ignore occurrences NOT followed by a probability operator"
            //
            // e.g. \textbf{p} = 0.05  → flag ✓
            //      \textbf{p} value    → skip  (no operator)
            //      $p > 0$             → skip  (bare p in math, not a text command)
            const PROB_OP = /^\s*(?:=|<|>|≥|≤|\\leq\b|\\geq\b)/;

            // ── Unified pattern: all text-mode command forms wrapping p or P ──────
            //
            // Form 1: \textbf{p}  \textrm{p}  \mathrm{p}  \mbox{p}  \text{p}  \rm{p}
            //   → group 1 captures the letter
            //
            // Form 2: {\bf p}  {\rm p}   (brace-group declaration style)
            //   → group 2 captures the letter
            //
            // Form 3: \rm p  \bf p       (bare command + space, no braces)
            //   → group 3 captures the letter
            //   → (?![a-zA-Z]) prevents matching \rm problem, \rm page etc.
            //
            // NOT matched:
            //   \textit{p}   already italic — excluded by pattern design
            //   \emph{p}     already emph   — excluded by pattern design
            //   \textbf{pc}  p not alone    — excluded by pattern design
            //   $p > 0$      bare p in math — no text command → not matched
            const PROB_P_PAT = /(?:(?:\\(?:textbf|textrm|mathrm|mbox|text|rm)\s*\{([pP])\})|(?:\{\\(?:bf|rm)\s+([pP])\})|(?:\\(?:bf|rm)\s+([pP])(?![a-zA-Z])))/g;

            // ── Main scan ─────────────────────────────────────────────────────────
            for (const seg of segments) {
                PROB_P_PAT.lastIndex = 0;
                let match;

                while ((match = PROB_P_PAT.exec(seg.text)) !== null) {
                    const letter = match[1] || match[2] || match[3];
                    const originalText = match[0];
                    const localOffset = match.index;
                    const absIndex = seg.absStart + localOffset;

                    // ── Gate: must be followed by a probability operator ───────────
                    // Look at what immediately follows in the SEGMENT text.
                    // This is the primary new requirement: only p=, p<, p>, p≥, p≤
                    const textAfter = seg.text.slice(localOffset + originalText.length);
                    if (!PROB_OP.test(textAfter)) continue;

                    // ── Determine suggestion based on environment ─────────────────
                    // getEnvStackAt uses the ABSOLUTE index in the full texFile
                    // to correctly resolve nested environments.
                    const envStack = getEnvStackAt(absIndex);
                    const inEquation = envStack.some(e => EQUATION_ENVS.has(e));

                    // In equation env → \emph{p} (math italic)
                    // In plain text   → \textit{p}
                    const suggestion = inEquation
                        ? `\\emph{${letter}}`
                        : `\\textit{${letter}}`;

                    // Skip if already correct (shouldn't happen due to PROB_P_PAT exclusions,
                    // but guard anyway)
                    if (originalText === suggestion) continue;

                    // ── Emit using the segment helper ─────────────────────────────
                    // seg.emit handles: absIndex = seg.absStart + localOffset,
                    // getPositionFromIndex, isRejectedByLivePosition, overlap checks,
                    // isAlreadyAnchored, findCommandorNot, and createAnchor.
                    seg.emit(
                        originalText,
                        suggestion,
                        localOffset,
                        `"${originalText}" should be "${suggestion}" — probability p must be italic`,
                    );
                }
            }

            return staleIds;
        },
    },

    tableUnits: {
        name: "Table Units",
        description: "Recurrent units should be inserted between brackets in corresponding colhead.",
        markerClass: "ace-Common-highlight",

        execute(texFile, session, Range, anchorlist, fileName, Allfiles,
            existingSuggestions = [], rejectedSuggestions = []) {

            function findCellInRow(texFile, tabularStart, rawRow, colIdx, cellContent) {
                const rowIdx = texFile.indexOf(rawRow, tabularStart);
                if (rowIdx === -1) return -1;
                let remaining = rawRow;
                let offset = 0;
                for (let i = 0; i < colIdx; i++) {
                    const ampIdx = remaining.indexOf('&');
                    if (ampIdx === -1) return -1;
                    offset += ampIdx + 1;
                    remaining = remaining.slice(ampIdx + 1);
                }
                const cellIdx = remaining.indexOf(cellContent.trim());
                if (cellIdx === -1) return -1;
                return rowIdx + offset + cellIdx;
            }

            function escapeRegex(s) {
                return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            }

            const KNOWN_UNITS = new Set([
                'nm', 'mm', 'cm', 'm', 'km',
                'mg', 'g', 'kg',
                'ms', 's', 'min', 'h',
                'ml', 'l', 'L',
                'Pa', 'kPa', 'MPa', 'GPa',
                'N', 'kN', 'MN',
                'Hz', 'kHz', 'MHz', 'GHz',
                'eV', 'keV', 'MeV',
                'K', 'C', 'F',
                'mol', 'mmol',
                'mM', 'nM', 'pM', 'uM',
                'rpm', 'rad',
                'mu', 'mum',
                'deg', 'wt', 'vol',
                'ppm', 'ppb',
            ]);

            function extractUnit(cellText) {
                console.log("the data coming to extractUnit is:", cellText);
                const stripped = cellText
                    .replace(/\\text[a-z]*\{([^}]*)\}/g, '$1')
                    .replace(/\$([^$]*)\$/g, '$1')
                    .trim();
                const m = /^-?[\d.,]+\s*([a-zA-Z\u03BC\/]+)$/.exec(stripped);
                if (m) {
                    const unit = m[1].trim();
                    if (KNOWN_UNITS.has(unit)) return unit;
                }
                const mathM = /\\(?:mathrm|text|textrm)\{([^}]+)\}/.exec(stripped);
                if (mathM && KNOWN_UNITS.has(mathM[1].trim())) return mathM[1].trim();
                return null;
            }

            function stripUnit(cellText, unit) {
                return cellText
                    .replace(new RegExp(`\\s*\\\\?${escapeRegex(unit)}\\b`, 'g'), '')
                    .replace(/\\(?:mathrm|text|textrm)\{[^}]+\}/g, (m) => {
                        const inner = /\{([^}]+)\}/.exec(m)?.[1] || '';
                        return KNOWN_UNITS.has(inner.trim()) ? '' : m;
                    })
                    .trim();
            }


            const staleIds = new Set();
            existingSuggestions.forEach(s => {
                if (s.styleInfo?.name === this.name) staleIds.add(s.id);
            });

            const emit = makeAnchorEmitter({
                texFile, session, Range, anchorlist,
                existingSuggestions, staleIds,
                styleName: this.name,
                markerClass: this.markerClass,

            });

            const tabularPat = /\\begin\{tabular\}([\s\S]*?)\\end\{tabular\}/g;
            let tabMatch;

            while ((tabMatch = tabularPat.exec(texFile)) !== null) {
                if (isCommented(texFile, tabMatch.index)) continue;

                const tabularContent = tabMatch[1];
                const tabularStart = tabMatch.index + '\\begin{tabular}'.length;

                const rawRows = tabularContent.split(/\\\\/);

                const parsedRows = rawRows.map((row, rowIdx) => {
                    const cleaned = row
                        .replace(/\\hline|\\midrule|\\toprule|\\bottomrule|\\cline\{[^}]*\}/g, '')
                        .replace(/%[^\n]*/g, '')
                        .trim();
                    console.log("the cleaned row is :", cleaned);
                    const cells = cleaned.split('&').map(c => c.trim());
                    return { cells, rawRow: row, rowIdx };
                }).filter(r => r.cells.some(c => c.length > 0));

                if (parsedRows.length < 2) continue;

                const headerRow = parsedRows[0];
                const dataRows = parsedRows.slice(1);
                const numCols = headerRow.cells.length;
                console.log("the numCols is:", numCols);

                for (let colIdx = 0; colIdx < numCols; colIdx++) {
                    const headerCell = headerRow.cells[colIdx];

                    if (/\([^)]+\)/.test(headerCell)) continue;

                    const colUnits = dataRows.map(r => extractUnit(r.cells[colIdx] || ''));
                    console.log("the colUnits are", colUnits);
                    const firstUnit = colUnits[0];
                    if (!firstUnit) continue;
                    if (!colUnits.every(u => u === firstUnit)) continue;

                    const newHeader = `${headerCell} (${firstUnit})`;

                    const headerCellIdx = findCellInRow(texFile, tabularStart, headerRow.rawRow, colIdx, headerCell);
                    if (headerCellIdx === -1) continue;

                    // ── single shared emit used here ──────────────────────────
                    emit(
                        headerCell,
                        newHeader,
                        headerCellIdx,
                        this.description,
                        {
                            removeType: 'tableUnitGroup',
                            unit: firstUnit,
                            colIdx,
                            dataRows: dataRows.map(r => {
                                const cell = r.cells[colIdx] || '';
                                const cellIdx = findCellInRow(texFile, tabularStart, r.rawRow, colIdx, cell);
                                return {
                                    original: cell,
                                    replacement: stripUnit(cell, firstUnit),
                                    absIndex: cellIdx,
                                };
                            }).filter(d => d.absIndex !== -1),
                        }
                    );
                }
            }

            return staleIds;
        }
    },


}